export interface RenderTree {
  id: string;
  name: string;
  children?: RenderTree[];
}

export const data: RenderTree = {
  id: "root",
  name: "Select All",
  children: [
    {
      children: [
        {
          id: "7926^^Behavioral Sciences|Behavioral Sciences,7924^^Behavioral Sciences|Behavioral Sciences,7921^^Behavioral Sciences|Behavioral Sciences,7917^^Behavioral Sciences|Behavioral Sciences,7915^^Behavioral Sciences|Behavioral Sciences,7912^^Behavioral Sciences|Behavioral Sciences,7909^^Behavioral Sciences|Behavioral Sciences,9096^^Behavioral Sciences|Behavioral Sciences,9090^^Behavioral Sciences|Behavioral Sciences,8270^^Behavioral Sciences|Behavioral Sciences,8261^^Behavioral Sciences|Behavioral Sciences,7906^^Behavioral Sciences|Behavioral Sciences,8256^^Behavioral Sciences|Behavioral Sciences,8248^^Behavioral Sciences|Behavioral Sciences,8245^^Behavioral Sciences|Behavioral Sciences,8229^^Behavioral Sciences|Behavioral Sciences,8219^^Behavioral Sciences|Behavioral Sciences,8209^^Behavioral Sciences|Behavioral Sciences,8204^^Behavioral Sciences|Behavioral Sciences,8200^^Behavioral Sciences|Behavioral Sciences,8198^^Behavioral Sciences|Behavioral Sciences,8185^^Behavioral Sciences|Behavioral Sciences,7903^^Behavioral Sciences|Behavioral Sciences,8180^^Behavioral Sciences|Behavioral Sciences,8175^^Behavioral Sciences|Behavioral Sciences,8167^^Behavioral Sciences|Behavioral Sciences,7928^^Behavioral Sciences|Behavioral Sciences,7899^^Behavioral Sciences|Behavioral Sciences,7896^^Behavioral Sciences|Behavioral Sciences,7894^^Behavioral Sciences|Behavioral Sciences,7892^^Behavioral Sciences|Behavioral Sciences,7890^^Behavioral Sciences|Behavioral Sciences,7888^^Behavioral Sciences|Behavioral Sciences,6838^^Behavioral Sciences|Behavioral Sciences,7886^^Behavioral Sciences|Behavioral Sciences,7884^^Behavioral Sciences|Behavioral Sciences,6903^^Behavioral Sciences|Behavioral Sciences,6894^^Behavioral Sciences|Behavioral Sciences,6888^^Behavioral Sciences|Behavioral Sciences,6870^^Behavioral Sciences|Behavioral Sciences,6863^^Behavioral Sciences|Behavioral Sciences,7268^^Behavioral Sciences|Behavioral Sciences,6857^^Behavioral Sciences|Behavioral Sciences,7265^^Behavioral Sciences|Behavioral Sciences,7262^^Behavioral Sciences|Behavioral Sciences,7260^^Behavioral Sciences|Behavioral Sciences,7255^^Behavioral Sciences|Behavioral Sciences,7253^^Behavioral Sciences|Behavioral Sciences,7251^^Behavioral Sciences|Behavioral Sciences,7249^^Behavioral Sciences|Behavioral Sciences,7247^^Behavioral Sciences|Behavioral Sciences,7245^^Behavioral Sciences|Behavioral Sciences,7243^^Behavioral Sciences|Behavioral Sciences,6847^^Behavioral Sciences|Behavioral Sciences,7241^^Behavioral Sciences|Behavioral Sciences,7239^^Behavioral Sciences|Behavioral Sciences,7236^^Behavioral Sciences|Behavioral Sciences,7234^^Behavioral Sciences|Behavioral Sciences,7232^^Behavioral Sciences|Behavioral Sciences,7230^^Behavioral Sciences|Behavioral Sciences,7228^^Behavioral Sciences|Behavioral Sciences,7226^^Behavioral Sciences|Behavioral Sciences,7021^^Behavioral Sciences|Behavioral Sciences,7015^^Behavioral Sciences|Behavioral Sciences,6843^^Behavioral Sciences|Behavioral Sciences,7009^^Behavioral Sciences|Behavioral Sciences,7001^^Behavioral Sciences|Behavioral Sciences,6997^^Behavioral Sciences|Behavioral Sciences,6982^^Behavioral Sciences|Behavioral Sciences,6975^^Behavioral Sciences|Behavioral Sciences,6971^^Behavioral Sciences|Behavioral Sciences,6965^^Behavioral Sciences|Behavioral Sciences,6958^^Behavioral Sciences|Behavioral Sciences,6937^^Behavioral Sciences|Behavioral Sciences,6930^^Behavioral Sciences|Behavioral Sciences,6840^^Behavioral Sciences|Behavioral Sciences,6925^^Behavioral Sciences|Behavioral Sciences,6918^^Behavioral Sciences|Behavioral Sciences,6914^^Behavioral Sciences|Behavioral Sciences,6908^^Behavioral Sciences|Behavioral Sciences,",
          qidArray: [
            "7926",
            "7924",
            "7921",
            "7917",
            "7915",
            "7912",
            "7909",
            "9096",
            "9090",
            "8270",
            "8261",
            "7906",
            "8256",
            "8248",
            "8245",
            "8229",
            "8219",
            "8209",
            "8204",
            "8200",
            "8198",
            "8185",
            "7903",
            "8180",
            "8175",
            "8167",
            "7928",
            "7899",
            "7896",
            "7894",
            "7892",
            "7890",
            "7888",
            "6838",
            "7886",
            "7884",
            "6903",
            "6894",
            "6888",
            "6870",
            "6863",
            "7268",
            "6857",
            "7265",
            "7262",
            "7260",
            "7255",
            "7253",
            "7251",
            "7249",
            "7247",
            "7245",
            "7243",
            "6847",
            "7241",
            "7239",
            "7236",
            "7234",
            "7232",
            "7230",
            "7228",
            "7226",
            "7021",
            "7015",
            "6843",
            "7009",
            "7001",
            "6997",
            "6982",
            "6975",
            "6971",
            "6965",
            "6958",
            "6937",
            "6930",
            "6840",
            "6925",
            "6918",
            "6914",
            "6908"
          ],
          TotalQuestionsCount: 80,
          name: "Behavioral Sciences-Behavioral Sciences(80)",
          qidsEncodedPatternString: "7926^^Behavioral Sciences|Behavioral Sciences,7924^^Behavioral Sciences|Behavioral Sciences,7921^^Behavioral Sciences|Behavioral Sciences,7917^^Behavioral Sciences|Behavioral Sciences,7915^^Behavioral Sciences|Behavioral Sciences,7912^^Behavioral Sciences|Behavioral Sciences,7909^^Behavioral Sciences|Behavioral Sciences,9096^^Behavioral Sciences|Behavioral Sciences,9090^^Behavioral Sciences|Behavioral Sciences,8270^^Behavioral Sciences|Behavioral Sciences,8261^^Behavioral Sciences|Behavioral Sciences,7906^^Behavioral Sciences|Behavioral Sciences,8256^^Behavioral Sciences|Behavioral Sciences,8248^^Behavioral Sciences|Behavioral Sciences,8245^^Behavioral Sciences|Behavioral Sciences,8229^^Behavioral Sciences|Behavioral Sciences,8219^^Behavioral Sciences|Behavioral Sciences,8209^^Behavioral Sciences|Behavioral Sciences,8204^^Behavioral Sciences|Behavioral Sciences,8200^^Behavioral Sciences|Behavioral Sciences,8198^^Behavioral Sciences|Behavioral Sciences,8185^^Behavioral Sciences|Behavioral Sciences,7903^^Behavioral Sciences|Behavioral Sciences,8180^^Behavioral Sciences|Behavioral Sciences,8175^^Behavioral Sciences|Behavioral Sciences,8167^^Behavioral Sciences|Behavioral Sciences,7928^^Behavioral Sciences|Behavioral Sciences,7899^^Behavioral Sciences|Behavioral Sciences,7896^^Behavioral Sciences|Behavioral Sciences,7894^^Behavioral Sciences|Behavioral Sciences,7892^^Behavioral Sciences|Behavioral Sciences,7890^^Behavioral Sciences|Behavioral Sciences,7888^^Behavioral Sciences|Behavioral Sciences,6838^^Behavioral Sciences|Behavioral Sciences,7886^^Behavioral Sciences|Behavioral Sciences,7884^^Behavioral Sciences|Behavioral Sciences,6903^^Behavioral Sciences|Behavioral Sciences,6894^^Behavioral Sciences|Behavioral Sciences,6888^^Behavioral Sciences|Behavioral Sciences,6870^^Behavioral Sciences|Behavioral Sciences,6863^^Behavioral Sciences|Behavioral Sciences,7268^^Behavioral Sciences|Behavioral Sciences,6857^^Behavioral Sciences|Behavioral Sciences,7265^^Behavioral Sciences|Behavioral Sciences,7262^^Behavioral Sciences|Behavioral Sciences,7260^^Behavioral Sciences|Behavioral Sciences,7255^^Behavioral Sciences|Behavioral Sciences,7253^^Behavioral Sciences|Behavioral Sciences,7251^^Behavioral Sciences|Behavioral Sciences,7249^^Behavioral Sciences|Behavioral Sciences,7247^^Behavioral Sciences|Behavioral Sciences,7245^^Behavioral Sciences|Behavioral Sciences,7243^^Behavioral Sciences|Behavioral Sciences,6847^^Behavioral Sciences|Behavioral Sciences,7241^^Behavioral Sciences|Behavioral Sciences,7239^^Behavioral Sciences|Behavioral Sciences,7236^^Behavioral Sciences|Behavioral Sciences,7234^^Behavioral Sciences|Behavioral Sciences,7232^^Behavioral Sciences|Behavioral Sciences,7230^^Behavioral Sciences|Behavioral Sciences,7228^^Behavioral Sciences|Behavioral Sciences,7226^^Behavioral Sciences|Behavioral Sciences,7021^^Behavioral Sciences|Behavioral Sciences,7015^^Behavioral Sciences|Behavioral Sciences,6843^^Behavioral Sciences|Behavioral Sciences,7009^^Behavioral Sciences|Behavioral Sciences,7001^^Behavioral Sciences|Behavioral Sciences,6997^^Behavioral Sciences|Behavioral Sciences,6982^^Behavioral Sciences|Behavioral Sciences,6975^^Behavioral Sciences|Behavioral Sciences,6971^^Behavioral Sciences|Behavioral Sciences,6965^^Behavioral Sciences|Behavioral Sciences,6958^^Behavioral Sciences|Behavioral Sciences,6937^^Behavioral Sciences|Behavioral Sciences,6930^^Behavioral Sciences|Behavioral Sciences,6840^^Behavioral Sciences|Behavioral Sciences,6925^^Behavioral Sciences|Behavioral Sciences,6918^^Behavioral Sciences|Behavioral Sciences,6914^^Behavioral Sciences|Behavioral Sciences,6908^^Behavioral Sciences|Behavioral Sciences,"
        }
      ],
      id: 89655,
      isParent: true,
      TotalQuestionsCount: 80,
      name: "Behavioral Sciences"
    },
    {
      children: [
        {
          id: "8599^^Biochemistry|Biochemistry,8596^^Biochemistry|Biochemistry,8593^^Biochemistry|Biochemistry,8590^^Biochemistry|Biochemistry,8587^^Biochemistry|Biochemistry,8585^^Biochemistry|Biochemistry,8583^^Biochemistry|Biochemistry,8800^^Biochemistry|Biochemistry,8798^^Biochemistry|Biochemistry,8794^^Biochemistry|Biochemistry,8785^^Biochemistry|Biochemistry,8778^^Biochemistry|Biochemistry,8771^^Biochemistry|Biochemistry,8767^^Biochemistry|Biochemistry,8579^^Biochemistry|Biochemistry,8764^^Biochemistry|Biochemistry,8762^^Biochemistry|Biochemistry,8757^^Biochemistry|Biochemistry,8755^^Biochemistry|Biochemistry,8747^^Biochemistry|Biochemistry,8725^^Biochemistry|Biochemistry,8720^^Biochemistry|Biochemistry,8638^^Biochemistry|Biochemistry,8633^^Biochemistry|Biochemistry,8618^^Biochemistry|Biochemistry,8614^^Biochemistry|Biochemistry,8610^^Biochemistry|Biochemistry,8577^^Biochemistry|Biochemistry,8608^^Biochemistry|Biochemistry,8605^^Biochemistry|Biochemistry,8602^^Biochemistry|Biochemistry,8449^^Biochemistry|Biochemistry,8446^^Biochemistry|Biochemistry,8443^^Biochemistry|Biochemistry,8440^^Biochemistry|Biochemistry,8438^^Biochemistry|Biochemistry,8434^^Biochemistry|Biochemistry,8575^^Biochemistry|Biochemistry,8429^^Biochemistry|Biochemistry,8573^^Biochemistry|Biochemistry,8568^^Biochemistry|Biochemistry,8564^^Biochemistry|Biochemistry,8558^^Biochemistry|Biochemistry,8553^^Biochemistry|Biochemistry,8533^^Biochemistry|Biochemistry,8530^^Biochemistry|Biochemistry,8527^^Biochemistry|Biochemistry,8525^^Biochemistry|Biochemistry,8521^^Biochemistry|Biochemistry,8426^^Biochemistry|Biochemistry,8516^^Biochemistry|Biochemistry,8512^^Biochemistry|Biochemistry,8510^^Biochemistry|Biochemistry,8504^^Biochemistry|Biochemistry,8501^^Biochemistry|Biochemistry,8498^^Biochemistry|Biochemistry,8494^^Biochemistry|Biochemistry,8480^^Biochemistry|Biochemistry,8477^^Biochemistry|Biochemistry,8475^^Biochemistry|Biochemistry,8424^^Biochemistry|Biochemistry,8464^^Biochemistry|Biochemistry,8458^^Biochemistry|Biochemistry,8456^^Biochemistry|Biochemistry,8453^^Biochemistry|Biochemistry,8237^^Biochemistry|Biochemistry,8232^^Biochemistry|Biochemistry,8228^^Biochemistry|Biochemistry,8220^^Biochemistry|Biochemistry,8212^^Biochemistry|Biochemistry,8205^^Biochemistry|Biochemistry,8375^^Biochemistry|Biochemistry,8191^^Biochemistry|Biochemistry,8370^^Biochemistry|Biochemistry,8366^^Biochemistry|Biochemistry,8363^^Biochemistry|Biochemistry,8360^^Biochemistry|Biochemistry,8357^^Biochemistry|Biochemistry,8354^^Biochemistry|Biochemistry,8350^^Biochemistry|Biochemistry,8346^^Biochemistry|Biochemistry,8341^^Biochemistry|Biochemistry,8339^^Biochemistry|Biochemistry,8187^^Biochemistry|Biochemistry,8336^^Biochemistry|Biochemistry,8334^^Biochemistry|Biochemistry,8331^^Biochemistry|Biochemistry,8327^^Biochemistry|Biochemistry,8324^^Biochemistry|Biochemistry,8321^^Biochemistry|Biochemistry,8316^^Biochemistry|Biochemistry,8300^^Biochemistry|Biochemistry,8294^^Biochemistry|Biochemistry,8282^^Biochemistry|Biochemistry,8178^^Biochemistry|Biochemistry,8276^^Biochemistry|Biochemistry,8264^^Biochemistry|Biochemistry,8243^^Biochemistry|Biochemistry,8240^^Biochemistry|Biochemistry,8022^^Biochemistry|Biochemistry,8019^^Biochemistry|Biochemistry,8016^^Biochemistry|Biochemistry,7978^^Biochemistry|Biochemistry,7976^^Biochemistry|Biochemistry,7972^^Biochemistry|Biochemistry,8172^^Biochemistry|Biochemistry,8166^^Biochemistry|Biochemistry,8162^^Biochemistry|Biochemistry,8160^^Biochemistry|Biochemistry,7969^^Biochemistry|Biochemistry,8157^^Biochemistry|Biochemistry,8154^^Biochemistry|Biochemistry,8150^^Biochemistry|Biochemistry,8147^^Biochemistry|Biochemistry,8145^^Biochemistry|Biochemistry,8141^^Biochemistry|Biochemistry,8137^^Biochemistry|Biochemistry,8134^^Biochemistry|Biochemistry,8131^^Biochemistry|Biochemistry,8127^^Biochemistry|Biochemistry,7967^^Biochemistry|Biochemistry,8125^^Biochemistry|Biochemistry,8121^^Biochemistry|Biochemistry,8118^^Biochemistry|Biochemistry,8117^^Biochemistry|Biochemistry,8111^^Biochemistry|Biochemistry,8109^^Biochemistry|Biochemistry,8105^^Biochemistry|Biochemistry,8085^^Biochemistry|Biochemistry,8080^^Biochemistry|Biochemistry,8077^^Biochemistry|Biochemistry,8062^^Biochemistry|Biochemistry,7964^^Biochemistry|Biochemistry,8060^^Biochemistry|Biochemistry,8056^^Biochemistry|Biochemistry,8051^^Biochemistry|Biochemistry,8045^^Biochemistry|Biochemistry,7725^^Biochemistry|Biochemistry,7723^^Biochemistry|Biochemistry,7721^^Biochemistry|Biochemistry,7717^^Biochemistry|Biochemistry,7715^^Biochemistry|Biochemistry,7713^^Biochemistry|Biochemistry,7961^^Biochemistry|Biochemistry,7958^^Biochemistry|Biochemistry,7955^^Biochemistry|Biochemistry,7952^^Biochemistry|Biochemistry,7949^^Biochemistry|Biochemistry,7947^^Biochemistry|Biochemistry,7943^^Biochemistry|Biochemistry,7938^^Biochemistry|Biochemistry,7709^^Biochemistry|Biochemistry,7935^^Biochemistry|Biochemistry,7933^^Biochemistry|Biochemistry,7877^^Biochemistry|Biochemistry,7874^^Biochemistry|Biochemistry,7872^^Biochemistry|Biochemistry,7867^^Biochemistry|Biochemistry,7863^^Biochemistry|Biochemistry,7860^^Biochemistry|Biochemistry,7857^^Biochemistry|Biochemistry,7853^^Biochemistry|Biochemistry,7707^^Biochemistry|Biochemistry,7848^^Biochemistry|Biochemistry,7838^^Biochemistry|Biochemistry,7830^^Biochemistry|Biochemistry,7821^^Biochemistry|Biochemistry,7810^^Biochemistry|Biochemistry,7807^^Biochemistry|Biochemistry,7802^^Biochemistry|Biochemistry,7799^^Biochemistry|Biochemistry,7796^^Biochemistry|Biochemistry,7790^^Biochemistry|Biochemistry,7703^^Biochemistry|Biochemistry,7781^^Biochemistry|Biochemistry,7736^^Biochemistry|Biochemistry,7732^^Biochemistry|Biochemistry,7728^^Biochemistry|Biochemistry,",
          qidArray: [
            "8599",
            "8596",
            "8593",
            "8590",
            "8587",
            "8585",
            "8583",
            "8800",
            "8798",
            "8794",
            "8785",
            "8778",
            "8771",
            "8767",
            "8579",
            "8764",
            "8762",
            "8757",
            "8755",
            "8747",
            "8725",
            "8720",
            "8638",
            "8633",
            "8618",
            "8614",
            "8610",
            "8577",
            "8608",
            "8605",
            "8602",
            "8449",
            "8446",
            "8443",
            "8440",
            "8438",
            "8434",
            "8575",
            "8429",
            "8573",
            "8568",
            "8564",
            "8558",
            "8553",
            "8533",
            "8530",
            "8527",
            "8525",
            "8521",
            "8426",
            "8516",
            "8512",
            "8510",
            "8504",
            "8501",
            "8498",
            "8494",
            "8480",
            "8477",
            "8475",
            "8424",
            "8464",
            "8458",
            "8456",
            "8453",
            "8237",
            "8232",
            "8228",
            "8220",
            "8212",
            "8205",
            "8375",
            "8191",
            "8370",
            "8366",
            "8363",
            "8360",
            "8357",
            "8354",
            "8350",
            "8346",
            "8341",
            "8339",
            "8187",
            "8336",
            "8334",
            "8331",
            "8327",
            "8324",
            "8321",
            "8316",
            "8300",
            "8294",
            "8282",
            "8178",
            "8276",
            "8264",
            "8243",
            "8240",
            "8022",
            "8019",
            "8016",
            "7978",
            "7976",
            "7972",
            "8172",
            "8166",
            "8162",
            "8160",
            "7969",
            "8157",
            "8154",
            "8150",
            "8147",
            "8145",
            "8141",
            "8137",
            "8134",
            "8131",
            "8127",
            "7967",
            "8125",
            "8121",
            "8118",
            "8117",
            "8111",
            "8109",
            "8105",
            "8085",
            "8080",
            "8077",
            "8062",
            "7964",
            "8060",
            "8056",
            "8051",
            "8045",
            "7725",
            "7723",
            "7721",
            "7717",
            "7715",
            "7713",
            "7961",
            "7958",
            "7955",
            "7952",
            "7949",
            "7947",
            "7943",
            "7938",
            "7709",
            "7935",
            "7933",
            "7877",
            "7874",
            "7872",
            "7867",
            "7863",
            "7860",
            "7857",
            "7853",
            "7707",
            "7848",
            "7838",
            "7830",
            "7821",
            "7810",
            "7807",
            "7802",
            "7799",
            "7796",
            "7790",
            "7703",
            "7781",
            "7736",
            "7732",
            "7728"
          ],
          TotalQuestionsCount: 178,
          name: "Biochemistry-Biochemistry(178)",
          qidsEncodedPatternString: "8599^^Biochemistry|Biochemistry,8596^^Biochemistry|Biochemistry,8593^^Biochemistry|Biochemistry,8590^^Biochemistry|Biochemistry,8587^^Biochemistry|Biochemistry,8585^^Biochemistry|Biochemistry,8583^^Biochemistry|Biochemistry,8800^^Biochemistry|Biochemistry,8798^^Biochemistry|Biochemistry,8794^^Biochemistry|Biochemistry,8785^^Biochemistry|Biochemistry,8778^^Biochemistry|Biochemistry,8771^^Biochemistry|Biochemistry,8767^^Biochemistry|Biochemistry,8579^^Biochemistry|Biochemistry,8764^^Biochemistry|Biochemistry,8762^^Biochemistry|Biochemistry,8757^^Biochemistry|Biochemistry,8755^^Biochemistry|Biochemistry,8747^^Biochemistry|Biochemistry,8725^^Biochemistry|Biochemistry,8720^^Biochemistry|Biochemistry,8638^^Biochemistry|Biochemistry,8633^^Biochemistry|Biochemistry,8618^^Biochemistry|Biochemistry,8614^^Biochemistry|Biochemistry,8610^^Biochemistry|Biochemistry,8577^^Biochemistry|Biochemistry,8608^^Biochemistry|Biochemistry,8605^^Biochemistry|Biochemistry,8602^^Biochemistry|Biochemistry,8449^^Biochemistry|Biochemistry,8446^^Biochemistry|Biochemistry,8443^^Biochemistry|Biochemistry,8440^^Biochemistry|Biochemistry,8438^^Biochemistry|Biochemistry,8434^^Biochemistry|Biochemistry,8575^^Biochemistry|Biochemistry,8429^^Biochemistry|Biochemistry,8573^^Biochemistry|Biochemistry,8568^^Biochemistry|Biochemistry,8564^^Biochemistry|Biochemistry,8558^^Biochemistry|Biochemistry,8553^^Biochemistry|Biochemistry,8533^^Biochemistry|Biochemistry,8530^^Biochemistry|Biochemistry,8527^^Biochemistry|Biochemistry,8525^^Biochemistry|Biochemistry,8521^^Biochemistry|Biochemistry,8426^^Biochemistry|Biochemistry,8516^^Biochemistry|Biochemistry,8512^^Biochemistry|Biochemistry,8510^^Biochemistry|Biochemistry,8504^^Biochemistry|Biochemistry,8501^^Biochemistry|Biochemistry,8498^^Biochemistry|Biochemistry,8494^^Biochemistry|Biochemistry,8480^^Biochemistry|Biochemistry,8477^^Biochemistry|Biochemistry,8475^^Biochemistry|Biochemistry,8424^^Biochemistry|Biochemistry,8464^^Biochemistry|Biochemistry,8458^^Biochemistry|Biochemistry,8456^^Biochemistry|Biochemistry,8453^^Biochemistry|Biochemistry,8237^^Biochemistry|Biochemistry,8232^^Biochemistry|Biochemistry,8228^^Biochemistry|Biochemistry,8220^^Biochemistry|Biochemistry,8212^^Biochemistry|Biochemistry,8205^^Biochemistry|Biochemistry,8375^^Biochemistry|Biochemistry,8191^^Biochemistry|Biochemistry,8370^^Biochemistry|Biochemistry,8366^^Biochemistry|Biochemistry,8363^^Biochemistry|Biochemistry,8360^^Biochemistry|Biochemistry,8357^^Biochemistry|Biochemistry,8354^^Biochemistry|Biochemistry,8350^^Biochemistry|Biochemistry,8346^^Biochemistry|Biochemistry,8341^^Biochemistry|Biochemistry,8339^^Biochemistry|Biochemistry,8187^^Biochemistry|Biochemistry,8336^^Biochemistry|Biochemistry,8334^^Biochemistry|Biochemistry,8331^^Biochemistry|Biochemistry,8327^^Biochemistry|Biochemistry,8324^^Biochemistry|Biochemistry,8321^^Biochemistry|Biochemistry,8316^^Biochemistry|Biochemistry,8300^^Biochemistry|Biochemistry,8294^^Biochemistry|Biochemistry,8282^^Biochemistry|Biochemistry,8178^^Biochemistry|Biochemistry,8276^^Biochemistry|Biochemistry,8264^^Biochemistry|Biochemistry,8243^^Biochemistry|Biochemistry,8240^^Biochemistry|Biochemistry,8022^^Biochemistry|Biochemistry,8019^^Biochemistry|Biochemistry,8016^^Biochemistry|Biochemistry,7978^^Biochemistry|Biochemistry,7976^^Biochemistry|Biochemistry,7972^^Biochemistry|Biochemistry,8172^^Biochemistry|Biochemistry,8166^^Biochemistry|Biochemistry,8162^^Biochemistry|Biochemistry,8160^^Biochemistry|Biochemistry,7969^^Biochemistry|Biochemistry,8157^^Biochemistry|Biochemistry,8154^^Biochemistry|Biochemistry,8150^^Biochemistry|Biochemistry,8147^^Biochemistry|Biochemistry,8145^^Biochemistry|Biochemistry,8141^^Biochemistry|Biochemistry,8137^^Biochemistry|Biochemistry,8134^^Biochemistry|Biochemistry,8131^^Biochemistry|Biochemistry,8127^^Biochemistry|Biochemistry,7967^^Biochemistry|Biochemistry,8125^^Biochemistry|Biochemistry,8121^^Biochemistry|Biochemistry,8118^^Biochemistry|Biochemistry,8117^^Biochemistry|Biochemistry,8111^^Biochemistry|Biochemistry,8109^^Biochemistry|Biochemistry,8105^^Biochemistry|Biochemistry,8085^^Biochemistry|Biochemistry,8080^^Biochemistry|Biochemistry,8077^^Biochemistry|Biochemistry,8062^^Biochemistry|Biochemistry,7964^^Biochemistry|Biochemistry,8060^^Biochemistry|Biochemistry,8056^^Biochemistry|Biochemistry,8051^^Biochemistry|Biochemistry,8045^^Biochemistry|Biochemistry,7725^^Biochemistry|Biochemistry,7723^^Biochemistry|Biochemistry,7721^^Biochemistry|Biochemistry,7717^^Biochemistry|Biochemistry,7715^^Biochemistry|Biochemistry,7713^^Biochemistry|Biochemistry,7961^^Biochemistry|Biochemistry,7958^^Biochemistry|Biochemistry,7955^^Biochemistry|Biochemistry,7952^^Biochemistry|Biochemistry,7949^^Biochemistry|Biochemistry,7947^^Biochemistry|Biochemistry,7943^^Biochemistry|Biochemistry,7938^^Biochemistry|Biochemistry,7709^^Biochemistry|Biochemistry,7935^^Biochemistry|Biochemistry,7933^^Biochemistry|Biochemistry,7877^^Biochemistry|Biochemistry,7874^^Biochemistry|Biochemistry,7872^^Biochemistry|Biochemistry,7867^^Biochemistry|Biochemistry,7863^^Biochemistry|Biochemistry,7860^^Biochemistry|Biochemistry,7857^^Biochemistry|Biochemistry,7853^^Biochemistry|Biochemistry,7707^^Biochemistry|Biochemistry,7848^^Biochemistry|Biochemistry,7838^^Biochemistry|Biochemistry,7830^^Biochemistry|Biochemistry,7821^^Biochemistry|Biochemistry,7810^^Biochemistry|Biochemistry,7807^^Biochemistry|Biochemistry,7802^^Biochemistry|Biochemistry,7799^^Biochemistry|Biochemistry,7796^^Biochemistry|Biochemistry,7790^^Biochemistry|Biochemistry,7703^^Biochemistry|Biochemistry,7781^^Biochemistry|Biochemistry,7736^^Biochemistry|Biochemistry,7732^^Biochemistry|Biochemistry,7728^^Biochemistry|Biochemistry,"
        }
      ],
      id: 25832,
      isParent: true,
      TotalQuestionsCount: 178,
      name: "Biochemistry"
    },
    {
      children: [
        {
          id: "9111^^Biostatistics|Biostatistics,9108^^Biostatistics|Biostatistics,9106^^Biostatistics|Biostatistics,9102^^Biostatistics|Biostatistics,9088^^Biostatistics|Biostatistics,9086^^Biostatistics|Biostatistics,9082^^Biostatistics|Biostatistics,9158^^Biostatistics|Biostatistics,9156^^Biostatistics|Biostatistics,9151^^Biostatistics|Biostatistics,9080^^Biostatistics|Biostatistics,9149^^Biostatistics|Biostatistics,9146^^Biostatistics|Biostatistics,9142^^Biostatistics|Biostatistics,9140^^Biostatistics|Biostatistics,9138^^Biostatistics|Biostatistics,9135^^Biostatistics|Biostatistics,9131^^Biostatistics|Biostatistics,9127^^Biostatistics|Biostatistics,9125^^Biostatistics|Biostatistics,9119^^Biostatistics|Biostatistics,9078^^Biostatistics|Biostatistics,9117^^Biostatistics|Biostatistics,9115^^Biostatistics|Biostatistics,9113^^Biostatistics|Biostatistics,8906^^Biostatistics|Biostatistics,8901^^Biostatistics|Biostatistics,8893^^Biostatistics|Biostatistics,8889^^Biostatistics|Biostatistics,8887^^Biostatistics|Biostatistics,8879^^Biostatistics|Biostatistics,9076^^Biostatistics|Biostatistics,9073^^Biostatistics|Biostatistics,9071^^Biostatistics|Biostatistics,9066^^Biostatistics|Biostatistics,9063^^Biostatistics|Biostatistics,9060^^Biostatistics|Biostatistics,9057^^Biostatistics|Biostatistics,9054^^Biostatistics|Biostatistics,8868^^Biostatistics|Biostatistics,9052^^Biostatistics|Biostatistics,8989^^Biostatistics|Biostatistics,8985^^Biostatistics|Biostatistics,8983^^Biostatistics|Biostatistics,8980^^Biostatistics|Biostatistics,8977^^Biostatistics|Biostatistics,8973^^Biostatistics|Biostatistics,8969^^Biostatistics|Biostatistics,8967^^Biostatistics|Biostatistics,8965^^Biostatistics|Biostatistics,8861^^Biostatistics|Biostatistics,8961^^Biostatistics|Biostatistics,8959^^Biostatistics|Biostatistics,8957^^Biostatistics|Biostatistics,8954^^Biostatistics|Biostatistics,8950^^Biostatistics|Biostatistics,8946^^Biostatistics|Biostatistics,8942^^Biostatistics|Biostatistics,8940^^Biostatistics|Biostatistics,8937^^Biostatistics|Biostatistics,8931^^Biostatistics|Biostatistics,8857^^Biostatistics|Biostatistics,8920^^Biostatistics|Biostatistics,8916^^Biostatistics|Biostatistics,8913^^Biostatistics|Biostatistics,8910^^Biostatistics|Biostatistics,",
          qidArray: [
            "9111",
            "9108",
            "9106",
            "9102",
            "9088",
            "9086",
            "9082",
            "9158",
            "9156",
            "9151",
            "9080",
            "9149",
            "9146",
            "9142",
            "9140",
            "9138",
            "9135",
            "9131",
            "9127",
            "9125",
            "9119",
            "9078",
            "9117",
            "9115",
            "9113",
            "8906",
            "8901",
            "8893",
            "8889",
            "8887",
            "8879",
            "9076",
            "9073",
            "9071",
            "9066",
            "9063",
            "9060",
            "9057",
            "9054",
            "8868",
            "9052",
            "8989",
            "8985",
            "8983",
            "8980",
            "8977",
            "8973",
            "8969",
            "8967",
            "8965",
            "8861",
            "8961",
            "8959",
            "8957",
            "8954",
            "8950",
            "8946",
            "8942",
            "8940",
            "8937",
            "8931",
            "8857",
            "8920",
            "8916",
            "8913",
            "8910"
          ],
          TotalQuestionsCount: 66,
          name: "Biostatistics-Biostatistics(66)",
          qidsEncodedPatternString: "9111^^Biostatistics|Biostatistics,9108^^Biostatistics|Biostatistics,9106^^Biostatistics|Biostatistics,9102^^Biostatistics|Biostatistics,9088^^Biostatistics|Biostatistics,9086^^Biostatistics|Biostatistics,9082^^Biostatistics|Biostatistics,9158^^Biostatistics|Biostatistics,9156^^Biostatistics|Biostatistics,9151^^Biostatistics|Biostatistics,9080^^Biostatistics|Biostatistics,9149^^Biostatistics|Biostatistics,9146^^Biostatistics|Biostatistics,9142^^Biostatistics|Biostatistics,9140^^Biostatistics|Biostatistics,9138^^Biostatistics|Biostatistics,9135^^Biostatistics|Biostatistics,9131^^Biostatistics|Biostatistics,9127^^Biostatistics|Biostatistics,9125^^Biostatistics|Biostatistics,9119^^Biostatistics|Biostatistics,9078^^Biostatistics|Biostatistics,9117^^Biostatistics|Biostatistics,9115^^Biostatistics|Biostatistics,9113^^Biostatistics|Biostatistics,8906^^Biostatistics|Biostatistics,8901^^Biostatistics|Biostatistics,8893^^Biostatistics|Biostatistics,8889^^Biostatistics|Biostatistics,8887^^Biostatistics|Biostatistics,8879^^Biostatistics|Biostatistics,9076^^Biostatistics|Biostatistics,9073^^Biostatistics|Biostatistics,9071^^Biostatistics|Biostatistics,9066^^Biostatistics|Biostatistics,9063^^Biostatistics|Biostatistics,9060^^Biostatistics|Biostatistics,9057^^Biostatistics|Biostatistics,9054^^Biostatistics|Biostatistics,8868^^Biostatistics|Biostatistics,9052^^Biostatistics|Biostatistics,8989^^Biostatistics|Biostatistics,8985^^Biostatistics|Biostatistics,8983^^Biostatistics|Biostatistics,8980^^Biostatistics|Biostatistics,8977^^Biostatistics|Biostatistics,8973^^Biostatistics|Biostatistics,8969^^Biostatistics|Biostatistics,8967^^Biostatistics|Biostatistics,8965^^Biostatistics|Biostatistics,8861^^Biostatistics|Biostatistics,8961^^Biostatistics|Biostatistics,8959^^Biostatistics|Biostatistics,8957^^Biostatistics|Biostatistics,8954^^Biostatistics|Biostatistics,8950^^Biostatistics|Biostatistics,8946^^Biostatistics|Biostatistics,8942^^Biostatistics|Biostatistics,8940^^Biostatistics|Biostatistics,8937^^Biostatistics|Biostatistics,8931^^Biostatistics|Biostatistics,8857^^Biostatistics|Biostatistics,8920^^Biostatistics|Biostatistics,8916^^Biostatistics|Biostatistics,8913^^Biostatistics|Biostatistics,8910^^Biostatistics|Biostatistics,"
        }
      ],
      id: 44326,
      isParent: true,
      TotalQuestionsCount: 66,
      name: "Biostatistics"
    },
    {
      children: [
        {
          id: "2281^^Cardiology|Anatomy,2277^^Cardiology|Anatomy,2271^^Cardiology|Anatomy,2269^^Cardiology|Anatomy,2267^^Cardiology|Anatomy,2264^^Cardiology|Anatomy,2261^^Cardiology|Anatomy,2320^^Cardiology|Anatomy,2315^^Cardiology|Anatomy,2312^^Cardiology|Anatomy,2310^^Cardiology|Anatomy,2302^^Cardiology|Anatomy,2298^^Cardiology|Anatomy,2293^^Cardiology|Anatomy,2288^^Cardiology|Anatomy,2255^^Cardiology|Anatomy,2286^^Cardiology|Anatomy,2284^^Cardiology|Anatomy,",
          qidArray: [
            "2281",
            "2277",
            "2271",
            "2269",
            "2267",
            "2264",
            "2261",
            "2320",
            "2315",
            "2312",
            "2310",
            "2302",
            "2298",
            "2293",
            "2288",
            "2255",
            "2286",
            "2284"
          ],
          TotalQuestionsCount: 18,
          name: "Cardiology-Anatomy(18)",
          qidsEncodedPatternString: "2281^^Cardiology|Anatomy,2277^^Cardiology|Anatomy,2271^^Cardiology|Anatomy,2269^^Cardiology|Anatomy,2267^^Cardiology|Anatomy,2264^^Cardiology|Anatomy,2261^^Cardiology|Anatomy,2320^^Cardiology|Anatomy,2315^^Cardiology|Anatomy,2312^^Cardiology|Anatomy,2310^^Cardiology|Anatomy,2302^^Cardiology|Anatomy,2298^^Cardiology|Anatomy,2293^^Cardiology|Anatomy,2288^^Cardiology|Anatomy,2255^^Cardiology|Anatomy,2286^^Cardiology|Anatomy,2284^^Cardiology|Anatomy,"
        },
        {
          id: "2333^^Cardiology|Embryology,2330^^Cardiology|Embryology,2326^^Cardiology|Embryology,",
          qidArray: [
            "2333",
            "2330",
            "2326"
          ],
          TotalQuestionsCount: 3,
          name: "Cardiology-Embryology(3)",
          qidsEncodedPatternString: "2333^^Cardiology|Embryology,2330^^Cardiology|Embryology,2326^^Cardiology|Embryology,"
        },
        {
          id: "2340^^Cardiology|Histology,2336^^Cardiology|Histology,",
          qidArray: [
            "2340",
            "2336"
          ],
          TotalQuestionsCount: 2,
          name: "Cardiology-Histology(2)",
          qidsEncodedPatternString: "2340^^Cardiology|Histology,2336^^Cardiology|Histology,"
        },
        {
          id: "2379^^Cardiology|Pathology,2374^^Cardiology|Pathology,2533^^Cardiology|Pathology,2371^^Cardiology|Pathology,2369^^Cardiology|Pathology,2485^^Cardiology|Pathology,2363^^Cardiology|Pathology,2483^^Cardiology|Pathology,2525^^Cardiology|Pathology,2481^^Cardiology|Pathology,2522^^Cardiology|Pathology,2478^^Cardiology|Pathology,2474^^Cardiology|Pathology,2471^^Cardiology|Pathology,2469^^Cardiology|Pathology,2537^^Cardiology|Pathology,2464^^Cardiology|Pathology,2520^^Cardiology|Pathology,2461^^Cardiology|Pathology,2459^^Cardiology|Pathology,2456^^Cardiology|Pathology,2361^^Cardiology|Pathology,2360^^Cardiology|Pathology,2517^^Cardiology|Pathology,2454^^Cardiology|Pathology,2515^^Cardiology|Pathology,2497^^Cardiology|Pathology,2451^^Cardiology|Pathology,2448^^Cardiology|Pathology,2446^^Cardiology|Pathology,2443^^Cardiology|Pathology,2438^^Cardiology|Pathology,2435^^Cardiology|Pathology,2431^^Cardiology|Pathology,2428^^Cardiology|Pathology,2513^^Cardiology|Pathology,2426^^Cardiology|Pathology,2358^^Cardiology|Pathology,2424^^Cardiology|Pathology,2511^^Cardiology|Pathology,2488^^Cardiology|Pathology,2419^^Cardiology|Pathology,2535^^Cardiology|Pathology,2509^^Cardiology|Pathology,2416^^Cardiology|Pathology,2411^^Cardiology|Pathology,2409^^Cardiology|Pathology,2407^^Cardiology|Pathology,2506^^Cardiology|Pathology,2405^^Cardiology|Pathology,2402^^Cardiology|Pathology,2398^^Cardiology|Pathology,2531^^Cardiology|Pathology,2502^^Cardiology|Pathology,2355^^Cardiology|Pathology,2353^^Cardiology|Pathology,2394^^Cardiology|Pathology,2393^^Cardiology|Pathology,2391^^Cardiology|Pathology,2384^^Cardiology|Pathology,2527^^Cardiology|Pathology,2381^^Cardiology|Pathology,",
          qidArray: [
            "2379",
            "2374",
            "2533",
            "2371",
            "2369",
            "2485",
            "2363",
            "2483",
            "2525",
            "2481",
            "2522",
            "2478",
            "2474",
            "2471",
            "2469",
            "2537",
            "2464",
            "2520",
            "2461",
            "2459",
            "2456",
            "2361",
            "2360",
            "2517",
            "2454",
            "2515",
            "2497",
            "2451",
            "2448",
            "2446",
            "2443",
            "2438",
            "2435",
            "2431",
            "2428",
            "2513",
            "2426",
            "2358",
            "2424",
            "2511",
            "2488",
            "2419",
            "2535",
            "2509",
            "2416",
            "2411",
            "2409",
            "2407",
            "2506",
            "2405",
            "2402",
            "2398",
            "2531",
            "2502",
            "2355",
            "2353",
            "2394",
            "2393",
            "2391",
            "2384",
            "2527",
            "2381"
          ],
          TotalQuestionsCount: 62,
          name: "Cardiology-Pathology(62)",
          qidsEncodedPatternString: "2379^^Cardiology|Pathology,2374^^Cardiology|Pathology,2533^^Cardiology|Pathology,2371^^Cardiology|Pathology,2369^^Cardiology|Pathology,2485^^Cardiology|Pathology,2363^^Cardiology|Pathology,2483^^Cardiology|Pathology,2525^^Cardiology|Pathology,2481^^Cardiology|Pathology,2522^^Cardiology|Pathology,2478^^Cardiology|Pathology,2474^^Cardiology|Pathology,2471^^Cardiology|Pathology,2469^^Cardiology|Pathology,2537^^Cardiology|Pathology,2464^^Cardiology|Pathology,2520^^Cardiology|Pathology,2461^^Cardiology|Pathology,2459^^Cardiology|Pathology,2456^^Cardiology|Pathology,2361^^Cardiology|Pathology,2360^^Cardiology|Pathology,2517^^Cardiology|Pathology,2454^^Cardiology|Pathology,2515^^Cardiology|Pathology,2497^^Cardiology|Pathology,2451^^Cardiology|Pathology,2448^^Cardiology|Pathology,2446^^Cardiology|Pathology,2443^^Cardiology|Pathology,2438^^Cardiology|Pathology,2435^^Cardiology|Pathology,2431^^Cardiology|Pathology,2428^^Cardiology|Pathology,2513^^Cardiology|Pathology,2426^^Cardiology|Pathology,2358^^Cardiology|Pathology,2424^^Cardiology|Pathology,2511^^Cardiology|Pathology,2488^^Cardiology|Pathology,2419^^Cardiology|Pathology,2535^^Cardiology|Pathology,2509^^Cardiology|Pathology,2416^^Cardiology|Pathology,2411^^Cardiology|Pathology,2409^^Cardiology|Pathology,2407^^Cardiology|Pathology,2506^^Cardiology|Pathology,2405^^Cardiology|Pathology,2402^^Cardiology|Pathology,2398^^Cardiology|Pathology,2531^^Cardiology|Pathology,2502^^Cardiology|Pathology,2355^^Cardiology|Pathology,2353^^Cardiology|Pathology,2394^^Cardiology|Pathology,2393^^Cardiology|Pathology,2391^^Cardiology|Pathology,2384^^Cardiology|Pathology,2527^^Cardiology|Pathology,2381^^Cardiology|Pathology,"
        },
        {
          id: "2744^^Cardiology|Pharmacology,2874^^Cardiology|Pharmacology,2742^^Cardiology|Pharmacology,2903^^Cardiology|Pharmacology,2738^^Cardiology|Pharmacology,2872^^Cardiology|Pharmacology,2736^^Cardiology|Pharmacology,2733^^Cardiology|Pharmacology,2869^^Cardiology|Pharmacology,2731^^Cardiology|Pharmacology,2867^^Cardiology|Pharmacology,2863^^Cardiology|Pharmacology,2860^^Cardiology|Pharmacology,2858^^Cardiology|Pharmacology,2893^^Cardiology|Pharmacology,2855^^Cardiology|Pharmacology,2853^^Cardiology|Pharmacology,2851^^Cardiology|Pharmacology,2891^^Cardiology|Pharmacology,2849^^Cardiology|Pharmacology,2834^^Cardiology|Pharmacology,2899^^Cardiology|Pharmacology,2828^^Cardiology|Pharmacology,2726^^Cardiology|Pharmacology,2819^^Cardiology|Pharmacology,2817^^Cardiology|Pharmacology,2814^^Cardiology|Pharmacology,2812^^Cardiology|Pharmacology,2888^^Cardiology|Pharmacology,2810^^Cardiology|Pharmacology,2807^^Cardiology|Pharmacology,2896^^Cardiology|Pharmacology,2802^^Cardiology|Pharmacology,2884^^Cardiology|Pharmacology,2799^^Cardiology|Pharmacology,2797^^Cardiology|Pharmacology,2794^^Cardiology|Pharmacology,2722^^Cardiology|Pharmacology,2879^^Cardiology|Pharmacology,2790^^Cardiology|Pharmacology,2788^^Cardiology|Pharmacology,2781^^Cardiology|Pharmacology,2775^^Cardiology|Pharmacology,2772^^Cardiology|Pharmacology,2770^^Cardiology|Pharmacology,2909^^Cardiology|Pharmacology,2767^^Cardiology|Pharmacology,2877^^Cardiology|Pharmacology,2765^^Cardiology|Pharmacology,2763^^Cardiology|Pharmacology,2720^^Cardiology|Pharmacology,2760^^Cardiology|Pharmacology,2755^^Cardiology|Pharmacology,2753^^Cardiology|Pharmacology,2749^^Cardiology|Pharmacology,",
          qidArray: [
            "2744",
            "2874",
            "2742",
            "2903",
            "2738",
            "2872",
            "2736",
            "2733",
            "2869",
            "2731",
            "2867",
            "2863",
            "2860",
            "2858",
            "2893",
            "2855",
            "2853",
            "2851",
            "2891",
            "2849",
            "2834",
            "2899",
            "2828",
            "2726",
            "2819",
            "2817",
            "2814",
            "2812",
            "2888",
            "2810",
            "2807",
            "2896",
            "2802",
            "2884",
            "2799",
            "2797",
            "2794",
            "2722",
            "2879",
            "2790",
            "2788",
            "2781",
            "2775",
            "2772",
            "2770",
            "2909",
            "2767",
            "2877",
            "2765",
            "2763",
            "2720",
            "2760",
            "2755",
            "2753",
            "2749"
          ],
          TotalQuestionsCount: 55,
          name: "Cardiology-Pharmacology(55)",
          qidsEncodedPatternString: "2744^^Cardiology|Pharmacology,2874^^Cardiology|Pharmacology,2742^^Cardiology|Pharmacology,2903^^Cardiology|Pharmacology,2738^^Cardiology|Pharmacology,2872^^Cardiology|Pharmacology,2736^^Cardiology|Pharmacology,2733^^Cardiology|Pharmacology,2869^^Cardiology|Pharmacology,2731^^Cardiology|Pharmacology,2867^^Cardiology|Pharmacology,2863^^Cardiology|Pharmacology,2860^^Cardiology|Pharmacology,2858^^Cardiology|Pharmacology,2893^^Cardiology|Pharmacology,2855^^Cardiology|Pharmacology,2853^^Cardiology|Pharmacology,2851^^Cardiology|Pharmacology,2891^^Cardiology|Pharmacology,2849^^Cardiology|Pharmacology,2834^^Cardiology|Pharmacology,2899^^Cardiology|Pharmacology,2828^^Cardiology|Pharmacology,2726^^Cardiology|Pharmacology,2819^^Cardiology|Pharmacology,2817^^Cardiology|Pharmacology,2814^^Cardiology|Pharmacology,2812^^Cardiology|Pharmacology,2888^^Cardiology|Pharmacology,2810^^Cardiology|Pharmacology,2807^^Cardiology|Pharmacology,2896^^Cardiology|Pharmacology,2802^^Cardiology|Pharmacology,2884^^Cardiology|Pharmacology,2799^^Cardiology|Pharmacology,2797^^Cardiology|Pharmacology,2794^^Cardiology|Pharmacology,2722^^Cardiology|Pharmacology,2879^^Cardiology|Pharmacology,2790^^Cardiology|Pharmacology,2788^^Cardiology|Pharmacology,2781^^Cardiology|Pharmacology,2775^^Cardiology|Pharmacology,2772^^Cardiology|Pharmacology,2770^^Cardiology|Pharmacology,2909^^Cardiology|Pharmacology,2767^^Cardiology|Pharmacology,2877^^Cardiology|Pharmacology,2765^^Cardiology|Pharmacology,2763^^Cardiology|Pharmacology,2720^^Cardiology|Pharmacology,2760^^Cardiology|Pharmacology,2755^^Cardiology|Pharmacology,2753^^Cardiology|Pharmacology,2749^^Cardiology|Pharmacology,"
        },
        {
          id: "2964^^Cardiology|Physiology,2961^^Cardiology|Physiology,2957^^Cardiology|Physiology,2950^^Cardiology|Physiology,2947^^Cardiology|Physiology,2945^^Cardiology|Physiology,3065^^Cardiology|Physiology,3062^^Cardiology|Physiology,3060^^Cardiology|Physiology,3057^^Cardiology|Physiology,3054^^Cardiology|Physiology,3052^^Cardiology|Physiology,3049^^Cardiology|Physiology,3045^^Cardiology|Physiology,3043^^Cardiology|Physiology,2942^^Cardiology|Physiology,3037^^Cardiology|Physiology,3033^^Cardiology|Physiology,3031^^Cardiology|Physiology,3027^^Cardiology|Physiology,3022^^Cardiology|Physiology,3017^^Cardiology|Physiology,3015^^Cardiology|Physiology,3013^^Cardiology|Physiology,3010^^Cardiology|Physiology,3008^^Cardiology|Physiology,2935^^Cardiology|Physiology,3004^^Cardiology|Physiology,3002^^Cardiology|Physiology,2999^^Cardiology|Physiology,2997^^Cardiology|Physiology,2995^^Cardiology|Physiology,2992^^Cardiology|Physiology,2988^^Cardiology|Physiology,2986^^Cardiology|Physiology,2982^^Cardiology|Physiology,2978^^Cardiology|Physiology,2930^^Cardiology|Physiology,2974^^Cardiology|Physiology,2971^^Cardiology|Physiology,2969^^Cardiology|Physiology,2967^^Cardiology|Physiology,",
          qidArray: [
            "2964",
            "2961",
            "2957",
            "2950",
            "2947",
            "2945",
            "3065",
            "3062",
            "3060",
            "3057",
            "3054",
            "3052",
            "3049",
            "3045",
            "3043",
            "2942",
            "3037",
            "3033",
            "3031",
            "3027",
            "3022",
            "3017",
            "3015",
            "3013",
            "3010",
            "3008",
            "2935",
            "3004",
            "3002",
            "2999",
            "2997",
            "2995",
            "2992",
            "2988",
            "2986",
            "2982",
            "2978",
            "2930",
            "2974",
            "2971",
            "2969",
            "2967"
          ],
          TotalQuestionsCount: 42,
          name: "Cardiology-Physiology(42)",
          qidsEncodedPatternString: "2964^^Cardiology|Physiology,2961^^Cardiology|Physiology,2957^^Cardiology|Physiology,2950^^Cardiology|Physiology,2947^^Cardiology|Physiology,2945^^Cardiology|Physiology,3065^^Cardiology|Physiology,3062^^Cardiology|Physiology,3060^^Cardiology|Physiology,3057^^Cardiology|Physiology,3054^^Cardiology|Physiology,3052^^Cardiology|Physiology,3049^^Cardiology|Physiology,3045^^Cardiology|Physiology,3043^^Cardiology|Physiology,2942^^Cardiology|Physiology,3037^^Cardiology|Physiology,3033^^Cardiology|Physiology,3031^^Cardiology|Physiology,3027^^Cardiology|Physiology,3022^^Cardiology|Physiology,3017^^Cardiology|Physiology,3015^^Cardiology|Physiology,3013^^Cardiology|Physiology,3010^^Cardiology|Physiology,3008^^Cardiology|Physiology,2935^^Cardiology|Physiology,3004^^Cardiology|Physiology,3002^^Cardiology|Physiology,2999^^Cardiology|Physiology,2997^^Cardiology|Physiology,2995^^Cardiology|Physiology,2992^^Cardiology|Physiology,2988^^Cardiology|Physiology,2986^^Cardiology|Physiology,2982^^Cardiology|Physiology,2978^^Cardiology|Physiology,2930^^Cardiology|Physiology,2974^^Cardiology|Physiology,2971^^Cardiology|Physiology,2969^^Cardiology|Physiology,2967^^Cardiology|Physiology,"
        },
        {
          id: "2586^^Cardiology|Pathophysiology,2584^^Cardiology|Pathophysiology,2581^^Cardiology|Pathophysiology,2559^^Cardiology|Pathophysiology,2709^^Cardiology|Pathophysiology,2554^^Cardiology|Pathophysiology,2706^^Cardiology|Pathophysiology,2552^^Cardiology|Pathophysiology,2703^^Cardiology|Pathophysiology,2716^^Cardiology|Pathophysiology,2700^^Cardiology|Pathophysiology,2696^^Cardiology|Pathophysiology,2692^^Cardiology|Pathophysiology,2689^^Cardiology|Pathophysiology,2687^^Cardiology|Pathophysiology,2685^^Cardiology|Pathophysiology,2682^^Cardiology|Pathophysiology,2680^^Cardiology|Pathophysiology,2677^^Cardiology|Pathophysiology,2549^^Cardiology|Pathophysiology,2675^^Cardiology|Pathophysiology,2672^^Cardiology|Pathophysiology,2669^^Cardiology|Pathophysiology,2665^^Cardiology|Pathophysiology,2662^^Cardiology|Pathophysiology,2657^^Cardiology|Pathophysiology,2654^^Cardiology|Pathophysiology,2713^^Cardiology|Pathophysiology,2648^^Cardiology|Pathophysiology,2646^^Cardiology|Pathophysiology,2643^^Cardiology|Pathophysiology,2545^^Cardiology|Pathophysiology,2640^^Cardiology|Pathophysiology,2633^^Cardiology|Pathophysiology,2630^^Cardiology|Pathophysiology,2628^^Cardiology|Pathophysiology,2626^^Cardiology|Pathophysiology,2623^^Cardiology|Pathophysiology,2621^^Cardiology|Pathophysiology,2618^^Cardiology|Pathophysiology,2615^^Cardiology|Pathophysiology,2612^^Cardiology|Pathophysiology,2542^^Cardiology|Pathophysiology,2607^^Cardiology|Pathophysiology,2601^^Cardiology|Pathophysiology,2595^^Cardiology|Pathophysiology,2589^^Cardiology|Pathophysiology,",
          qidArray: [
            "2586",
            "2584",
            "2581",
            "2559",
            "2709",
            "2554",
            "2706",
            "2552",
            "2703",
            "2716",
            "2700",
            "2696",
            "2692",
            "2689",
            "2687",
            "2685",
            "2682",
            "2680",
            "2677",
            "2549",
            "2675",
            "2672",
            "2669",
            "2665",
            "2662",
            "2657",
            "2654",
            "2713",
            "2648",
            "2646",
            "2643",
            "2545",
            "2640",
            "2633",
            "2630",
            "2628",
            "2626",
            "2623",
            "2621",
            "2618",
            "2615",
            "2612",
            "2542",
            "2607",
            "2601",
            "2595",
            "2589"
          ],
          TotalQuestionsCount: 47,
          name: "Cardiology-Pathophysiology(47)",
          qidsEncodedPatternString: "2586^^Cardiology|Pathophysiology,2584^^Cardiology|Pathophysiology,2581^^Cardiology|Pathophysiology,2559^^Cardiology|Pathophysiology,2709^^Cardiology|Pathophysiology,2554^^Cardiology|Pathophysiology,2706^^Cardiology|Pathophysiology,2552^^Cardiology|Pathophysiology,2703^^Cardiology|Pathophysiology,2716^^Cardiology|Pathophysiology,2700^^Cardiology|Pathophysiology,2696^^Cardiology|Pathophysiology,2692^^Cardiology|Pathophysiology,2689^^Cardiology|Pathophysiology,2687^^Cardiology|Pathophysiology,2685^^Cardiology|Pathophysiology,2682^^Cardiology|Pathophysiology,2680^^Cardiology|Pathophysiology,2677^^Cardiology|Pathophysiology,2549^^Cardiology|Pathophysiology,2675^^Cardiology|Pathophysiology,2672^^Cardiology|Pathophysiology,2669^^Cardiology|Pathophysiology,2665^^Cardiology|Pathophysiology,2662^^Cardiology|Pathophysiology,2657^^Cardiology|Pathophysiology,2654^^Cardiology|Pathophysiology,2713^^Cardiology|Pathophysiology,2648^^Cardiology|Pathophysiology,2646^^Cardiology|Pathophysiology,2643^^Cardiology|Pathophysiology,2545^^Cardiology|Pathophysiology,2640^^Cardiology|Pathophysiology,2633^^Cardiology|Pathophysiology,2630^^Cardiology|Pathophysiology,2628^^Cardiology|Pathophysiology,2626^^Cardiology|Pathophysiology,2623^^Cardiology|Pathophysiology,2621^^Cardiology|Pathophysiology,2618^^Cardiology|Pathophysiology,2615^^Cardiology|Pathophysiology,2612^^Cardiology|Pathophysiology,2542^^Cardiology|Pathophysiology,2607^^Cardiology|Pathophysiology,2601^^Cardiology|Pathophysiology,2595^^Cardiology|Pathophysiology,2589^^Cardiology|Pathophysiology,"
        }
      ],
      id: 76766,
      isParent: true,
      TotalQuestionsCount: 229,
      name: "Cardiology"
    },
    {
      children: [
        {
          id: "3354^^Dermatology|Embryology,",
          qidArray: [
            "3354"
          ],
          TotalQuestionsCount: 1,
          name: "Dermatology-Embryology(1)",
          qidsEncodedPatternString: "3354^^Dermatology|Embryology,"
        },
        {
          id: "3350^^Dermatology|Anatomy,",
          qidArray: [
            "3350"
          ],
          TotalQuestionsCount: 1,
          name: "Dermatology-Anatomy(1)",
          qidsEncodedPatternString: "3350^^Dermatology|Anatomy,"
        },
        {
          id: "3383^^Dermatology|Pathology,3381^^Dermatology|Pathology,3378^^Dermatology|Pathology,3374^^Dermatology|Pathology,3369^^Dermatology|Pathology,3366^^Dermatology|Pathology,3467^^Dermatology|Pathology,3363^^Dermatology|Pathology,3464^^Dermatology|Pathology,3462^^Dermatology|Pathology,3460^^Dermatology|Pathology,3457^^Dermatology|Pathology,3453^^Dermatology|Pathology,3449^^Dermatology|Pathology,3446^^Dermatology|Pathology,3443^^Dermatology|Pathology,3438^^Dermatology|Pathology,3434^^Dermatology|Pathology,3360^^Dermatology|Pathology,3430^^Dermatology|Pathology,3428^^Dermatology|Pathology,3425^^Dermatology|Pathology,3423^^Dermatology|Pathology,3419^^Dermatology|Pathology,3415^^Dermatology|Pathology,3412^^Dermatology|Pathology,3409^^Dermatology|Pathology,3405^^Dermatology|Pathology,3395^^Dermatology|Pathology,3358^^Dermatology|Pathology,3393^^Dermatology|Pathology,3390^^Dermatology|Pathology,3388^^Dermatology|Pathology,3385^^Dermatology|Pathology,",
          qidArray: [
            "3383",
            "3381",
            "3378",
            "3374",
            "3369",
            "3366",
            "3467",
            "3363",
            "3464",
            "3462",
            "3460",
            "3457",
            "3453",
            "3449",
            "3446",
            "3443",
            "3438",
            "3434",
            "3360",
            "3430",
            "3428",
            "3425",
            "3423",
            "3419",
            "3415",
            "3412",
            "3409",
            "3405",
            "3395",
            "3358",
            "3393",
            "3390",
            "3388",
            "3385"
          ],
          TotalQuestionsCount: 34,
          name: "Dermatology-Pathology(34)",
          qidsEncodedPatternString: "3383^^Dermatology|Pathology,3381^^Dermatology|Pathology,3378^^Dermatology|Pathology,3374^^Dermatology|Pathology,3369^^Dermatology|Pathology,3366^^Dermatology|Pathology,3467^^Dermatology|Pathology,3363^^Dermatology|Pathology,3464^^Dermatology|Pathology,3462^^Dermatology|Pathology,3460^^Dermatology|Pathology,3457^^Dermatology|Pathology,3453^^Dermatology|Pathology,3449^^Dermatology|Pathology,3446^^Dermatology|Pathology,3443^^Dermatology|Pathology,3438^^Dermatology|Pathology,3434^^Dermatology|Pathology,3360^^Dermatology|Pathology,3430^^Dermatology|Pathology,3428^^Dermatology|Pathology,3425^^Dermatology|Pathology,3423^^Dermatology|Pathology,3419^^Dermatology|Pathology,3415^^Dermatology|Pathology,3412^^Dermatology|Pathology,3409^^Dermatology|Pathology,3405^^Dermatology|Pathology,3395^^Dermatology|Pathology,3358^^Dermatology|Pathology,3393^^Dermatology|Pathology,3390^^Dermatology|Pathology,3388^^Dermatology|Pathology,3385^^Dermatology|Pathology,"
        },
        {
          id: "3491^^Dermatology|Pharmacology,3488^^Dermatology|Pharmacology,3483^^Dermatology|Pharmacology,3478^^Dermatology|Pharmacology,3476^^Dermatology|Pharmacology,3473^^Dermatology|Pharmacology,3470^^Dermatology|Pharmacology,",
          qidArray: [
            "3491",
            "3488",
            "3483",
            "3478",
            "3476",
            "3473",
            "3470"
          ],
          TotalQuestionsCount: 7,
          name: "Dermatology-Pharmacology(7)",
          qidsEncodedPatternString: "3491^^Dermatology|Pharmacology,3488^^Dermatology|Pharmacology,3483^^Dermatology|Pharmacology,3478^^Dermatology|Pharmacology,3476^^Dermatology|Pharmacology,3473^^Dermatology|Pharmacology,3470^^Dermatology|Pharmacology,"
        }
      ],
      id: 80220,
      isParent: true,
      TotalQuestionsCount: 43,
      name: "Dermatology"
    },
    {
      children: [
        {
          id: "4113^^Endocrinology|Anatomy,4110^^Endocrinology|Anatomy,",
          qidArray: [
            "4113",
            "4110"
          ],
          TotalQuestionsCount: 2,
          name: "Endocrinology-Anatomy(2)",
          qidsEncodedPatternString: "4113^^Endocrinology|Anatomy,4110^^Endocrinology|Anatomy,"
        },
        {
          id: "4126^^Endocrinology|Embryology,4124^^Endocrinology|Embryology,4118^^Endocrinology|Embryology,4116^^Endocrinology|Embryology,",
          qidArray: [
            "4126",
            "4124",
            "4118",
            "4116"
          ],
          TotalQuestionsCount: 4,
          name: "Endocrinology-Embryology(4)",
          qidsEncodedPatternString: "4126^^Endocrinology|Embryology,4124^^Endocrinology|Embryology,4118^^Endocrinology|Embryology,4116^^Endocrinology|Embryology,"
        },
        {
          id: "4128^^Endocrinology|Histology,",
          qidArray: [
            "4128"
          ],
          TotalQuestionsCount: 1,
          name: "Endocrinology-Histology(1)",
          qidsEncodedPatternString: "4128^^Endocrinology|Histology,"
        },
        {
          id: "4163^^Endocrinology|Pathology,4161^^Endocrinology|Pathology,4157^^Endocrinology|Pathology,4153^^Endocrinology|Pathology,4150^^Endocrinology|Pathology,4146^^Endocrinology|Pathology,4143^^Endocrinology|Pathology,4207^^Endocrinology|Pathology,4204^^Endocrinology|Pathology,4140^^Endocrinology|Pathology,4201^^Endocrinology|Pathology,4199^^Endocrinology|Pathology,4197^^Endocrinology|Pathology,4194^^Endocrinology|Pathology,4191^^Endocrinology|Pathology,4189^^Endocrinology|Pathology,4185^^Endocrinology|Pathology,4182^^Endocrinology|Pathology,4174^^Endocrinology|Pathology,4136^^Endocrinology|Pathology,4171^^Endocrinology|Pathology,4168^^Endocrinology|Pathology,4165^^Endocrinology|Pathology,",
          qidArray: [
            "4163",
            "4161",
            "4157",
            "4153",
            "4150",
            "4146",
            "4143",
            "4207",
            "4204",
            "4140",
            "4201",
            "4199",
            "4197",
            "4194",
            "4191",
            "4189",
            "4185",
            "4182",
            "4174",
            "4136",
            "4171",
            "4168",
            "4165"
          ],
          TotalQuestionsCount: 23,
          name: "Endocrinology-Pathology(23)",
          qidsEncodedPatternString: "4163^^Endocrinology|Pathology,4161^^Endocrinology|Pathology,4157^^Endocrinology|Pathology,4153^^Endocrinology|Pathology,4150^^Endocrinology|Pathology,4146^^Endocrinology|Pathology,4143^^Endocrinology|Pathology,4207^^Endocrinology|Pathology,4204^^Endocrinology|Pathology,4140^^Endocrinology|Pathology,4201^^Endocrinology|Pathology,4199^^Endocrinology|Pathology,4197^^Endocrinology|Pathology,4194^^Endocrinology|Pathology,4191^^Endocrinology|Pathology,4189^^Endocrinology|Pathology,4185^^Endocrinology|Pathology,4182^^Endocrinology|Pathology,4174^^Endocrinology|Pathology,4136^^Endocrinology|Pathology,4171^^Endocrinology|Pathology,4168^^Endocrinology|Pathology,4165^^Endocrinology|Pathology,"
        },
        {
          id: "4392^^Endocrinology|Pharmacology,4390^^Endocrinology|Pharmacology,4387^^Endocrinology|Pharmacology,4384^^Endocrinology|Pharmacology,4380^^Endocrinology|Pharmacology,4378^^Endocrinology|Pharmacology,4473^^Endocrinology|Pharmacology,4465^^Endocrinology|Pharmacology,4376^^Endocrinology|Pharmacology,4462^^Endocrinology|Pharmacology,4458^^Endocrinology|Pharmacology,4455^^Endocrinology|Pharmacology,4452^^Endocrinology|Pharmacology,4448^^Endocrinology|Pharmacology,4445^^Endocrinology|Pharmacology,4442^^Endocrinology|Pharmacology,4440^^Endocrinology|Pharmacology,4437^^Endocrinology|Pharmacology,4434^^Endocrinology|Pharmacology,4373^^Endocrinology|Pharmacology,4432^^Endocrinology|Pharmacology,4429^^Endocrinology|Pharmacology,4427^^Endocrinology|Pharmacology,4423^^Endocrinology|Pharmacology,4420^^Endocrinology|Pharmacology,4418^^Endocrinology|Pharmacology,4413^^Endocrinology|Pharmacology,4409^^Endocrinology|Pharmacology,4407^^Endocrinology|Pharmacology,4405^^Endocrinology|Pharmacology,4370^^Endocrinology|Pharmacology,4402^^Endocrinology|Pharmacology,4400^^Endocrinology|Pharmacology,4398^^Endocrinology|Pharmacology,4395^^Endocrinology|Pharmacology,",
          qidArray: [
            "4392",
            "4390",
            "4387",
            "4384",
            "4380",
            "4378",
            "4473",
            "4465",
            "4376",
            "4462",
            "4458",
            "4455",
            "4452",
            "4448",
            "4445",
            "4442",
            "4440",
            "4437",
            "4434",
            "4373",
            "4432",
            "4429",
            "4427",
            "4423",
            "4420",
            "4418",
            "4413",
            "4409",
            "4407",
            "4405",
            "4370",
            "4402",
            "4400",
            "4398",
            "4395"
          ],
          TotalQuestionsCount: 35,
          name: "Endocrinology-Pharmacology(35)",
          qidsEncodedPatternString: "4392^^Endocrinology|Pharmacology,4390^^Endocrinology|Pharmacology,4387^^Endocrinology|Pharmacology,4384^^Endocrinology|Pharmacology,4380^^Endocrinology|Pharmacology,4378^^Endocrinology|Pharmacology,4473^^Endocrinology|Pharmacology,4465^^Endocrinology|Pharmacology,4376^^Endocrinology|Pharmacology,4462^^Endocrinology|Pharmacology,4458^^Endocrinology|Pharmacology,4455^^Endocrinology|Pharmacology,4452^^Endocrinology|Pharmacology,4448^^Endocrinology|Pharmacology,4445^^Endocrinology|Pharmacology,4442^^Endocrinology|Pharmacology,4440^^Endocrinology|Pharmacology,4437^^Endocrinology|Pharmacology,4434^^Endocrinology|Pharmacology,4373^^Endocrinology|Pharmacology,4432^^Endocrinology|Pharmacology,4429^^Endocrinology|Pharmacology,4427^^Endocrinology|Pharmacology,4423^^Endocrinology|Pharmacology,4420^^Endocrinology|Pharmacology,4418^^Endocrinology|Pharmacology,4413^^Endocrinology|Pharmacology,4409^^Endocrinology|Pharmacology,4407^^Endocrinology|Pharmacology,4405^^Endocrinology|Pharmacology,4370^^Endocrinology|Pharmacology,4402^^Endocrinology|Pharmacology,4400^^Endocrinology|Pharmacology,4398^^Endocrinology|Pharmacology,4395^^Endocrinology|Pharmacology,"
        },
        {
          id: "4501^^Endocrinology|Physiology,4498^^Endocrinology|Physiology,4495^^Endocrinology|Physiology,4492^^Endocrinology|Physiology,4489^^Endocrinology|Physiology,4486^^Endocrinology|Physiology,4483^^Endocrinology|Physiology,4479^^Endocrinology|Physiology,4545^^Endocrinology|Physiology,4542^^Endocrinology|Physiology,4539^^Endocrinology|Physiology,4536^^Endocrinology|Physiology,4533^^Endocrinology|Physiology,4529^^Endocrinology|Physiology,4526^^Endocrinology|Physiology,4523^^Endocrinology|Physiology,4476^^Endocrinology|Physiology,4519^^Endocrinology|Physiology,4504^^Endocrinology|Physiology,",
          qidArray: [
            "4501",
            "4498",
            "4495",
            "4492",
            "4489",
            "4486",
            "4483",
            "4479",
            "4545",
            "4542",
            "4539",
            "4536",
            "4533",
            "4529",
            "4526",
            "4523",
            "4476",
            "4519",
            "4504"
          ],
          TotalQuestionsCount: 19,
          name: "Endocrinology-Physiology(19)",
          qidsEncodedPatternString: "4501^^Endocrinology|Physiology,4498^^Endocrinology|Physiology,4495^^Endocrinology|Physiology,4492^^Endocrinology|Physiology,4489^^Endocrinology|Physiology,4486^^Endocrinology|Physiology,4483^^Endocrinology|Physiology,4479^^Endocrinology|Physiology,4545^^Endocrinology|Physiology,4542^^Endocrinology|Physiology,4539^^Endocrinology|Physiology,4536^^Endocrinology|Physiology,4533^^Endocrinology|Physiology,4529^^Endocrinology|Physiology,4526^^Endocrinology|Physiology,4523^^Endocrinology|Physiology,4476^^Endocrinology|Physiology,4519^^Endocrinology|Physiology,4504^^Endocrinology|Physiology,"
        },
        {
          id: "4238^^Endocrinology|Pathophysiology,4232^^Endocrinology|Pathophysiology,4229^^Endocrinology|Pathophysiology,4227^^Endocrinology|Pathophysiology,4225^^Endocrinology|Pathophysiology,4351^^Endocrinology|Pathophysiology,4222^^Endocrinology|Pathophysiology,4349^^Endocrinology|Pathophysiology,4346^^Endocrinology|Pathophysiology,4341^^Endocrinology|Pathophysiology,4337^^Endocrinology|Pathophysiology,4334^^Endocrinology|Pathophysiology,4331^^Endocrinology|Pathophysiology,4329^^Endocrinology|Pathophysiology,4326^^Endocrinology|Pathophysiology,4323^^Endocrinology|Pathophysiology,4320^^Endocrinology|Pathophysiology,4218^^Endocrinology|Pathophysiology,4317^^Endocrinology|Pathophysiology,4313^^Endocrinology|Pathophysiology,4310^^Endocrinology|Pathophysiology,4306^^Endocrinology|Pathophysiology,4303^^Endocrinology|Pathophysiology,4300^^Endocrinology|Pathophysiology,4296^^Endocrinology|Pathophysiology,4291^^Endocrinology|Pathophysiology,4288^^Endocrinology|Pathophysiology,4285^^Endocrinology|Pathophysiology,4215^^Endocrinology|Pathophysiology,4282^^Endocrinology|Pathophysiology,4279^^Endocrinology|Pathophysiology,4275^^Endocrinology|Pathophysiology,4368^^Endocrinology|Pathophysiology,4272^^Endocrinology|Pathophysiology,4270^^Endocrinology|Pathophysiology,4267^^Endocrinology|Pathophysiology,4264^^Endocrinology|Pathophysiology,4363^^Endocrinology|Pathophysiology,4261^^Endocrinology|Pathophysiology,4360^^Endocrinology|Pathophysiology,4257^^Endocrinology|Pathophysiology,4252^^Endocrinology|Pathophysiology,4211^^Endocrinology|Pathophysiology,4249^^Endocrinology|Pathophysiology,4356^^Endocrinology|Pathophysiology,4246^^Endocrinology|Pathophysiology,4243^^Endocrinology|Pathophysiology,4240^^Endocrinology|Pathophysiology,4353^^Endocrinology|Pathophysiology,2250^^Endocrinology|Pathophysiology,",
          qidArray: [
            "4238",
            "4232",
            "4229",
            "4227",
            "4225",
            "4351",
            "4222",
            "4349",
            "4346",
            "4341",
            "4337",
            "4334",
            "4331",
            "4329",
            "4326",
            "4323",
            "4320",
            "4218",
            "4317",
            "4313",
            "4310",
            "4306",
            "4303",
            "4300",
            "4296",
            "4291",
            "4288",
            "4285",
            "4215",
            "4282",
            "4279",
            "4275",
            "4368",
            "4272",
            "4270",
            "4267",
            "4264",
            "4363",
            "4261",
            "4360",
            "4257",
            "4252",
            "4211",
            "4249",
            "4356",
            "4246",
            "4243",
            "4240",
            "4353",
            "2250"
          ],
          TotalQuestionsCount: 50,
          name: "Endocrinology-Pathophysiology(50)",
          qidsEncodedPatternString: "4238^^Endocrinology|Pathophysiology,4232^^Endocrinology|Pathophysiology,4229^^Endocrinology|Pathophysiology,4227^^Endocrinology|Pathophysiology,4225^^Endocrinology|Pathophysiology,4351^^Endocrinology|Pathophysiology,4222^^Endocrinology|Pathophysiology,4349^^Endocrinology|Pathophysiology,4346^^Endocrinology|Pathophysiology,4341^^Endocrinology|Pathophysiology,4337^^Endocrinology|Pathophysiology,4334^^Endocrinology|Pathophysiology,4331^^Endocrinology|Pathophysiology,4329^^Endocrinology|Pathophysiology,4326^^Endocrinology|Pathophysiology,4323^^Endocrinology|Pathophysiology,4320^^Endocrinology|Pathophysiology,4218^^Endocrinology|Pathophysiology,4317^^Endocrinology|Pathophysiology,4313^^Endocrinology|Pathophysiology,4310^^Endocrinology|Pathophysiology,4306^^Endocrinology|Pathophysiology,4303^^Endocrinology|Pathophysiology,4300^^Endocrinology|Pathophysiology,4296^^Endocrinology|Pathophysiology,4291^^Endocrinology|Pathophysiology,4288^^Endocrinology|Pathophysiology,4285^^Endocrinology|Pathophysiology,4215^^Endocrinology|Pathophysiology,4282^^Endocrinology|Pathophysiology,4279^^Endocrinology|Pathophysiology,4275^^Endocrinology|Pathophysiology,4368^^Endocrinology|Pathophysiology,4272^^Endocrinology|Pathophysiology,4270^^Endocrinology|Pathophysiology,4267^^Endocrinology|Pathophysiology,4264^^Endocrinology|Pathophysiology,4363^^Endocrinology|Pathophysiology,4261^^Endocrinology|Pathophysiology,4360^^Endocrinology|Pathophysiology,4257^^Endocrinology|Pathophysiology,4252^^Endocrinology|Pathophysiology,4211^^Endocrinology|Pathophysiology,4249^^Endocrinology|Pathophysiology,4356^^Endocrinology|Pathophysiology,4246^^Endocrinology|Pathophysiology,4243^^Endocrinology|Pathophysiology,4240^^Endocrinology|Pathophysiology,4353^^Endocrinology|Pathophysiology,2250^^Endocrinology|Pathophysiology,"
        }
      ],
      id: 3309,
      isParent: true,
      TotalQuestionsCount: 134,
      name: "Endocrinology"
    },
    {
      children: [
        {
          id: "3518^^Gastroenterology|Anatomy,3515^^Gastroenterology|Anatomy,3511^^Gastroenterology|Anatomy,3509^^Gastroenterology|Anatomy,3506^^Gastroenterology|Anatomy,3502^^Gastroenterology|Anatomy,3499^^Gastroenterology|Anatomy,3563^^Gastroenterology|Anatomy,3560^^Gastroenterology|Anatomy,3496^^Gastroenterology|Anatomy,3557^^Gastroenterology|Anatomy,3554^^Gastroenterology|Anatomy,3552^^Gastroenterology|Anatomy,3549^^Gastroenterology|Anatomy,3545^^Gastroenterology|Anatomy,3542^^Gastroenterology|Anatomy,3539^^Gastroenterology|Anatomy,3537^^Gastroenterology|Anatomy,3534^^Gastroenterology|Anatomy,3531^^Gastroenterology|Anatomy,3493^^Gastroenterology|Anatomy,3528^^Gastroenterology|Anatomy,3524^^Gastroenterology|Anatomy,3521^^Gastroenterology|Anatomy,",
          qidArray: [
            "3518",
            "3515",
            "3511",
            "3509",
            "3506",
            "3502",
            "3499",
            "3563",
            "3560",
            "3496",
            "3557",
            "3554",
            "3552",
            "3549",
            "3545",
            "3542",
            "3539",
            "3537",
            "3534",
            "3531",
            "3493",
            "3528",
            "3524",
            "3521"
          ],
          TotalQuestionsCount: 24,
          name: "Gastroenterology-Anatomy(24)",
          qidsEncodedPatternString: "3518^^Gastroenterology|Anatomy,3515^^Gastroenterology|Anatomy,3511^^Gastroenterology|Anatomy,3509^^Gastroenterology|Anatomy,3506^^Gastroenterology|Anatomy,3502^^Gastroenterology|Anatomy,3499^^Gastroenterology|Anatomy,3563^^Gastroenterology|Anatomy,3560^^Gastroenterology|Anatomy,3496^^Gastroenterology|Anatomy,3557^^Gastroenterology|Anatomy,3554^^Gastroenterology|Anatomy,3552^^Gastroenterology|Anatomy,3549^^Gastroenterology|Anatomy,3545^^Gastroenterology|Anatomy,3542^^Gastroenterology|Anatomy,3539^^Gastroenterology|Anatomy,3537^^Gastroenterology|Anatomy,3534^^Gastroenterology|Anatomy,3531^^Gastroenterology|Anatomy,3493^^Gastroenterology|Anatomy,3528^^Gastroenterology|Anatomy,3524^^Gastroenterology|Anatomy,3521^^Gastroenterology|Anatomy,"
        },
        {
          id: "3586^^Gastroenterology|Embryology,3583^^Gastroenterology|Embryology,3580^^Gastroenterology|Embryology,3578^^Gastroenterology|Embryology,3575^^Gastroenterology|Embryology,3572^^Gastroenterology|Embryology,3570^^Gastroenterology|Embryology,3567^^Gastroenterology|Embryology,3594^^Gastroenterology|Embryology,3565^^Gastroenterology|Embryology,3592^^Gastroenterology|Embryology,",
          qidArray: [
            "3586",
            "3583",
            "3580",
            "3578",
            "3575",
            "3572",
            "3570",
            "3567",
            "3594",
            "3565",
            "3592"
          ],
          TotalQuestionsCount: 11,
          name: "Gastroenterology-Embryology(11)",
          qidsEncodedPatternString: "3586^^Gastroenterology|Embryology,3583^^Gastroenterology|Embryology,3580^^Gastroenterology|Embryology,3578^^Gastroenterology|Embryology,3575^^Gastroenterology|Embryology,3572^^Gastroenterology|Embryology,3570^^Gastroenterology|Embryology,3567^^Gastroenterology|Embryology,3594^^Gastroenterology|Embryology,3565^^Gastroenterology|Embryology,3592^^Gastroenterology|Embryology,"
        },
        {
          id: "3597^^Gastroenterology|Histology,",
          qidArray: [
            "3597"
          ],
          TotalQuestionsCount: 1,
          name: "Gastroenterology-Histology(1)",
          qidsEncodedPatternString: "3597^^Gastroenterology|Histology,"
        },
        {
          id: "3624^^Gastroenterology|Pathology,3621^^Gastroenterology|Pathology,3618^^Gastroenterology|Pathology,3770^^Gastroenterology|Pathology,3615^^Gastroenterology|Pathology,3718^^Gastroenterology|Pathology,3611^^Gastroenterology|Pathology,3716^^Gastroenterology|Pathology,3714^^Gastroenterology|Pathology,3609^^Gastroenterology|Pathology,3712^^Gastroenterology|Pathology,3710^^Gastroenterology|Pathology,3708^^Gastroenterology|Pathology,3706^^Gastroenterology|Pathology,3758^^Gastroenterology|Pathology,3703^^Gastroenterology|Pathology,3756^^Gastroenterology|Pathology,3701^^Gastroenterology|Pathology,3753^^Gastroenterology|Pathology,3698^^Gastroenterology|Pathology,3750^^Gastroenterology|Pathology,3695^^Gastroenterology|Pathology,3693^^Gastroenterology|Pathology,3744^^Gastroenterology|Pathology,3689^^Gastroenterology|Pathology,3606^^Gastroenterology|Pathology,3739^^Gastroenterology|Pathology,3686^^Gastroenterology|Pathology,3761^^Gastroenterology|Pathology,3684^^Gastroenterology|Pathology,3783^^Gastroenterology|Pathology,3682^^Gastroenterology|Pathology,3680^^Gastroenterology|Pathology,3678^^Gastroenterology|Pathology,3779^^Gastroenterology|Pathology,3737^^Gastroenterology|Pathology,3676^^Gastroenterology|Pathology,3672^^Gastroenterology|Pathology,3776^^Gastroenterology|Pathology,3670^^Gastroenterology|Pathology,3735^^Gastroenterology|Pathology,3668^^Gastroenterology|Pathology,3665^^Gastroenterology|Pathology,3603^^Gastroenterology|Pathology,3733^^Gastroenterology|Pathology,3663^^Gastroenterology|Pathology,3773^^Gastroenterology|Pathology,3729^^Gastroenterology|Pathology,3661^^Gastroenterology|Pathology,3727^^Gastroenterology|Pathology,3658^^Gastroenterology|Pathology,3656^^Gastroenterology|Pathology,3653^^Gastroenterology|Pathology,3650^^Gastroenterology|Pathology,3647^^Gastroenterology|Pathology,3643^^Gastroenterology|Pathology,3641^^Gastroenterology|Pathology,3768^^Gastroenterology|Pathology,3639^^Gastroenterology|Pathology,3601^^Gastroenterology|Pathology,3765^^Gastroenterology|Pathology,3722^^Gastroenterology|Pathology,3636^^Gastroenterology|Pathology,3631^^Gastroenterology|Pathology,3763^^Gastroenterology|Pathology,3720^^Gastroenterology|Pathology,3627^^Gastroenterology|Pathology,",
          qidArray: [
            "3624",
            "3621",
            "3618",
            "3770",
            "3615",
            "3718",
            "3611",
            "3716",
            "3714",
            "3609",
            "3712",
            "3710",
            "3708",
            "3706",
            "3758",
            "3703",
            "3756",
            "3701",
            "3753",
            "3698",
            "3750",
            "3695",
            "3693",
            "3744",
            "3689",
            "3606",
            "3739",
            "3686",
            "3761",
            "3684",
            "3783",
            "3682",
            "3680",
            "3678",
            "3779",
            "3737",
            "3676",
            "3672",
            "3776",
            "3670",
            "3735",
            "3668",
            "3665",
            "3603",
            "3733",
            "3663",
            "3773",
            "3729",
            "3661",
            "3727",
            "3658",
            "3656",
            "3653",
            "3650",
            "3647",
            "3643",
            "3641",
            "3768",
            "3639",
            "3601",
            "3765",
            "3722",
            "3636",
            "3631",
            "3763",
            "3720",
            "3627"
          ],
          TotalQuestionsCount: 67,
          name: "Gastroenterology-Pathology(67)",
          qidsEncodedPatternString: "3624^^Gastroenterology|Pathology,3621^^Gastroenterology|Pathology,3618^^Gastroenterology|Pathology,3770^^Gastroenterology|Pathology,3615^^Gastroenterology|Pathology,3718^^Gastroenterology|Pathology,3611^^Gastroenterology|Pathology,3716^^Gastroenterology|Pathology,3714^^Gastroenterology|Pathology,3609^^Gastroenterology|Pathology,3712^^Gastroenterology|Pathology,3710^^Gastroenterology|Pathology,3708^^Gastroenterology|Pathology,3706^^Gastroenterology|Pathology,3758^^Gastroenterology|Pathology,3703^^Gastroenterology|Pathology,3756^^Gastroenterology|Pathology,3701^^Gastroenterology|Pathology,3753^^Gastroenterology|Pathology,3698^^Gastroenterology|Pathology,3750^^Gastroenterology|Pathology,3695^^Gastroenterology|Pathology,3693^^Gastroenterology|Pathology,3744^^Gastroenterology|Pathology,3689^^Gastroenterology|Pathology,3606^^Gastroenterology|Pathology,3739^^Gastroenterology|Pathology,3686^^Gastroenterology|Pathology,3761^^Gastroenterology|Pathology,3684^^Gastroenterology|Pathology,3783^^Gastroenterology|Pathology,3682^^Gastroenterology|Pathology,3680^^Gastroenterology|Pathology,3678^^Gastroenterology|Pathology,3779^^Gastroenterology|Pathology,3737^^Gastroenterology|Pathology,3676^^Gastroenterology|Pathology,3672^^Gastroenterology|Pathology,3776^^Gastroenterology|Pathology,3670^^Gastroenterology|Pathology,3735^^Gastroenterology|Pathology,3668^^Gastroenterology|Pathology,3665^^Gastroenterology|Pathology,3603^^Gastroenterology|Pathology,3733^^Gastroenterology|Pathology,3663^^Gastroenterology|Pathology,3773^^Gastroenterology|Pathology,3729^^Gastroenterology|Pathology,3661^^Gastroenterology|Pathology,3727^^Gastroenterology|Pathology,3658^^Gastroenterology|Pathology,3656^^Gastroenterology|Pathology,3653^^Gastroenterology|Pathology,3650^^Gastroenterology|Pathology,3647^^Gastroenterology|Pathology,3643^^Gastroenterology|Pathology,3641^^Gastroenterology|Pathology,3768^^Gastroenterology|Pathology,3639^^Gastroenterology|Pathology,3601^^Gastroenterology|Pathology,3765^^Gastroenterology|Pathology,3722^^Gastroenterology|Pathology,3636^^Gastroenterology|Pathology,3631^^Gastroenterology|Pathology,3763^^Gastroenterology|Pathology,3720^^Gastroenterology|Pathology,3627^^Gastroenterology|Pathology,"
        },
        {
          id: "3922^^Gastroenterology|Pharmacology,3919^^Gastroenterology|Pharmacology,3914^^Gastroenterology|Pharmacology,3911^^Gastroenterology|Pharmacology,3908^^Gastroenterology|Pharmacology,3906^^Gastroenterology|Pharmacology,3904^^Gastroenterology|Pharmacology,3901^^Gastroenterology|Pharmacology,3954^^Gastroenterology|Pharmacology,3646^^Gastroenterology|Pharmacology,3951^^Gastroenterology|Pharmacology,3948^^Gastroenterology|Pharmacology,3725^^Gastroenterology|Pharmacology,3946^^Gastroenterology|Pharmacology,3943^^Gastroenterology|Pharmacology,3938^^Gastroenterology|Pharmacology,3634^^Gastroenterology|Pharmacology,3936^^Gastroenterology|Pharmacology,3835^^Gastroenterology|Pharmacology,3934^^Gastroenterology|Pharmacology,3925^^Gastroenterology|Pharmacology,",
          qidArray: [
            "3922",
            "3919",
            "3914",
            "3911",
            "3908",
            "3906",
            "3904",
            "3901",
            "3954",
            "3646",
            "3951",
            "3948",
            "3725",
            "3946",
            "3943",
            "3938",
            "3634",
            "3936",
            "3835",
            "3934",
            "3925"
          ],
          TotalQuestionsCount: 21,
          name: "Gastroenterology-Pharmacology(21)",
          qidsEncodedPatternString: "3922^^Gastroenterology|Pharmacology,3919^^Gastroenterology|Pharmacology,3914^^Gastroenterology|Pharmacology,3911^^Gastroenterology|Pharmacology,3908^^Gastroenterology|Pharmacology,3906^^Gastroenterology|Pharmacology,3904^^Gastroenterology|Pharmacology,3901^^Gastroenterology|Pharmacology,3954^^Gastroenterology|Pharmacology,3646^^Gastroenterology|Pharmacology,3951^^Gastroenterology|Pharmacology,3948^^Gastroenterology|Pharmacology,3725^^Gastroenterology|Pharmacology,3946^^Gastroenterology|Pharmacology,3943^^Gastroenterology|Pharmacology,3938^^Gastroenterology|Pharmacology,3634^^Gastroenterology|Pharmacology,3936^^Gastroenterology|Pharmacology,3835^^Gastroenterology|Pharmacology,3934^^Gastroenterology|Pharmacology,3925^^Gastroenterology|Pharmacology,"
        },
        {
          id: "3809^^Gastroenterology|Pathophysiology,3805^^Gastroenterology|Pathophysiology,3802^^Gastroenterology|Pathophysiology,3799^^Gastroenterology|Pathophysiology,3797^^Gastroenterology|Pathophysiology,3795^^Gastroenterology|Pathophysiology,3793^^Gastroenterology|Pathophysiology,3791^^Gastroenterology|Pathophysiology,3832^^Gastroenterology|Pathophysiology,3829^^Gastroenterology|Pathophysiology,3826^^Gastroenterology|Pathophysiology,3823^^Gastroenterology|Pathophysiology,3820^^Gastroenterology|Pathophysiology,3818^^Gastroenterology|Pathophysiology,3788^^Gastroenterology|Pathophysiology,3814^^Gastroenterology|Pathophysiology,3812^^Gastroenterology|Pathophysiology,",
          qidArray: [
            "3809",
            "3805",
            "3802",
            "3799",
            "3797",
            "3795",
            "3793",
            "3791",
            "3832",
            "3829",
            "3826",
            "3823",
            "3820",
            "3818",
            "3788",
            "3814",
            "3812"
          ],
          TotalQuestionsCount: 17,
          name: "Gastroenterology-Pathophysiology(17)",
          qidsEncodedPatternString: "3809^^Gastroenterology|Pathophysiology,3805^^Gastroenterology|Pathophysiology,3802^^Gastroenterology|Pathophysiology,3799^^Gastroenterology|Pathophysiology,3797^^Gastroenterology|Pathophysiology,3795^^Gastroenterology|Pathophysiology,3793^^Gastroenterology|Pathophysiology,3791^^Gastroenterology|Pathophysiology,3832^^Gastroenterology|Pathophysiology,3829^^Gastroenterology|Pathophysiology,3826^^Gastroenterology|Pathophysiology,3823^^Gastroenterology|Pathophysiology,3820^^Gastroenterology|Pathophysiology,3818^^Gastroenterology|Pathophysiology,3788^^Gastroenterology|Pathophysiology,3814^^Gastroenterology|Pathophysiology,3812^^Gastroenterology|Pathophysiology,"
        },
        {
          id: "3973^^Gastroenterology|Physiology,3969^^Gastroenterology|Physiology,3967^^Gastroenterology|Physiology,3964^^Gastroenterology|Physiology,3961^^Gastroenterology|Physiology,3959^^Gastroenterology|Physiology,3957^^Gastroenterology|Physiology,",
          qidArray: [
            "3973",
            "3969",
            "3967",
            "3964",
            "3961",
            "3959",
            "3957"
          ],
          TotalQuestionsCount: 7,
          name: "Gastroenterology-Physiology(7)",
          qidsEncodedPatternString: "3973^^Gastroenterology|Physiology,3969^^Gastroenterology|Physiology,3967^^Gastroenterology|Physiology,3964^^Gastroenterology|Physiology,3961^^Gastroenterology|Physiology,3959^^Gastroenterology|Physiology,3957^^Gastroenterology|Physiology,"
        }
      ],
      id: 10296,
      isParent: true,
      TotalQuestionsCount: 148,
      name: "Gastroenterology"
    },
    {
      children: [
        {
          id: "4576^^Genitourinary|Anatomy,4573^^Genitourinary|Anatomy,4571^^Genitourinary|Anatomy,4568^^Genitourinary|Anatomy,4563^^Genitourinary|Anatomy,4559^^Genitourinary|Anatomy,4556^^Genitourinary|Anatomy,4553^^Genitourinary|Anatomy,4550^^Genitourinary|Anatomy,",
          qidArray: [
            "4576",
            "4573",
            "4571",
            "4568",
            "4563",
            "4559",
            "4556",
            "4553",
            "4550"
          ],
          TotalQuestionsCount: 9,
          name: "Genitourinary-Anatomy(9)",
          qidsEncodedPatternString: "4576^^Genitourinary|Anatomy,4573^^Genitourinary|Anatomy,4571^^Genitourinary|Anatomy,4568^^Genitourinary|Anatomy,4563^^Genitourinary|Anatomy,4559^^Genitourinary|Anatomy,4556^^Genitourinary|Anatomy,4553^^Genitourinary|Anatomy,4550^^Genitourinary|Anatomy,"
        },
        {
          id: "4594^^Genitourinary|Embryology,4590^^Genitourinary|Embryology,4587^^Genitourinary|Embryology,4584^^Genitourinary|Embryology,4581^^Genitourinary|Embryology,4579^^Genitourinary|Embryology,",
          qidArray: [
            "4594",
            "4590",
            "4587",
            "4584",
            "4581",
            "4579"
          ],
          TotalQuestionsCount: 6,
          name: "Genitourinary-Embryology(6)",
          qidsEncodedPatternString: "4594^^Genitourinary|Embryology,4590^^Genitourinary|Embryology,4587^^Genitourinary|Embryology,4584^^Genitourinary|Embryology,4581^^Genitourinary|Embryology,4579^^Genitourinary|Embryology,"
        },
        {
          id: "4618^^Genitourinary|Pathology,4616^^Genitourinary|Pathology,4614^^Genitourinary|Pathology,4611^^Genitourinary|Pathology,4606^^Genitourinary|Pathology,4603^^Genitourinary|Pathology,4601^^Genitourinary|Pathology,4653^^Genitourinary|Pathology,4599^^Genitourinary|Pathology,4650^^Genitourinary|Pathology,4648^^Genitourinary|Pathology,4646^^Genitourinary|Pathology,4643^^Genitourinary|Pathology,4641^^Genitourinary|Pathology,4640^^Genitourinary|Pathology,4636^^Genitourinary|Pathology,4634^^Genitourinary|Pathology,4632^^Genitourinary|Pathology,4629^^Genitourinary|Pathology,4625^^Genitourinary|Pathology,4597^^Genitourinary|Pathology,4623^^Genitourinary|Pathology,4621^^Genitourinary|Pathology,",
          qidArray: [
            "4618",
            "4616",
            "4614",
            "4611",
            "4606",
            "4603",
            "4601",
            "4653",
            "4599",
            "4650",
            "4648",
            "4646",
            "4643",
            "4641",
            "4640",
            "4636",
            "4634",
            "4632",
            "4629",
            "4625",
            "4597",
            "4623",
            "4621"
          ],
          TotalQuestionsCount: 23,
          name: "Genitourinary-Pathology(23)",
          qidsEncodedPatternString: "4618^^Genitourinary|Pathology,4616^^Genitourinary|Pathology,4614^^Genitourinary|Pathology,4611^^Genitourinary|Pathology,4606^^Genitourinary|Pathology,4603^^Genitourinary|Pathology,4601^^Genitourinary|Pathology,4653^^Genitourinary|Pathology,4599^^Genitourinary|Pathology,4650^^Genitourinary|Pathology,4648^^Genitourinary|Pathology,4646^^Genitourinary|Pathology,4643^^Genitourinary|Pathology,4641^^Genitourinary|Pathology,4640^^Genitourinary|Pathology,4636^^Genitourinary|Pathology,4634^^Genitourinary|Pathology,4632^^Genitourinary|Pathology,4629^^Genitourinary|Pathology,4625^^Genitourinary|Pathology,4597^^Genitourinary|Pathology,4623^^Genitourinary|Pathology,4621^^Genitourinary|Pathology,"
        },
        {
          id: "4674^^Genitourinary|Pharmacology,4671^^Genitourinary|Pharmacology,4668^^Genitourinary|Pharmacology,4666^^Genitourinary|Pharmacology,4664^^Genitourinary|Pharmacology,4661^^Genitourinary|Pharmacology,4659^^Genitourinary|Pharmacology,4657^^Genitourinary|Pharmacology,4694^^Genitourinary|Pharmacology,4683^^Genitourinary|Pharmacology,4655^^Genitourinary|Pharmacology,4681^^Genitourinary|Pharmacology,4677^^Genitourinary|Pharmacology,4676^^Genitourinary|Pharmacology,",
          qidArray: [
            "4674",
            "4671",
            "4668",
            "4666",
            "4664",
            "4661",
            "4659",
            "4657",
            "4694",
            "4683",
            "4655",
            "4681",
            "4677",
            "4676"
          ],
          TotalQuestionsCount: 14,
          name: "Genitourinary-Pharmacology(14)",
          qidsEncodedPatternString: "4674^^Genitourinary|Pharmacology,4671^^Genitourinary|Pharmacology,4668^^Genitourinary|Pharmacology,4666^^Genitourinary|Pharmacology,4664^^Genitourinary|Pharmacology,4661^^Genitourinary|Pharmacology,4659^^Genitourinary|Pharmacology,4657^^Genitourinary|Pharmacology,4694^^Genitourinary|Pharmacology,4683^^Genitourinary|Pharmacology,4655^^Genitourinary|Pharmacology,4681^^Genitourinary|Pharmacology,4677^^Genitourinary|Pharmacology,4676^^Genitourinary|Pharmacology,"
        },
        {
          id: "4700^^Genitourinary|Physiology,4698^^Genitourinary|Physiology,4696^^Genitourinary|Physiology,",
          qidArray: [
            "4700",
            "4698",
            "4696"
          ],
          TotalQuestionsCount: 3,
          name: "Genitourinary-Physiology(3)",
          qidsEncodedPatternString: "4700^^Genitourinary|Physiology,4698^^Genitourinary|Physiology,4696^^Genitourinary|Physiology,"
        }
      ],
      id: 20035,
      isParent: true,
      TotalQuestionsCount: 55,
      name: "Genitourinary"
    },
    {
      children: [
        {
          id: "4018^^Head and neck|Anatomy,4012^^Head and neck|Anatomy,4001^^Head and neck|Anatomy,3996^^Head and neck|Anatomy,3991^^Head and neck|Anatomy,3987^^Head and neck|Anatomy,3981^^Head and neck|Anatomy,3978^^Head and neck|Anatomy,4029^^Head and neck|Anatomy,4026^^Head and neck|Anatomy,3975^^Head and neck|Anatomy,4024^^Head and neck|Anatomy,4021^^Head and neck|Anatomy,",
          qidArray: [
            "4018",
            "4012",
            "4001",
            "3996",
            "3991",
            "3987",
            "3981",
            "3978",
            "4029",
            "4026",
            "3975",
            "4024",
            "4021"
          ],
          TotalQuestionsCount: 13,
          name: "Head and neck-Anatomy(13)",
          qidsEncodedPatternString: "4018^^Head and neck|Anatomy,4012^^Head and neck|Anatomy,4001^^Head and neck|Anatomy,3996^^Head and neck|Anatomy,3991^^Head and neck|Anatomy,3987^^Head and neck|Anatomy,3981^^Head and neck|Anatomy,3978^^Head and neck|Anatomy,4029^^Head and neck|Anatomy,4026^^Head and neck|Anatomy,3975^^Head and neck|Anatomy,4024^^Head and neck|Anatomy,4021^^Head and neck|Anatomy,"
        },
        {
          id: "4039^^Head and neck|Embryology,4037^^Head and neck|Embryology,4032^^Head and neck|Embryology,",
          qidArray: [
            "4039",
            "4037",
            "4032"
          ],
          TotalQuestionsCount: 3,
          name: "Head and neck-Embryology(3)",
          qidsEncodedPatternString: "4039^^Head and neck|Embryology,4037^^Head and neck|Embryology,4032^^Head and neck|Embryology,"
        },
        {
          id: "4058^^Head and neck|Pathology,4056^^Head and neck|Pathology,4053^^Head and neck|Pathology,4050^^Head and neck|Pathology,4047^^Head and neck|Pathology,4044^^Head and neck|Pathology,4042^^Head and neck|Pathology,",
          qidArray: [
            "4058",
            "4056",
            "4053",
            "4050",
            "4047",
            "4044",
            "4042"
          ],
          TotalQuestionsCount: 7,
          name: "Head and neck-Pathology(7)",
          qidsEncodedPatternString: "4058^^Head and neck|Pathology,4056^^Head and neck|Pathology,4053^^Head and neck|Pathology,4050^^Head and neck|Pathology,4047^^Head and neck|Pathology,4044^^Head and neck|Pathology,4042^^Head and neck|Pathology,"
        },
        {
          id: "4082^^Head and neck|Pharmacology,4079^^Head and neck|Pharmacology,4075^^Head and neck|Pharmacology,4072^^Head and neck|Pharmacology,4069^^Head and neck|Pharmacology,4067^^Head and neck|Pharmacology,4066^^Head and neck|Pharmacology,4064^^Head and neck|Pharmacology,4102^^Head and neck|Pharmacology,4062^^Head and neck|Pharmacology,4097^^Head and neck|Pharmacology,4094^^Head and neck|Pharmacology,",
          qidArray: [
            "4082",
            "4079",
            "4075",
            "4072",
            "4069",
            "4067",
            "4066",
            "4064",
            "4102",
            "4062",
            "4097",
            "4094"
          ],
          TotalQuestionsCount: 12,
          name: "Head and neck-Pharmacology(12)",
          qidsEncodedPatternString: "4082^^Head and neck|Pharmacology,4079^^Head and neck|Pharmacology,4075^^Head and neck|Pharmacology,4072^^Head and neck|Pharmacology,4069^^Head and neck|Pharmacology,4067^^Head and neck|Pharmacology,4066^^Head and neck|Pharmacology,4064^^Head and neck|Pharmacology,4102^^Head and neck|Pharmacology,4062^^Head and neck|Pharmacology,4097^^Head and neck|Pharmacology,4094^^Head and neck|Pharmacology,"
        },
        {
          id: "4107^^Head and neck|Physiology,4104^^Head and neck|Physiology,",
          qidArray: [
            "4107",
            "4104"
          ],
          TotalQuestionsCount: 2,
          name: "Head and neck-Physiology(2)",
          qidsEncodedPatternString: "4107^^Head and neck|Physiology,4104^^Head and neck|Physiology,"
        }
      ],
      id: 26107,
      isParent: true,
      TotalQuestionsCount: 37,
      name: "Head and neck"
    },
    {
      children: [
        {
          id: "3068^^Hematology|Histology,",
          qidArray: [
            "3068"
          ],
          TotalQuestionsCount: 1,
          name: "Hematology-Histology(1)",
          qidsEncodedPatternString: "3068^^Hematology|Histology,"
        },
        {
          id: "3100^^Hematology|Pathology,3098^^Hematology|Pathology,3094^^Hematology|Pathology,3092^^Hematology|Pathology,3090^^Hematology|Pathology,3213^^Hematology|Pathology,3086^^Hematology|Pathology,3211^^Hematology|Pathology,3209^^Hematology|Pathology,3205^^Hematology|Pathology,3202^^Hematology|Pathology,3198^^Hematology|Pathology,3193^^Hematology|Pathology,3191^^Hematology|Pathology,3187^^Hematology|Pathology,3185^^Hematology|Pathology,3180^^Hematology|Pathology,3082^^Hematology|Pathology,3176^^Hematology|Pathology,3174^^Hematology|Pathology,3172^^Hematology|Pathology,3169^^Hematology|Pathology,3167^^Hematology|Pathology,3163^^Hematology|Pathology,3160^^Hematology|Pathology,3157^^Hematology|Pathology,3155^^Hematology|Pathology,3150^^Hematology|Pathology,3079^^Hematology|Pathology,3146^^Hematology|Pathology,3142^^Hematology|Pathology,3138^^Hematology|Pathology,3130^^Hematology|Pathology,3128^^Hematology|Pathology,3125^^Hematology|Pathology,3122^^Hematology|Pathology,3119^^Hematology|Pathology,3117^^Hematology|Pathology,3115^^Hematology|Pathology,3077^^Hematology|Pathology,3111^^Hematology|Pathology,3109^^Hematology|Pathology,3106^^Hematology|Pathology,3102^^Hematology|Pathology,",
          qidArray: [
            "3100",
            "3098",
            "3094",
            "3092",
            "3090",
            "3213",
            "3086",
            "3211",
            "3209",
            "3205",
            "3202",
            "3198",
            "3193",
            "3191",
            "3187",
            "3185",
            "3180",
            "3082",
            "3176",
            "3174",
            "3172",
            "3169",
            "3167",
            "3163",
            "3160",
            "3157",
            "3155",
            "3150",
            "3079",
            "3146",
            "3142",
            "3138",
            "3130",
            "3128",
            "3125",
            "3122",
            "3119",
            "3117",
            "3115",
            "3077",
            "3111",
            "3109",
            "3106",
            "3102"
          ],
          TotalQuestionsCount: 44,
          name: "Hematology-Pathology(44)",
          qidsEncodedPatternString: "3100^^Hematology|Pathology,3098^^Hematology|Pathology,3094^^Hematology|Pathology,3092^^Hematology|Pathology,3090^^Hematology|Pathology,3213^^Hematology|Pathology,3086^^Hematology|Pathology,3211^^Hematology|Pathology,3209^^Hematology|Pathology,3205^^Hematology|Pathology,3202^^Hematology|Pathology,3198^^Hematology|Pathology,3193^^Hematology|Pathology,3191^^Hematology|Pathology,3187^^Hematology|Pathology,3185^^Hematology|Pathology,3180^^Hematology|Pathology,3082^^Hematology|Pathology,3176^^Hematology|Pathology,3174^^Hematology|Pathology,3172^^Hematology|Pathology,3169^^Hematology|Pathology,3167^^Hematology|Pathology,3163^^Hematology|Pathology,3160^^Hematology|Pathology,3157^^Hematology|Pathology,3155^^Hematology|Pathology,3150^^Hematology|Pathology,3079^^Hematology|Pathology,3146^^Hematology|Pathology,3142^^Hematology|Pathology,3138^^Hematology|Pathology,3130^^Hematology|Pathology,3128^^Hematology|Pathology,3125^^Hematology|Pathology,3122^^Hematology|Pathology,3119^^Hematology|Pathology,3117^^Hematology|Pathology,3115^^Hematology|Pathology,3077^^Hematology|Pathology,3111^^Hematology|Pathology,3109^^Hematology|Pathology,3106^^Hematology|Pathology,3102^^Hematology|Pathology,"
        },
        {
          id: "3281^^Hematology|Pharmacology,3278^^Hematology|Pharmacology,3274^^Hematology|Pharmacology,3272^^Hematology|Pharmacology,3268^^Hematology|Pharmacology,3265^^Hematology|Pharmacology,3262^^Hematology|Pharmacology,3339^^Hematology|Pharmacology,3337^^Hematology|Pharmacology,3334^^Hematology|Pharmacology,3330^^Hematology|Pharmacology,3259^^Hematology|Pharmacology,3328^^Hematology|Pharmacology,3324^^Hematology|Pharmacology,3321^^Hematology|Pharmacology,3317^^Hematology|Pharmacology,3313^^Hematology|Pharmacology,3309^^Hematology|Pharmacology,3307^^Hematology|Pharmacology,3305^^Hematology|Pharmacology,3303^^Hematology|Pharmacology,3300^^Hematology|Pharmacology,3256^^Hematology|Pharmacology,3297^^Hematology|Pharmacology,3294^^Hematology|Pharmacology,3283^^Hematology|Pharmacology,",
          qidArray: [
            "3281",
            "3278",
            "3274",
            "3272",
            "3268",
            "3265",
            "3262",
            "3339",
            "3337",
            "3334",
            "3330",
            "3259",
            "3328",
            "3324",
            "3321",
            "3317",
            "3313",
            "3309",
            "3307",
            "3305",
            "3303",
            "3300",
            "3256",
            "3297",
            "3294",
            "3283"
          ],
          TotalQuestionsCount: 26,
          name: "Hematology-Pharmacology(26)",
          qidsEncodedPatternString: "3281^^Hematology|Pharmacology,3278^^Hematology|Pharmacology,3274^^Hematology|Pharmacology,3272^^Hematology|Pharmacology,3268^^Hematology|Pharmacology,3265^^Hematology|Pharmacology,3262^^Hematology|Pharmacology,3339^^Hematology|Pharmacology,3337^^Hematology|Pharmacology,3334^^Hematology|Pharmacology,3330^^Hematology|Pharmacology,3259^^Hematology|Pharmacology,3328^^Hematology|Pharmacology,3324^^Hematology|Pharmacology,3321^^Hematology|Pharmacology,3317^^Hematology|Pharmacology,3313^^Hematology|Pharmacology,3309^^Hematology|Pharmacology,3307^^Hematology|Pharmacology,3305^^Hematology|Pharmacology,3303^^Hematology|Pharmacology,3300^^Hematology|Pharmacology,3256^^Hematology|Pharmacology,3297^^Hematology|Pharmacology,3294^^Hematology|Pharmacology,3283^^Hematology|Pharmacology,"
        },
        {
          id: "6234^^Hematology|Physiology,6230^^Hematology|Physiology,6227^^Hematology|Physiology,6224^^Hematology|Physiology,6221^^Hematology|Physiology,",
          qidArray: [
            "6234",
            "6230",
            "6227",
            "6224",
            "6221"
          ],
          TotalQuestionsCount: 5,
          name: "Hematology-Physiology(5)",
          qidsEncodedPatternString: "6234^^Hematology|Physiology,6230^^Hematology|Physiology,6227^^Hematology|Physiology,6224^^Hematology|Physiology,6221^^Hematology|Physiology,"
        },
        {
          id: "3244^^Hematology|Pathophysiology,3241^^Hematology|Pathophysiology,3237^^Hematology|Pathophysiology,3234^^Hematology|Pathophysiology,3229^^Hematology|Pathophysiology,3227^^Hematology|Pathophysiology,3224^^Hematology|Pathophysiology,3220^^Hematology|Pathophysiology,3215^^Hematology|Pathophysiology,3247^^Hematology|Pathophysiology,",
          qidArray: [
            "3244",
            "3241",
            "3237",
            "3234",
            "3229",
            "3227",
            "3224",
            "3220",
            "3215",
            "3247"
          ],
          TotalQuestionsCount: 10,
          name: "Hematology-Pathophysiology(10)",
          qidsEncodedPatternString: "3244^^Hematology|Pathophysiology,3241^^Hematology|Pathophysiology,3237^^Hematology|Pathophysiology,3234^^Hematology|Pathophysiology,3229^^Hematology|Pathophysiology,3227^^Hematology|Pathophysiology,3224^^Hematology|Pathophysiology,3220^^Hematology|Pathophysiology,3215^^Hematology|Pathophysiology,3247^^Hematology|Pathophysiology,"
        }
      ],
      id: 28397,
      isParent: true,
      TotalQuestionsCount: 86,
      name: "Hematology"
    },
    {
      children: [
        {
          id: "4703^^Hepatology|Anatomy,",
          qidArray: [
            "4703"
          ],
          TotalQuestionsCount: 1,
          name: "Hepatology-Anatomy(1)",
          qidsEncodedPatternString: "4703^^Hepatology|Anatomy,"
        },
        {
          id: "4707^^Hepatology|Histology,",
          qidArray: [
            "4707"
          ],
          TotalQuestionsCount: 1,
          name: "Hepatology-Histology(1)",
          qidsEncodedPatternString: "4707^^Hepatology|Histology,"
        },
        {
          id: "4731^^Hepatology|Pathology,4729^^Hepatology|Pathology,4726^^Hepatology|Pathology,4723^^Hepatology|Pathology,4721^^Hepatology|Pathology,4718^^Hepatology|Pathology,4808^^Hepatology|Pathology,4805^^Hepatology|Pathology,4801^^Hepatology|Pathology,4799^^Hepatology|Pathology,4796^^Hepatology|Pathology,4715^^Hepatology|Pathology,4794^^Hepatology|Pathology,4792^^Hepatology|Pathology,4790^^Hepatology|Pathology,4787^^Hepatology|Pathology,4785^^Hepatology|Pathology,4783^^Hepatology|Pathology,4779^^Hepatology|Pathology,4777^^Hepatology|Pathology,4774^^Hepatology|Pathology,4772^^Hepatology|Pathology,4711^^Hepatology|Pathology,4770^^Hepatology|Pathology,4767^^Hepatology|Pathology,4765^^Hepatology|Pathology,4762^^Hepatology|Pathology,4758^^Hepatology|Pathology,4754^^Hepatology|Pathology,4752^^Hepatology|Pathology,4750^^Hepatology|Pathology,4748^^Hepatology|Pathology,4746^^Hepatology|Pathology,4709^^Hepatology|Pathology,4743^^Hepatology|Pathology,4740^^Hepatology|Pathology,4736^^Hepatology|Pathology,4734^^Hepatology|Pathology,",
          qidArray: [
            "4731",
            "4729",
            "4726",
            "4723",
            "4721",
            "4718",
            "4808",
            "4805",
            "4801",
            "4799",
            "4796",
            "4715",
            "4794",
            "4792",
            "4790",
            "4787",
            "4785",
            "4783",
            "4779",
            "4777",
            "4774",
            "4772",
            "4711",
            "4770",
            "4767",
            "4765",
            "4762",
            "4758",
            "4754",
            "4752",
            "4750",
            "4748",
            "4746",
            "4709",
            "4743",
            "4740",
            "4736",
            "4734"
          ],
          TotalQuestionsCount: 38,
          name: "Hepatology-Pathology(38)",
          qidsEncodedPatternString: "4731^^Hepatology|Pathology,4729^^Hepatology|Pathology,4726^^Hepatology|Pathology,4723^^Hepatology|Pathology,4721^^Hepatology|Pathology,4718^^Hepatology|Pathology,4808^^Hepatology|Pathology,4805^^Hepatology|Pathology,4801^^Hepatology|Pathology,4799^^Hepatology|Pathology,4796^^Hepatology|Pathology,4715^^Hepatology|Pathology,4794^^Hepatology|Pathology,4792^^Hepatology|Pathology,4790^^Hepatology|Pathology,4787^^Hepatology|Pathology,4785^^Hepatology|Pathology,4783^^Hepatology|Pathology,4779^^Hepatology|Pathology,4777^^Hepatology|Pathology,4774^^Hepatology|Pathology,4772^^Hepatology|Pathology,4711^^Hepatology|Pathology,4770^^Hepatology|Pathology,4767^^Hepatology|Pathology,4765^^Hepatology|Pathology,4762^^Hepatology|Pathology,4758^^Hepatology|Pathology,4754^^Hepatology|Pathology,4752^^Hepatology|Pathology,4750^^Hepatology|Pathology,4748^^Hepatology|Pathology,4746^^Hepatology|Pathology,4709^^Hepatology|Pathology,4743^^Hepatology|Pathology,4740^^Hepatology|Pathology,4736^^Hepatology|Pathology,4734^^Hepatology|Pathology,"
        },
        {
          id: "4853^^Hepatology|Pharmacology,4851^^Hepatology|Pharmacology,4846^^Hepatology|Pharmacology,4843^^Hepatology|Pharmacology,4840^^Hepatology|Pharmacology,4838^^Hepatology|Pharmacology,4835^^Hepatology|Pharmacology,4832^^Hepatology|Pharmacology,4830^^Hepatology|Pharmacology,4855^^Hepatology|Pharmacology,",
          qidArray: [
            "4853",
            "4851",
            "4846",
            "4843",
            "4840",
            "4838",
            "4835",
            "4832",
            "4830",
            "4855"
          ],
          TotalQuestionsCount: 10,
          name: "Hepatology-Pharmacology(10)",
          qidsEncodedPatternString: "4853^^Hepatology|Pharmacology,4851^^Hepatology|Pharmacology,4846^^Hepatology|Pharmacology,4843^^Hepatology|Pharmacology,4840^^Hepatology|Pharmacology,4838^^Hepatology|Pharmacology,4835^^Hepatology|Pharmacology,4832^^Hepatology|Pharmacology,4830^^Hepatology|Pharmacology,4855^^Hepatology|Pharmacology,"
        },
        {
          id: "4827^^Hepatology|Pathophysiology,4824^^Hepatology|Pathophysiology,4821^^Hepatology|Pathophysiology,4819^^Hepatology|Pathophysiology,4817^^Hepatology|Pathophysiology,4813^^Hepatology|Pathophysiology,4810^^Hepatology|Pathophysiology,",
          qidArray: [
            "4827",
            "4824",
            "4821",
            "4819",
            "4817",
            "4813",
            "4810"
          ],
          TotalQuestionsCount: 7,
          name: "Hepatology-Pathophysiology(7)",
          qidsEncodedPatternString: "4827^^Hepatology|Pathophysiology,4824^^Hepatology|Pathophysiology,4821^^Hepatology|Pathophysiology,4819^^Hepatology|Pathophysiology,4817^^Hepatology|Pathophysiology,4813^^Hepatology|Pathophysiology,4810^^Hepatology|Pathophysiology,"
        }
      ],
      id: 56489,
      isParent: true,
      TotalQuestionsCount: 57,
      name: "Hepatology"
    },
    {
      children: [
        {
          id: "7301^^Immunology|Immunology,7297^^Immunology|Immunology,7293^^Immunology|Immunology,7287^^Immunology|Immunology,7283^^Immunology|Immunology,7281^^Immunology|Immunology,7459^^Immunology|Immunology,7450^^Immunology|Immunology,7448^^Immunology|Immunology,7442^^Immunology|Immunology,7438^^Immunology|Immunology,7434^^Immunology|Immunology,7431^^Immunology|Immunology,7424^^Immunology|Immunology,7422^^Immunology|Immunology,7370^^Immunology|Immunology,7277^^Immunology|Immunology,7366^^Immunology|Immunology,7364^^Immunology|Immunology,7362^^Immunology|Immunology,7360^^Immunology|Immunology,7357^^Immunology|Immunology,7355^^Immunology|Immunology,7351^^Immunology|Immunology,7349^^Immunology|Immunology,7347^^Immunology|Immunology,7343^^Immunology|Immunology,7273^^Immunology|Immunology,7340^^Immunology|Immunology,7338^^Immunology|Immunology,7677^^Immunology|Immunology,7335^^Immunology|Immunology,7675^^Immunology|Immunology,7331^^Immunology|Immunology,7514^^Immunology|Immunology,7328^^Immunology|Immunology,7512^^Immunology|Immunology,7325^^Immunology|Immunology,7510^^Immunology|Immunology,7323^^Immunology|Immunology,7508^^Immunology|Immunology,7321^^Immunology|Immunology,7505^^Immunology|Immunology,7318^^Immunology|Immunology,7673^^Immunology|Immunology,7502^^Immunology|Immunology,7315^^Immunology|Immunology,7670^^Immunology|Immunology,7270^^Immunology|Immunology,7666^^Immunology|Immunology,7664^^Immunology|Immunology,7662^^Immunology|Immunology,7660^^Immunology|Immunology,7656^^Immunology|Immunology,7654^^Immunology|Immunology,7652^^Immunology|Immunology,7649^^Immunology|Immunology,7644^^Immunology|Immunology,7500^^Immunology|Immunology,7313^^Immunology|Immunology,7641^^Immunology|Immunology,7638^^Immunology|Immunology,7635^^Immunology|Immunology,7633^^Immunology|Immunology,7631^^Immunology|Immunology,7627^^Immunology|Immunology,7624^^Immunology|Immunology,7616^^Immunology|Immunology,7608^^Immunology|Immunology,7602^^Immunology|Immunology,7497^^Immunology|Immunology,7310^^Immunology|Immunology,7597^^Immunology|Immunology,7595^^Immunology|Immunology,7562^^Immunology|Immunology,7560^^Immunology|Immunology,7556^^Immunology|Immunology,7553^^Immunology|Immunology,7550^^Immunology|Immunology,7547^^Immunology|Immunology,7544^^Immunology|Immunology,7533^^Immunology|Immunology,7495^^Immunology|Immunology,7308^^Immunology|Immunology,7530^^Immunology|Immunology,7527^^Immunology|Immunology,7524^^Immunology|Immunology,7517^^Immunology|Immunology,7304^^Immunology|Immunology,",
          qidArray: [
            "7301",
            "7297",
            "7293",
            "7287",
            "7283",
            "7281",
            "7459",
            "7450",
            "7448",
            "7442",
            "7438",
            "7434",
            "7431",
            "7424",
            "7422",
            "7370",
            "7277",
            "7366",
            "7364",
            "7362",
            "7360",
            "7357",
            "7355",
            "7351",
            "7349",
            "7347",
            "7343",
            "7273",
            "7340",
            "7338",
            "7677",
            "7335",
            "7675",
            "7331",
            "7514",
            "7328",
            "7512",
            "7325",
            "7510",
            "7323",
            "7508",
            "7321",
            "7505",
            "7318",
            "7673",
            "7502",
            "7315",
            "7670",
            "7270",
            "7666",
            "7664",
            "7662",
            "7660",
            "7656",
            "7654",
            "7652",
            "7649",
            "7644",
            "7500",
            "7313",
            "7641",
            "7638",
            "7635",
            "7633",
            "7631",
            "7627",
            "7624",
            "7616",
            "7608",
            "7602",
            "7497",
            "7310",
            "7597",
            "7595",
            "7562",
            "7560",
            "7556",
            "7553",
            "7550",
            "7547",
            "7544",
            "7533",
            "7495",
            "7308",
            "7530",
            "7527",
            "7524",
            "7517",
            "7304"
          ],
          TotalQuestionsCount: 89,
          name: "Immunology-Immunology(89)",
          qidsEncodedPatternString: "7301^^Immunology|Immunology,7297^^Immunology|Immunology,7293^^Immunology|Immunology,7287^^Immunology|Immunology,7283^^Immunology|Immunology,7281^^Immunology|Immunology,7459^^Immunology|Immunology,7450^^Immunology|Immunology,7448^^Immunology|Immunology,7442^^Immunology|Immunology,7438^^Immunology|Immunology,7434^^Immunology|Immunology,7431^^Immunology|Immunology,7424^^Immunology|Immunology,7422^^Immunology|Immunology,7370^^Immunology|Immunology,7277^^Immunology|Immunology,7366^^Immunology|Immunology,7364^^Immunology|Immunology,7362^^Immunology|Immunology,7360^^Immunology|Immunology,7357^^Immunology|Immunology,7355^^Immunology|Immunology,7351^^Immunology|Immunology,7349^^Immunology|Immunology,7347^^Immunology|Immunology,7343^^Immunology|Immunology,7273^^Immunology|Immunology,7340^^Immunology|Immunology,7338^^Immunology|Immunology,7677^^Immunology|Immunology,7335^^Immunology|Immunology,7675^^Immunology|Immunology,7331^^Immunology|Immunology,7514^^Immunology|Immunology,7328^^Immunology|Immunology,7512^^Immunology|Immunology,7325^^Immunology|Immunology,7510^^Immunology|Immunology,7323^^Immunology|Immunology,7508^^Immunology|Immunology,7321^^Immunology|Immunology,7505^^Immunology|Immunology,7318^^Immunology|Immunology,7673^^Immunology|Immunology,7502^^Immunology|Immunology,7315^^Immunology|Immunology,7670^^Immunology|Immunology,7270^^Immunology|Immunology,7666^^Immunology|Immunology,7664^^Immunology|Immunology,7662^^Immunology|Immunology,7660^^Immunology|Immunology,7656^^Immunology|Immunology,7654^^Immunology|Immunology,7652^^Immunology|Immunology,7649^^Immunology|Immunology,7644^^Immunology|Immunology,7500^^Immunology|Immunology,7313^^Immunology|Immunology,7641^^Immunology|Immunology,7638^^Immunology|Immunology,7635^^Immunology|Immunology,7633^^Immunology|Immunology,7631^^Immunology|Immunology,7627^^Immunology|Immunology,7624^^Immunology|Immunology,7616^^Immunology|Immunology,7608^^Immunology|Immunology,7602^^Immunology|Immunology,7497^^Immunology|Immunology,7310^^Immunology|Immunology,7597^^Immunology|Immunology,7595^^Immunology|Immunology,7562^^Immunology|Immunology,7560^^Immunology|Immunology,7556^^Immunology|Immunology,7553^^Immunology|Immunology,7550^^Immunology|Immunology,7547^^Immunology|Immunology,7544^^Immunology|Immunology,7533^^Immunology|Immunology,7495^^Immunology|Immunology,7308^^Immunology|Immunology,7530^^Immunology|Immunology,7527^^Immunology|Immunology,7524^^Immunology|Immunology,7517^^Immunology|Immunology,7304^^Immunology|Immunology,"
        }
      ],
      id: 44738,
      isParent: true,
      TotalQuestionsCount: 89,
      name: "Immunology"
    },
    {
      children: [
        {
          id: "9045^^Microbiology|Microbiology,9040^^Microbiology|Microbiology,9038^^Microbiology|Microbiology,9033^^Microbiology|Microbiology,8878^^Microbiology|Microbiology,8876^^Microbiology|Microbiology,8872^^Microbiology|Microbiology,8866^^Microbiology|Microbiology,8851^^Microbiology|Microbiology,8849^^Microbiology|Microbiology,8847^^Microbiology|Microbiology,9026^^Microbiology|Microbiology,9023^^Microbiology|Microbiology,9020^^Microbiology|Microbiology,8844^^Microbiology|Microbiology,9013^^Microbiology|Microbiology,9010^^Microbiology|Microbiology,9004^^Microbiology|Microbiology,9002^^Microbiology|Microbiology,8999^^Microbiology|Microbiology,8997^^Microbiology|Microbiology,8993^^Microbiology|Microbiology,8932^^Microbiology|Microbiology,8926^^Microbiology|Microbiology,8922^^Microbiology|Microbiology,8841^^Microbiology|Microbiology,8904^^Microbiology|Microbiology,8895^^Microbiology|Microbiology,8883^^Microbiology|Microbiology,8648^^Microbiology|Microbiology,8645^^Microbiology|Microbiology,8643^^Microbiology|Microbiology,8641^^Microbiology|Microbiology,8637^^Microbiology|Microbiology,8629^^Microbiology|Microbiology,8834^^Microbiology|Microbiology,8830^^Microbiology|Microbiology,4935^^Microbiology|Microbiology,8827^^Microbiology|Microbiology,8815^^Microbiology|Microbiology,8811^^Microbiology|Microbiology,8809^^Microbiology|Microbiology,8806^^Microbiology|Microbiology,8803^^Microbiology|Microbiology,8787^^Microbiology|Microbiology,8780^^Microbiology|Microbiology,8624^^Microbiology|Microbiology,8776^^Microbiology|Microbiology,8774^^Microbiology|Microbiology,8765^^Microbiology|Microbiology,8738^^Microbiology|Microbiology,8735^^Microbiology|Microbiology,8733^^Microbiology|Microbiology,8730^^Microbiology|Microbiology,8726^^Microbiology|Microbiology,8716^^Microbiology|Microbiology,8714^^Microbiology|Microbiology,8622^^Microbiology|Microbiology,8712^^Microbiology|Microbiology,8710^^Microbiology|Microbiology,8707^^Microbiology|Microbiology,8696^^Microbiology|Microbiology,8694^^Microbiology|Microbiology,8684^^Microbiology|Microbiology,8681^^Microbiology|Microbiology,8674^^Microbiology|Microbiology,8668^^Microbiology|Microbiology,8666^^Microbiology|Microbiology,8620^^Microbiology|Microbiology,8664^^Microbiology|Microbiology,8662^^Microbiology|Microbiology,8659^^Microbiology|Microbiology,8651^^Microbiology|Microbiology,8083^^Microbiology|Microbiology,8075^^Microbiology|Microbiology,8071^^Microbiology|Microbiology,8065^^Microbiology|Microbiology,8053^^Microbiology|Microbiology,8047^^Microbiology|Microbiology,4932^^Microbiology|Microbiology,8550^^Microbiology|Microbiology,8546^^Microbiology|Microbiology,8543^^Microbiology|Microbiology,8541^^Microbiology|Microbiology,8538^^Microbiology|Microbiology,8536^^Microbiology|Microbiology,8481^^Microbiology|Microbiology,8470^^Microbiology|Microbiology,8044^^Microbiology|Microbiology,8468^^Microbiology|Microbiology,8463^^Microbiology|Microbiology,8459^^Microbiology|Microbiology,8406^^Microbiology|Microbiology,8403^^Microbiology|Microbiology,8401^^Microbiology|Microbiology,8398^^Microbiology|Microbiology,8395^^Microbiology|Microbiology,8392^^Microbiology|Microbiology,8389^^Microbiology|Microbiology,8040^^Microbiology|Microbiology,8386^^Microbiology|Microbiology,8384^^Microbiology|Microbiology,8380^^Microbiology|Microbiology,8289^^Microbiology|Microbiology,8286^^Microbiology|Microbiology,8281^^Microbiology|Microbiology,8273^^Microbiology|Microbiology,8268^^Microbiology|Microbiology,8265^^Microbiology|Microbiology,8258^^Microbiology|Microbiology,8038^^Microbiology|Microbiology,8255^^Microbiology|Microbiology,8250^^Microbiology|Microbiology,8246^^Microbiology|Microbiology,8224^^Microbiology|Microbiology,8088^^Microbiology|Microbiology,7742^^Microbiology|Microbiology,7740^^Microbiology|Microbiology,7737^^Microbiology|Microbiology,7691^^Microbiology|Microbiology,7689^^Microbiology|Microbiology,7686^^Microbiology|Microbiology,8009^^Microbiology|Microbiology,8005^^Microbiology|Microbiology,8002^^Microbiology|Microbiology,7998^^Microbiology|Microbiology,7995^^Microbiology|Microbiology,7992^^Microbiology|Microbiology,7990^^Microbiology|Microbiology,7987^^Microbiology|Microbiology,7985^^Microbiology|Microbiology,7684^^Microbiology|Microbiology,7983^^Microbiology|Microbiology,7980^^Microbiology|Microbiology,7940^^Microbiology|Microbiology,7846^^Microbiology|Microbiology,7841^^Microbiology|Microbiology,7836^^Microbiology|Microbiology,7832^^Microbiology|Microbiology,7826^^Microbiology|Microbiology,7820^^Microbiology|Microbiology,7817^^Microbiology|Microbiology,7682^^Microbiology|Microbiology,7815^^Microbiology|Microbiology,7811^^Microbiology|Microbiology,7803^^Microbiology|Microbiology,7785^^Microbiology|Microbiology,7782^^Microbiology|Microbiology,7773^^Microbiology|Microbiology,7770^^Microbiology|Microbiology,7768^^Microbiology|Microbiology,7758^^Microbiology|Microbiology,7756^^Microbiology|Microbiology,7679^^Microbiology|Microbiology,7752^^Microbiology|Microbiology,7750^^Microbiology|Microbiology,7748^^Microbiology|Microbiology,7746^^Microbiology|Microbiology,",
          qidArray: [
            "9045",
            "9040",
            "9038",
            "9033",
            "8878",
            "8876",
            "8872",
            "8866",
            "8851",
            "8849",
            "8847",
            "9026",
            "9023",
            "9020",
            "8844",
            "9013",
            "9010",
            "9004",
            "9002",
            "8999",
            "8997",
            "8993",
            "8932",
            "8926",
            "8922",
            "8841",
            "8904",
            "8895",
            "8883",
            "8648",
            "8645",
            "8643",
            "8641",
            "8637",
            "8629",
            "8834",
            "8830",
            "4935",
            "8827",
            "8815",
            "8811",
            "8809",
            "8806",
            "8803",
            "8787",
            "8780",
            "8624",
            "8776",
            "8774",
            "8765",
            "8738",
            "8735",
            "8733",
            "8730",
            "8726",
            "8716",
            "8714",
            "8622",
            "8712",
            "8710",
            "8707",
            "8696",
            "8694",
            "8684",
            "8681",
            "8674",
            "8668",
            "8666",
            "8620",
            "8664",
            "8662",
            "8659",
            "8651",
            "8083",
            "8075",
            "8071",
            "8065",
            "8053",
            "8047",
            "4932",
            "8550",
            "8546",
            "8543",
            "8541",
            "8538",
            "8536",
            "8481",
            "8470",
            "8044",
            "8468",
            "8463",
            "8459",
            "8406",
            "8403",
            "8401",
            "8398",
            "8395",
            "8392",
            "8389",
            "8040",
            "8386",
            "8384",
            "8380",
            "8289",
            "8286",
            "8281",
            "8273",
            "8268",
            "8265",
            "8258",
            "8038",
            "8255",
            "8250",
            "8246",
            "8224",
            "8088",
            "7742",
            "7740",
            "7737",
            "7691",
            "7689",
            "7686",
            "8009",
            "8005",
            "8002",
            "7998",
            "7995",
            "7992",
            "7990",
            "7987",
            "7985",
            "7684",
            "7983",
            "7980",
            "7940",
            "7846",
            "7841",
            "7836",
            "7832",
            "7826",
            "7820",
            "7817",
            "7682",
            "7815",
            "7811",
            "7803",
            "7785",
            "7782",
            "7773",
            "7770",
            "7768",
            "7758",
            "7756",
            "7679",
            "7752",
            "7750",
            "7748",
            "7746"
          ],
          TotalQuestionsCount: 158,
          name: "Microbiology-Microbiology(158)",
          qidsEncodedPatternString: "9045^^Microbiology|Microbiology,9040^^Microbiology|Microbiology,9038^^Microbiology|Microbiology,9033^^Microbiology|Microbiology,8878^^Microbiology|Microbiology,8876^^Microbiology|Microbiology,8872^^Microbiology|Microbiology,8866^^Microbiology|Microbiology,8851^^Microbiology|Microbiology,8849^^Microbiology|Microbiology,8847^^Microbiology|Microbiology,9026^^Microbiology|Microbiology,9023^^Microbiology|Microbiology,9020^^Microbiology|Microbiology,8844^^Microbiology|Microbiology,9013^^Microbiology|Microbiology,9010^^Microbiology|Microbiology,9004^^Microbiology|Microbiology,9002^^Microbiology|Microbiology,8999^^Microbiology|Microbiology,8997^^Microbiology|Microbiology,8993^^Microbiology|Microbiology,8932^^Microbiology|Microbiology,8926^^Microbiology|Microbiology,8922^^Microbiology|Microbiology,8841^^Microbiology|Microbiology,8904^^Microbiology|Microbiology,8895^^Microbiology|Microbiology,8883^^Microbiology|Microbiology,8648^^Microbiology|Microbiology,8645^^Microbiology|Microbiology,8643^^Microbiology|Microbiology,8641^^Microbiology|Microbiology,8637^^Microbiology|Microbiology,8629^^Microbiology|Microbiology,8834^^Microbiology|Microbiology,8830^^Microbiology|Microbiology,4935^^Microbiology|Microbiology,8827^^Microbiology|Microbiology,8815^^Microbiology|Microbiology,8811^^Microbiology|Microbiology,8809^^Microbiology|Microbiology,8806^^Microbiology|Microbiology,8803^^Microbiology|Microbiology,8787^^Microbiology|Microbiology,8780^^Microbiology|Microbiology,8624^^Microbiology|Microbiology,8776^^Microbiology|Microbiology,8774^^Microbiology|Microbiology,8765^^Microbiology|Microbiology,8738^^Microbiology|Microbiology,8735^^Microbiology|Microbiology,8733^^Microbiology|Microbiology,8730^^Microbiology|Microbiology,8726^^Microbiology|Microbiology,8716^^Microbiology|Microbiology,8714^^Microbiology|Microbiology,8622^^Microbiology|Microbiology,8712^^Microbiology|Microbiology,8710^^Microbiology|Microbiology,8707^^Microbiology|Microbiology,8696^^Microbiology|Microbiology,8694^^Microbiology|Microbiology,8684^^Microbiology|Microbiology,8681^^Microbiology|Microbiology,8674^^Microbiology|Microbiology,8668^^Microbiology|Microbiology,8666^^Microbiology|Microbiology,8620^^Microbiology|Microbiology,8664^^Microbiology|Microbiology,8662^^Microbiology|Microbiology,8659^^Microbiology|Microbiology,8651^^Microbiology|Microbiology,8083^^Microbiology|Microbiology,8075^^Microbiology|Microbiology,8071^^Microbiology|Microbiology,8065^^Microbiology|Microbiology,8053^^Microbiology|Microbiology,8047^^Microbiology|Microbiology,4932^^Microbiology|Microbiology,8550^^Microbiology|Microbiology,8546^^Microbiology|Microbiology,8543^^Microbiology|Microbiology,8541^^Microbiology|Microbiology,8538^^Microbiology|Microbiology,8536^^Microbiology|Microbiology,8481^^Microbiology|Microbiology,8470^^Microbiology|Microbiology,8044^^Microbiology|Microbiology,8468^^Microbiology|Microbiology,8463^^Microbiology|Microbiology,8459^^Microbiology|Microbiology,8406^^Microbiology|Microbiology,8403^^Microbiology|Microbiology,8401^^Microbiology|Microbiology,8398^^Microbiology|Microbiology,8395^^Microbiology|Microbiology,8392^^Microbiology|Microbiology,8389^^Microbiology|Microbiology,8040^^Microbiology|Microbiology,8386^^Microbiology|Microbiology,8384^^Microbiology|Microbiology,8380^^Microbiology|Microbiology,8289^^Microbiology|Microbiology,8286^^Microbiology|Microbiology,8281^^Microbiology|Microbiology,8273^^Microbiology|Microbiology,8268^^Microbiology|Microbiology,8265^^Microbiology|Microbiology,8258^^Microbiology|Microbiology,8038^^Microbiology|Microbiology,8255^^Microbiology|Microbiology,8250^^Microbiology|Microbiology,8246^^Microbiology|Microbiology,8224^^Microbiology|Microbiology,8088^^Microbiology|Microbiology,7742^^Microbiology|Microbiology,7740^^Microbiology|Microbiology,7737^^Microbiology|Microbiology,7691^^Microbiology|Microbiology,7689^^Microbiology|Microbiology,7686^^Microbiology|Microbiology,8009^^Microbiology|Microbiology,8005^^Microbiology|Microbiology,8002^^Microbiology|Microbiology,7998^^Microbiology|Microbiology,7995^^Microbiology|Microbiology,7992^^Microbiology|Microbiology,7990^^Microbiology|Microbiology,7987^^Microbiology|Microbiology,7985^^Microbiology|Microbiology,7684^^Microbiology|Microbiology,7983^^Microbiology|Microbiology,7980^^Microbiology|Microbiology,7940^^Microbiology|Microbiology,7846^^Microbiology|Microbiology,7841^^Microbiology|Microbiology,7836^^Microbiology|Microbiology,7832^^Microbiology|Microbiology,7826^^Microbiology|Microbiology,7820^^Microbiology|Microbiology,7817^^Microbiology|Microbiology,7682^^Microbiology|Microbiology,7815^^Microbiology|Microbiology,7811^^Microbiology|Microbiology,7803^^Microbiology|Microbiology,7785^^Microbiology|Microbiology,7782^^Microbiology|Microbiology,7773^^Microbiology|Microbiology,7770^^Microbiology|Microbiology,7768^^Microbiology|Microbiology,7758^^Microbiology|Microbiology,7756^^Microbiology|Microbiology,7679^^Microbiology|Microbiology,7752^^Microbiology|Microbiology,7750^^Microbiology|Microbiology,7748^^Microbiology|Microbiology,7746^^Microbiology|Microbiology,"
        }
      ],
      id: 78825,
      isParent: true,
      TotalQuestionsCount: 158,
      name: "Microbiology"
    },
    {
      children: [
        {
          id: "4893^^Musculoskeletal|Anatomy,4890^^Musculoskeletal|Anatomy,4886^^Musculoskeletal|Anatomy,4883^^Musculoskeletal|Anatomy,4879^^Musculoskeletal|Anatomy,4875^^Musculoskeletal|Anatomy,6961^^Musculoskeletal|Anatomy,6959^^Musculoskeletal|Anatomy,6954^^Musculoskeletal|Anatomy,6951^^Musculoskeletal|Anatomy,4872^^Musculoskeletal|Anatomy,6945^^Musculoskeletal|Anatomy,6940^^Musculoskeletal|Anatomy,6934^^Musculoskeletal|Anatomy,6927^^Musculoskeletal|Anatomy,6921^^Musculoskeletal|Anatomy,6916^^Musculoskeletal|Anatomy,6911^^Musculoskeletal|Anatomy,6906^^Musculoskeletal|Anatomy,6901^^Musculoskeletal|Anatomy,6898^^Musculoskeletal|Anatomy,4868^^Musculoskeletal|Anatomy,6887^^Musculoskeletal|Anatomy,6882^^Musculoskeletal|Anatomy,6878^^Musculoskeletal|Anatomy,6862^^Musculoskeletal|Anatomy,4927^^Musculoskeletal|Anatomy,4923^^Musculoskeletal|Anatomy,4919^^Musculoskeletal|Anatomy,4917^^Musculoskeletal|Anatomy,4916^^Musculoskeletal|Anatomy,4913^^Musculoskeletal|Anatomy,4864^^Musculoskeletal|Anatomy,4909^^Musculoskeletal|Anatomy,4905^^Musculoskeletal|Anatomy,4901^^Musculoskeletal|Anatomy,4898^^Musculoskeletal|Anatomy,",
          qidArray: [
            "4893",
            "4890",
            "4886",
            "4883",
            "4879",
            "4875",
            "6961",
            "6959",
            "6954",
            "6951",
            "4872",
            "6945",
            "6940",
            "6934",
            "6927",
            "6921",
            "6916",
            "6911",
            "6906",
            "6901",
            "6898",
            "4868",
            "6887",
            "6882",
            "6878",
            "6862",
            "4927",
            "4923",
            "4919",
            "4917",
            "4916",
            "4913",
            "4864",
            "4909",
            "4905",
            "4901",
            "4898"
          ],
          TotalQuestionsCount: 37,
          name: "Musculoskeletal-Anatomy(37)",
          qidsEncodedPatternString: "4893^^Musculoskeletal|Anatomy,4890^^Musculoskeletal|Anatomy,4886^^Musculoskeletal|Anatomy,4883^^Musculoskeletal|Anatomy,4879^^Musculoskeletal|Anatomy,4875^^Musculoskeletal|Anatomy,6961^^Musculoskeletal|Anatomy,6959^^Musculoskeletal|Anatomy,6954^^Musculoskeletal|Anatomy,6951^^Musculoskeletal|Anatomy,4872^^Musculoskeletal|Anatomy,6945^^Musculoskeletal|Anatomy,6940^^Musculoskeletal|Anatomy,6934^^Musculoskeletal|Anatomy,6927^^Musculoskeletal|Anatomy,6921^^Musculoskeletal|Anatomy,6916^^Musculoskeletal|Anatomy,6911^^Musculoskeletal|Anatomy,6906^^Musculoskeletal|Anatomy,6901^^Musculoskeletal|Anatomy,6898^^Musculoskeletal|Anatomy,4868^^Musculoskeletal|Anatomy,6887^^Musculoskeletal|Anatomy,6882^^Musculoskeletal|Anatomy,6878^^Musculoskeletal|Anatomy,6862^^Musculoskeletal|Anatomy,4927^^Musculoskeletal|Anatomy,4923^^Musculoskeletal|Anatomy,4919^^Musculoskeletal|Anatomy,4917^^Musculoskeletal|Anatomy,4916^^Musculoskeletal|Anatomy,4913^^Musculoskeletal|Anatomy,4864^^Musculoskeletal|Anatomy,4909^^Musculoskeletal|Anatomy,4905^^Musculoskeletal|Anatomy,4901^^Musculoskeletal|Anatomy,4898^^Musculoskeletal|Anatomy,"
        },
        {
          id: "6973^^Musculoskeletal|Embryology,6966^^Musculoskeletal|Embryology,",
          qidArray: [
            "6973",
            "6966"
          ],
          TotalQuestionsCount: 2,
          name: "Musculoskeletal-Embryology(2)",
          qidsEncodedPatternString: "6973^^Musculoskeletal|Embryology,6966^^Musculoskeletal|Embryology,"
        },
        {
          id: "6985^^Musculoskeletal|Histology,6981^^Musculoskeletal|Histology,",
          qidArray: [
            "6985",
            "6981"
          ],
          TotalQuestionsCount: 2,
          name: "Musculoskeletal-Histology(2)",
          qidsEncodedPatternString: "6985^^Musculoskeletal|Histology,6981^^Musculoskeletal|Histology,"
        },
        {
          id: "7030^^Musculoskeletal|Pathology,7027^^Musculoskeletal|Pathology,7023^^Musculoskeletal|Pathology,7018^^Musculoskeletal|Pathology,7013^^Musculoskeletal|Pathology,7007^^Musculoskeletal|Pathology,7003^^Musculoskeletal|Pathology,7086^^Musculoskeletal|Pathology,7083^^Musculoskeletal|Pathology,7078^^Musculoskeletal|Pathology,7075^^Musculoskeletal|Pathology,6999^^Musculoskeletal|Pathology,6994^^Musculoskeletal|Pathology,7071^^Musculoskeletal|Pathology,7067^^Musculoskeletal|Pathology,7063^^Musculoskeletal|Pathology,7060^^Musculoskeletal|Pathology,7057^^Musculoskeletal|Pathology,7054^^Musculoskeletal|Pathology,7052^^Musculoskeletal|Pathology,7050^^Musculoskeletal|Pathology,7043^^Musculoskeletal|Pathology,7041^^Musculoskeletal|Pathology,6989^^Musculoskeletal|Pathology,7036^^Musculoskeletal|Pathology,7034^^Musculoskeletal|Pathology,7032^^Musculoskeletal|Pathology,",
          qidArray: [
            "7030",
            "7027",
            "7023",
            "7018",
            "7013",
            "7007",
            "7003",
            "7086",
            "7083",
            "7078",
            "7075",
            "6999",
            "6994",
            "7071",
            "7067",
            "7063",
            "7060",
            "7057",
            "7054",
            "7052",
            "7050",
            "7043",
            "7041",
            "6989",
            "7036",
            "7034",
            "7032"
          ],
          TotalQuestionsCount: 27,
          name: "Musculoskeletal-Pathology(27)",
          qidsEncodedPatternString: "7030^^Musculoskeletal|Pathology,7027^^Musculoskeletal|Pathology,7023^^Musculoskeletal|Pathology,7018^^Musculoskeletal|Pathology,7013^^Musculoskeletal|Pathology,7007^^Musculoskeletal|Pathology,7003^^Musculoskeletal|Pathology,7086^^Musculoskeletal|Pathology,7083^^Musculoskeletal|Pathology,7078^^Musculoskeletal|Pathology,7075^^Musculoskeletal|Pathology,6999^^Musculoskeletal|Pathology,6994^^Musculoskeletal|Pathology,7071^^Musculoskeletal|Pathology,7067^^Musculoskeletal|Pathology,7063^^Musculoskeletal|Pathology,7060^^Musculoskeletal|Pathology,7057^^Musculoskeletal|Pathology,7054^^Musculoskeletal|Pathology,7052^^Musculoskeletal|Pathology,7050^^Musculoskeletal|Pathology,7043^^Musculoskeletal|Pathology,7041^^Musculoskeletal|Pathology,6989^^Musculoskeletal|Pathology,7036^^Musculoskeletal|Pathology,7034^^Musculoskeletal|Pathology,7032^^Musculoskeletal|Pathology,"
        },
        {
          id: "7132^^Musculoskeletal|Pathophysiology,7125^^Musculoskeletal|Pathophysiology,7119^^Musculoskeletal|Pathophysiology,7111^^Musculoskeletal|Pathophysiology,7105^^Musculoskeletal|Pathophysiology,7102^^Musculoskeletal|Pathophysiology,7098^^Musculoskeletal|Pathophysiology,7094^^Musculoskeletal|Pathophysiology,7142^^Musculoskeletal|Pathophysiology,7090^^Musculoskeletal|Pathophysiology,7138^^Musculoskeletal|Pathophysiology,",
          qidArray: [
            "7132",
            "7125",
            "7119",
            "7111",
            "7105",
            "7102",
            "7098",
            "7094",
            "7142",
            "7090",
            "7138"
          ],
          TotalQuestionsCount: 11,
          name: "Musculoskeletal-Pathophysiology(11)",
          qidsEncodedPatternString: "7132^^Musculoskeletal|Pathophysiology,7125^^Musculoskeletal|Pathophysiology,7119^^Musculoskeletal|Pathophysiology,7111^^Musculoskeletal|Pathophysiology,7105^^Musculoskeletal|Pathophysiology,7102^^Musculoskeletal|Pathophysiology,7098^^Musculoskeletal|Pathophysiology,7094^^Musculoskeletal|Pathophysiology,7142^^Musculoskeletal|Pathophysiology,7090^^Musculoskeletal|Pathophysiology,7138^^Musculoskeletal|Pathophysiology,"
        },
        {
          id: "7184^^Musculoskeletal|Pharmacology,7182^^Musculoskeletal|Pharmacology,7180^^Musculoskeletal|Pharmacology,7178^^Musculoskeletal|Pharmacology,7175^^Musculoskeletal|Pharmacology,7172^^Musculoskeletal|Pharmacology,7169^^Musculoskeletal|Pharmacology,7223^^Musculoskeletal|Pharmacology,7166^^Musculoskeletal|Pharmacology,7221^^Musculoskeletal|Pharmacology,7217^^Musculoskeletal|Pharmacology,7213^^Musculoskeletal|Pharmacology,7210^^Musculoskeletal|Pharmacology,7208^^Musculoskeletal|Pharmacology,7205^^Musculoskeletal|Pharmacology,7203^^Musculoskeletal|Pharmacology,7200^^Musculoskeletal|Pharmacology,7194^^Musculoskeletal|Pharmacology,7190^^Musculoskeletal|Pharmacology,7145^^Musculoskeletal|Pharmacology,7188^^Musculoskeletal|Pharmacology,7186^^Musculoskeletal|Pharmacology,",
          qidArray: [
            "7184",
            "7182",
            "7180",
            "7178",
            "7175",
            "7172",
            "7169",
            "7223",
            "7166",
            "7221",
            "7217",
            "7213",
            "7210",
            "7208",
            "7205",
            "7203",
            "7200",
            "7194",
            "7190",
            "7145",
            "7188",
            "7186"
          ],
          TotalQuestionsCount: 22,
          name: "Musculoskeletal-Pharmacology(22)",
          qidsEncodedPatternString: "7184^^Musculoskeletal|Pharmacology,7182^^Musculoskeletal|Pharmacology,7180^^Musculoskeletal|Pharmacology,7178^^Musculoskeletal|Pharmacology,7175^^Musculoskeletal|Pharmacology,7172^^Musculoskeletal|Pharmacology,7169^^Musculoskeletal|Pharmacology,7223^^Musculoskeletal|Pharmacology,7166^^Musculoskeletal|Pharmacology,7221^^Musculoskeletal|Pharmacology,7217^^Musculoskeletal|Pharmacology,7213^^Musculoskeletal|Pharmacology,7210^^Musculoskeletal|Pharmacology,7208^^Musculoskeletal|Pharmacology,7205^^Musculoskeletal|Pharmacology,7203^^Musculoskeletal|Pharmacology,7200^^Musculoskeletal|Pharmacology,7194^^Musculoskeletal|Pharmacology,7190^^Musculoskeletal|Pharmacology,7145^^Musculoskeletal|Pharmacology,7188^^Musculoskeletal|Pharmacology,7186^^Musculoskeletal|Pharmacology,"
        },
        {
          id: "7484^^Musculoskeletal|Physiology,7482^^Musculoskeletal|Physiology,7478^^Musculoskeletal|Physiology,7474^^Musculoskeletal|Physiology,",
          qidArray: [
            "7484",
            "7482",
            "7478",
            "7474"
          ],
          TotalQuestionsCount: 4,
          name: "Musculoskeletal-Physiology(4)",
          qidsEncodedPatternString: "7484^^Musculoskeletal|Physiology,7482^^Musculoskeletal|Physiology,7478^^Musculoskeletal|Physiology,7474^^Musculoskeletal|Physiology,"
        }
      ],
      id: 81973,
      isParent: true,
      TotalQuestionsCount: 105,
      name: "Musculoskeletal"
    },
    {
      children: [
        {
          id: "5257^^Neurology|Anatomy,5368^^Neurology|Anatomy,5254^^Neurology|Anatomy,5252^^Neurology|Anatomy,5250^^Neurology|Anatomy,5248^^Neurology|Anatomy,5404^^Neurology|Anatomy,5362^^Neurology|Anatomy,5244^^Neurology|Anatomy,5360^^Neurology|Anatomy,5357^^Neurology|Anatomy,5412^^Neurology|Anatomy,5396^^Neurology|Anatomy,5354^^Neurology|Anatomy,5351^^Neurology|Anatomy,5349^^Neurology|Anatomy,5345^^Neurology|Anatomy,5341^^Neurology|Anatomy,5409^^Neurology|Anatomy,5393^^Neurology|Anatomy,5337^^Neurology|Anatomy,5334^^Neurology|Anatomy,5238^^Neurology|Anatomy,5331^^Neurology|Anatomy,5400^^Neurology|Anatomy,5327^^Neurology|Anatomy,5365^^Neurology|Anatomy,5324^^Neurology|Anatomy,5389^^Neurology|Anatomy,5321^^Neurology|Anatomy,5319^^Neurology|Anatomy,5316^^Neurology|Anatomy,5382^^Neurology|Anatomy,5312^^Neurology|Anatomy,5308^^Neurology|Anatomy,5305^^Neurology|Anatomy,5302^^Neurology|Anatomy,5234^^Neurology|Anatomy,5299^^Neurology|Anatomy,5378^^Neurology|Anatomy,5297^^Neurology|Anatomy,5374^^Neurology|Anatomy,5294^^Neurology|Anatomy,5290^^Neurology|Anatomy,5287^^Neurology|Anatomy,5284^^Neurology|Anatomy,5280^^Neurology|Anatomy,5278^^Neurology|Anatomy,5371^^Neurology|Anatomy,5276^^Neurology|Anatomy,5272^^Neurology|Anatomy,4969^^Neurology|Anatomy,5269^^Neurology|Anatomy,5265^^Neurology|Anatomy,5263^^Neurology|Anatomy,5260^^Neurology|Anatomy,",
          qidArray: [
            "5257",
            "5368",
            "5254",
            "5252",
            "5250",
            "5248",
            "5404",
            "5362",
            "5244",
            "5360",
            "5357",
            "5412",
            "5396",
            "5354",
            "5351",
            "5349",
            "5345",
            "5341",
            "5409",
            "5393",
            "5337",
            "5334",
            "5238",
            "5331",
            "5400",
            "5327",
            "5365",
            "5324",
            "5389",
            "5321",
            "5319",
            "5316",
            "5382",
            "5312",
            "5308",
            "5305",
            "5302",
            "5234",
            "5299",
            "5378",
            "5297",
            "5374",
            "5294",
            "5290",
            "5287",
            "5284",
            "5280",
            "5278",
            "5371",
            "5276",
            "5272",
            "4969",
            "5269",
            "5265",
            "5263",
            "5260"
          ],
          TotalQuestionsCount: 56,
          name: "Neurology-Anatomy(56)",
          qidsEncodedPatternString: "5257^^Neurology|Anatomy,5368^^Neurology|Anatomy,5254^^Neurology|Anatomy,5252^^Neurology|Anatomy,5250^^Neurology|Anatomy,5248^^Neurology|Anatomy,5404^^Neurology|Anatomy,5362^^Neurology|Anatomy,5244^^Neurology|Anatomy,5360^^Neurology|Anatomy,5357^^Neurology|Anatomy,5412^^Neurology|Anatomy,5396^^Neurology|Anatomy,5354^^Neurology|Anatomy,5351^^Neurology|Anatomy,5349^^Neurology|Anatomy,5345^^Neurology|Anatomy,5341^^Neurology|Anatomy,5409^^Neurology|Anatomy,5393^^Neurology|Anatomy,5337^^Neurology|Anatomy,5334^^Neurology|Anatomy,5238^^Neurology|Anatomy,5331^^Neurology|Anatomy,5400^^Neurology|Anatomy,5327^^Neurology|Anatomy,5365^^Neurology|Anatomy,5324^^Neurology|Anatomy,5389^^Neurology|Anatomy,5321^^Neurology|Anatomy,5319^^Neurology|Anatomy,5316^^Neurology|Anatomy,5382^^Neurology|Anatomy,5312^^Neurology|Anatomy,5308^^Neurology|Anatomy,5305^^Neurology|Anatomy,5302^^Neurology|Anatomy,5234^^Neurology|Anatomy,5299^^Neurology|Anatomy,5378^^Neurology|Anatomy,5297^^Neurology|Anatomy,5374^^Neurology|Anatomy,5294^^Neurology|Anatomy,5290^^Neurology|Anatomy,5287^^Neurology|Anatomy,5284^^Neurology|Anatomy,5280^^Neurology|Anatomy,5278^^Neurology|Anatomy,5371^^Neurology|Anatomy,5276^^Neurology|Anatomy,5272^^Neurology|Anatomy,4969^^Neurology|Anatomy,5269^^Neurology|Anatomy,5265^^Neurology|Anatomy,5263^^Neurology|Anatomy,5260^^Neurology|Anatomy,"
        },
        {
          id: "5430^^Neurology|Embryology,5428^^Neurology|Embryology,5426^^Neurology|Embryology,5423^^Neurology|Embryology,5421^^Neurology|Embryology,5417^^Neurology|Embryology,",
          qidArray: [
            "5430",
            "5428",
            "5426",
            "5423",
            "5421",
            "5417"
          ],
          TotalQuestionsCount: 6,
          name: "Neurology-Embryology(6)",
          qidsEncodedPatternString: "5430^^Neurology|Embryology,5428^^Neurology|Embryology,5426^^Neurology|Embryology,5423^^Neurology|Embryology,5421^^Neurology|Embryology,5417^^Neurology|Embryology,"
        },
        {
          id: "5587^^Neurology|Histology,5582^^Neurology|Histology,5576^^Neurology|Histology,",
          qidArray: [
            "5587",
            "5582",
            "5576"
          ],
          TotalQuestionsCount: 3,
          name: "Neurology-Histology(3)",
          qidsEncodedPatternString: "5587^^Neurology|Histology,5582^^Neurology|Histology,5576^^Neurology|Histology,"
        },
        {
          id: "6050^^Neurology|Pathology,6112^^Neurology|Pathology,6048^^Neurology|Pathology,6045^^Neurology|Pathology,6042^^Neurology|Pathology,6039^^Neurology|Pathology,6105^^Neurology|Pathology,6036^^Neurology|Pathology,6034^^Neurology|Pathology,6031^^Neurology|Pathology,6029^^Neurology|Pathology,6102^^Neurology|Pathology,6024^^Neurology|Pathology,6096^^Neurology|Pathology,6021^^Neurology|Pathology,6017^^Neurology|Pathology,6142^^Neurology|Pathology,6093^^Neurology|Pathology,6015^^Neurology|Pathology,6139^^Neurology|Pathology,6011^^Neurology|Pathology,6007^^Neurology|Pathology,6137^^Neurology|Pathology,6005^^Neurology|Pathology,6134^^Neurology|Pathology,6003^^Neurology|Pathology,6090^^Neurology|Pathology,5999^^Neurology|Pathology,6132^^Neurology|Pathology,6087^^Neurology|Pathology,5997^^Neurology|Pathology,5995^^Neurology|Pathology,6084^^Neurology|Pathology,5993^^Neurology|Pathology,5990^^Neurology|Pathology,6081^^Neurology|Pathology,5987^^Neurology|Pathology,6079^^Neurology|Pathology,5984^^Neurology|Pathology,6130^^Neurology|Pathology,5981^^Neurology|Pathology,6128^^Neurology|Pathology,6076^^Neurology|Pathology,5976^^Neurology|Pathology,5973^^Neurology|Pathology,6126^^Neurology|Pathology,6074^^Neurology|Pathology,5969^^Neurology|Pathology,6072^^Neurology|Pathology,5830^^Neurology|Pathology,5828^^Neurology|Pathology,5823^^Neurology|Pathology,5819^^Neurology|Pathology,5816^^Neurology|Pathology,5809^^Neurology|Pathology,6184^^Neurology|Pathology,6181^^Neurology|Pathology,6179^^Neurology|Pathology,6177^^Neurology|Pathology,6174^^Neurology|Pathology,6171^^Neurology|Pathology,5802^^Neurology|Pathology,6165^^Neurology|Pathology,6163^^Neurology|Pathology,6161^^Neurology|Pathology,6109^^Neurology|Pathology,6122^^Neurology|Pathology,6118^^Neurology|Pathology,6115^^Neurology|Pathology,5800^^Neurology|Pathology,6069^^Neurology|Pathology,6067^^Neurology|Pathology,6065^^Neurology|Pathology,6063^^Neurology|Pathology,6060^^Neurology|Pathology,6057^^Neurology|Pathology,6054^^Neurology|Pathology,5967^^Neurology|Pathology,5965^^Neurology|Pathology,5960^^Neurology|Pathology,5957^^Neurology|Pathology,5954^^Neurology|Pathology,5869^^Neurology|Pathology,5797^^Neurology|Pathology,5867^^Neurology|Pathology,5863^^Neurology|Pathology,5849^^Neurology|Pathology,5835^^Neurology|Pathology,",
          qidArray: [
            "6050",
            "6112",
            "6048",
            "6045",
            "6042",
            "6039",
            "6105",
            "6036",
            "6034",
            "6031",
            "6029",
            "6102",
            "6024",
            "6096",
            "6021",
            "6017",
            "6142",
            "6093",
            "6015",
            "6139",
            "6011",
            "6007",
            "6137",
            "6005",
            "6134",
            "6003",
            "6090",
            "5999",
            "6132",
            "6087",
            "5997",
            "5995",
            "6084",
            "5993",
            "5990",
            "6081",
            "5987",
            "6079",
            "5984",
            "6130",
            "5981",
            "6128",
            "6076",
            "5976",
            "5973",
            "6126",
            "6074",
            "5969",
            "6072",
            "5830",
            "5828",
            "5823",
            "5819",
            "5816",
            "5809",
            "6184",
            "6181",
            "6179",
            "6177",
            "6174",
            "6171",
            "5802",
            "6165",
            "6163",
            "6161",
            "6109",
            "6122",
            "6118",
            "6115",
            "5800",
            "6069",
            "6067",
            "6065",
            "6063",
            "6060",
            "6057",
            "6054",
            "5967",
            "5965",
            "5960",
            "5957",
            "5954",
            "5869",
            "5797",
            "5867",
            "5863",
            "5849",
            "5835"
          ],
          TotalQuestionsCount: 88,
          name: "Neurology-Pathology(88)",
          qidsEncodedPatternString: "6050^^Neurology|Pathology,6112^^Neurology|Pathology,6048^^Neurology|Pathology,6045^^Neurology|Pathology,6042^^Neurology|Pathology,6039^^Neurology|Pathology,6105^^Neurology|Pathology,6036^^Neurology|Pathology,6034^^Neurology|Pathology,6031^^Neurology|Pathology,6029^^Neurology|Pathology,6102^^Neurology|Pathology,6024^^Neurology|Pathology,6096^^Neurology|Pathology,6021^^Neurology|Pathology,6017^^Neurology|Pathology,6142^^Neurology|Pathology,6093^^Neurology|Pathology,6015^^Neurology|Pathology,6139^^Neurology|Pathology,6011^^Neurology|Pathology,6007^^Neurology|Pathology,6137^^Neurology|Pathology,6005^^Neurology|Pathology,6134^^Neurology|Pathology,6003^^Neurology|Pathology,6090^^Neurology|Pathology,5999^^Neurology|Pathology,6132^^Neurology|Pathology,6087^^Neurology|Pathology,5997^^Neurology|Pathology,5995^^Neurology|Pathology,6084^^Neurology|Pathology,5993^^Neurology|Pathology,5990^^Neurology|Pathology,6081^^Neurology|Pathology,5987^^Neurology|Pathology,6079^^Neurology|Pathology,5984^^Neurology|Pathology,6130^^Neurology|Pathology,5981^^Neurology|Pathology,6128^^Neurology|Pathology,6076^^Neurology|Pathology,5976^^Neurology|Pathology,5973^^Neurology|Pathology,6126^^Neurology|Pathology,6074^^Neurology|Pathology,5969^^Neurology|Pathology,6072^^Neurology|Pathology,5830^^Neurology|Pathology,5828^^Neurology|Pathology,5823^^Neurology|Pathology,5819^^Neurology|Pathology,5816^^Neurology|Pathology,5809^^Neurology|Pathology,6184^^Neurology|Pathology,6181^^Neurology|Pathology,6179^^Neurology|Pathology,6177^^Neurology|Pathology,6174^^Neurology|Pathology,6171^^Neurology|Pathology,5802^^Neurology|Pathology,6165^^Neurology|Pathology,6163^^Neurology|Pathology,6161^^Neurology|Pathology,6109^^Neurology|Pathology,6122^^Neurology|Pathology,6118^^Neurology|Pathology,6115^^Neurology|Pathology,5800^^Neurology|Pathology,6069^^Neurology|Pathology,6067^^Neurology|Pathology,6065^^Neurology|Pathology,6063^^Neurology|Pathology,6060^^Neurology|Pathology,6057^^Neurology|Pathology,6054^^Neurology|Pathology,5967^^Neurology|Pathology,5965^^Neurology|Pathology,5960^^Neurology|Pathology,5957^^Neurology|Pathology,5954^^Neurology|Pathology,5869^^Neurology|Pathology,5797^^Neurology|Pathology,5867^^Neurology|Pathology,5863^^Neurology|Pathology,5849^^Neurology|Pathology,5835^^Neurology|Pathology,"
        },
        {
          id: "6389^^Neurology|Pathophysiology,6395^^Neurology|Pathophysiology,6392^^Neurology|Pathophysiology,6387^^Neurology|Pathophysiology,6383^^Neurology|Pathophysiology,6378^^Neurology|Pathophysiology,6371^^Neurology|Pathophysiology,",
          qidArray: [
            "6389",
            "6395",
            "6392",
            "6387",
            "6383",
            "6378",
            "6371"
          ],
          TotalQuestionsCount: 7,
          name: "Neurology-Pathophysiology(7)",
          qidsEncodedPatternString: "6389^^Neurology|Pathophysiology,6395^^Neurology|Pathophysiology,6392^^Neurology|Pathophysiology,6387^^Neurology|Pathophysiology,6383^^Neurology|Pathophysiology,6378^^Neurology|Pathophysiology,6371^^Neurology|Pathophysiology,"
        },
        {
          id: "6426^^Neurology|Pharmacology,6423^^Neurology|Pharmacology,6420^^Neurology|Pharmacology,6417^^Neurology|Pharmacology,6545^^Neurology|Pharmacology,6415^^Neurology|Pharmacology,6543^^Neurology|Pharmacology,6643^^Neurology|Pharmacology,6641^^Neurology|Pharmacology,6540^^Neurology|Pharmacology,6638^^Neurology|Pharmacology,6535^^Neurology|Pharmacology,6532^^Neurology|Pharmacology,6529^^Neurology|Pharmacology,6526^^Neurology|Pharmacology,6522^^Neurology|Pharmacology,6619^^Neurology|Pharmacology,6517^^Neurology|Pharmacology,6617^^Neurology|Pharmacology,6514^^Neurology|Pharmacology,6615^^Neurology|Pharmacology,6510^^Neurology|Pharmacology,6413^^Neurology|Pharmacology,6636^^Neurology|Pharmacology,6633^^Neurology|Pharmacology,6612^^Neurology|Pharmacology,6507^^Neurology|Pharmacology,6630^^Neurology|Pharmacology,6503^^Neurology|Pharmacology,6628^^Neurology|Pharmacology,6624^^Neurology|Pharmacology,6499^^Neurology|Pharmacology,6621^^Neurology|Pharmacology,6493^^Neurology|Pharmacology,6489^^Neurology|Pharmacology,6484^^Neurology|Pharmacology,6480^^Neurology|Pharmacology,6476^^Neurology|Pharmacology,6472^^Neurology|Pharmacology,6470^^Neurology|Pharmacology,6408^^Neurology|Pharmacology,6608^^Neurology|Pharmacology,6603^^Neurology|Pharmacology,6600^^Neurology|Pharmacology,6597^^Neurology|Pharmacology,6593^^Neurology|Pharmacology,6590^^Neurology|Pharmacology,6587^^Neurology|Pharmacology,6584^^Neurology|Pharmacology,6581^^Neurology|Pharmacology,6579^^Neurology|Pharmacology,6576^^Neurology|Pharmacology,6574^^Neurology|Pharmacology,6466^^Neurology|Pharmacology,6570^^Neurology|Pharmacology,6567^^Neurology|Pharmacology,6565^^Neurology|Pharmacology,6561^^Neurology|Pharmacology,6559^^Neurology|Pharmacology,6463^^Neurology|Pharmacology,6553^^Neurology|Pharmacology,6550^^Neurology|Pharmacology,6548^^Neurology|Pharmacology,6461^^Neurology|Pharmacology,6459^^Neurology|Pharmacology,6455^^Neurology|Pharmacology,6452^^Neurology|Pharmacology,6449^^Neurology|Pharmacology,6447^^Neurology|Pharmacology,6443^^Neurology|Pharmacology,6405^^Neurology|Pharmacology,6438^^Neurology|Pharmacology,6436^^Neurology|Pharmacology,6434^^Neurology|Pharmacology,6430^^Neurology|Pharmacology,",
          qidArray: [
            "6426",
            "6423",
            "6420",
            "6417",
            "6545",
            "6415",
            "6543",
            "6643",
            "6641",
            "6540",
            "6638",
            "6535",
            "6532",
            "6529",
            "6526",
            "6522",
            "6619",
            "6517",
            "6617",
            "6514",
            "6615",
            "6510",
            "6413",
            "6636",
            "6633",
            "6612",
            "6507",
            "6630",
            "6503",
            "6628",
            "6624",
            "6499",
            "6621",
            "6493",
            "6489",
            "6484",
            "6480",
            "6476",
            "6472",
            "6470",
            "6408",
            "6608",
            "6603",
            "6600",
            "6597",
            "6593",
            "6590",
            "6587",
            "6584",
            "6581",
            "6579",
            "6576",
            "6574",
            "6466",
            "6570",
            "6567",
            "6565",
            "6561",
            "6559",
            "6463",
            "6553",
            "6550",
            "6548",
            "6461",
            "6459",
            "6455",
            "6452",
            "6449",
            "6447",
            "6443",
            "6405",
            "6438",
            "6436",
            "6434",
            "6430"
          ],
          TotalQuestionsCount: 75,
          name: "Neurology-Pharmacology(75)",
          qidsEncodedPatternString: "6426^^Neurology|Pharmacology,6423^^Neurology|Pharmacology,6420^^Neurology|Pharmacology,6417^^Neurology|Pharmacology,6545^^Neurology|Pharmacology,6415^^Neurology|Pharmacology,6543^^Neurology|Pharmacology,6643^^Neurology|Pharmacology,6641^^Neurology|Pharmacology,6540^^Neurology|Pharmacology,6638^^Neurology|Pharmacology,6535^^Neurology|Pharmacology,6532^^Neurology|Pharmacology,6529^^Neurology|Pharmacology,6526^^Neurology|Pharmacology,6522^^Neurology|Pharmacology,6619^^Neurology|Pharmacology,6517^^Neurology|Pharmacology,6617^^Neurology|Pharmacology,6514^^Neurology|Pharmacology,6615^^Neurology|Pharmacology,6510^^Neurology|Pharmacology,6413^^Neurology|Pharmacology,6636^^Neurology|Pharmacology,6633^^Neurology|Pharmacology,6612^^Neurology|Pharmacology,6507^^Neurology|Pharmacology,6630^^Neurology|Pharmacology,6503^^Neurology|Pharmacology,6628^^Neurology|Pharmacology,6624^^Neurology|Pharmacology,6499^^Neurology|Pharmacology,6621^^Neurology|Pharmacology,6493^^Neurology|Pharmacology,6489^^Neurology|Pharmacology,6484^^Neurology|Pharmacology,6480^^Neurology|Pharmacology,6476^^Neurology|Pharmacology,6472^^Neurology|Pharmacology,6470^^Neurology|Pharmacology,6408^^Neurology|Pharmacology,6608^^Neurology|Pharmacology,6603^^Neurology|Pharmacology,6600^^Neurology|Pharmacology,6597^^Neurology|Pharmacology,6593^^Neurology|Pharmacology,6590^^Neurology|Pharmacology,6587^^Neurology|Pharmacology,6584^^Neurology|Pharmacology,6581^^Neurology|Pharmacology,6579^^Neurology|Pharmacology,6576^^Neurology|Pharmacology,6574^^Neurology|Pharmacology,6466^^Neurology|Pharmacology,6570^^Neurology|Pharmacology,6567^^Neurology|Pharmacology,6565^^Neurology|Pharmacology,6561^^Neurology|Pharmacology,6559^^Neurology|Pharmacology,6463^^Neurology|Pharmacology,6553^^Neurology|Pharmacology,6550^^Neurology|Pharmacology,6548^^Neurology|Pharmacology,6461^^Neurology|Pharmacology,6459^^Neurology|Pharmacology,6455^^Neurology|Pharmacology,6452^^Neurology|Pharmacology,6449^^Neurology|Pharmacology,6447^^Neurology|Pharmacology,6443^^Neurology|Pharmacology,6405^^Neurology|Pharmacology,6438^^Neurology|Pharmacology,6436^^Neurology|Pharmacology,6434^^Neurology|Pharmacology,6430^^Neurology|Pharmacology,"
        },
        {
          id: "6671^^Neurology|Physiology,6667^^Neurology|Physiology,6663^^Neurology|Physiology,6660^^Neurology|Physiology,6655^^Neurology|Physiology,6653^^Neurology|Physiology,6651^^Neurology|Physiology,6649^^Neurology|Physiology,6646^^Neurology|Physiology,6673^^Neurology|Physiology,",
          qidArray: [
            "6671",
            "6667",
            "6663",
            "6660",
            "6655",
            "6653",
            "6651",
            "6649",
            "6646",
            "6673"
          ],
          TotalQuestionsCount: 10,
          name: "Neurology-Physiology(10)",
          qidsEncodedPatternString: "6671^^Neurology|Physiology,6667^^Neurology|Physiology,6663^^Neurology|Physiology,6660^^Neurology|Physiology,6655^^Neurology|Physiology,6653^^Neurology|Physiology,6651^^Neurology|Physiology,6649^^Neurology|Physiology,6646^^Neurology|Physiology,6673^^Neurology|Physiology,"
        }
      ],
      id: 48381,
      isParent: true,
      TotalQuestionsCount: 245,
      name: "Neurology"
    },
    {
      children: [
        {
          id: "6686^^Oncology|Anatomy,",
          qidArray: [
            "6686"
          ],
          TotalQuestionsCount: 1,
          name: "Oncology-Anatomy(1)",
          qidsEncodedPatternString: "6686^^Oncology|Anatomy,"
        },
        {
          id: "6726^^Oncology|Pathology,6721^^Oncology|Pathology,6719^^Oncology|Pathology,6714^^Oncology|Pathology,6712^^Oncology|Pathology,6705^^Oncology|Pathology,6789^^Oncology|Pathology,6701^^Oncology|Pathology,6786^^Oncology|Pathology,6784^^Oncology|Pathology,6778^^Oncology|Pathology,6776^^Oncology|Pathology,6772^^Oncology|Pathology,6770^^Oncology|Pathology,6768^^Oncology|Pathology,6766^^Oncology|Pathology,6762^^Oncology|Pathology,6760^^Oncology|Pathology,6699^^Oncology|Pathology,6758^^Oncology|Pathology,6756^^Oncology|Pathology,6753^^Oncology|Pathology,6751^^Oncology|Pathology,6748^^Oncology|Pathology,6746^^Oncology|Pathology,6744^^Oncology|Pathology,6742^^Oncology|Pathology,6739^^Oncology|Pathology,6692^^Oncology|Pathology,6736^^Oncology|Pathology,6734^^Oncology|Pathology,6731^^Oncology|Pathology,6729^^Oncology|Pathology,",
          qidArray: [
            "6726",
            "6721",
            "6719",
            "6714",
            "6712",
            "6705",
            "6789",
            "6701",
            "6786",
            "6784",
            "6778",
            "6776",
            "6772",
            "6770",
            "6768",
            "6766",
            "6762",
            "6760",
            "6699",
            "6758",
            "6756",
            "6753",
            "6751",
            "6748",
            "6746",
            "6744",
            "6742",
            "6739",
            "6692",
            "6736",
            "6734",
            "6731",
            "6729"
          ],
          TotalQuestionsCount: 33,
          name: "Oncology-Pathology(33)",
          qidsEncodedPatternString: "6726^^Oncology|Pathology,6721^^Oncology|Pathology,6719^^Oncology|Pathology,6714^^Oncology|Pathology,6712^^Oncology|Pathology,6705^^Oncology|Pathology,6789^^Oncology|Pathology,6701^^Oncology|Pathology,6786^^Oncology|Pathology,6784^^Oncology|Pathology,6778^^Oncology|Pathology,6776^^Oncology|Pathology,6772^^Oncology|Pathology,6770^^Oncology|Pathology,6768^^Oncology|Pathology,6766^^Oncology|Pathology,6762^^Oncology|Pathology,6760^^Oncology|Pathology,6699^^Oncology|Pathology,6758^^Oncology|Pathology,6756^^Oncology|Pathology,6753^^Oncology|Pathology,6751^^Oncology|Pathology,6748^^Oncology|Pathology,6746^^Oncology|Pathology,6744^^Oncology|Pathology,6742^^Oncology|Pathology,6739^^Oncology|Pathology,6692^^Oncology|Pathology,6736^^Oncology|Pathology,6734^^Oncology|Pathology,6731^^Oncology|Pathology,6729^^Oncology|Pathology,"
        },
        {
          id: "6819^^Oncology|Pharmacology,6816^^Oncology|Pharmacology,6812^^Oncology|Pharmacology,6809^^Oncology|Pharmacology,6807^^Oncology|Pharmacology,6805^^Oncology|Pharmacology,6799^^Oncology|Pharmacology,6797^^Oncology|Pharmacology,6835^^Oncology|Pharmacology,6833^^Oncology|Pharmacology,6830^^Oncology|Pharmacology,6794^^Oncology|Pharmacology,6826^^Oncology|Pharmacology,6823^^Oncology|Pharmacology,",
          qidArray: [
            "6819",
            "6816",
            "6812",
            "6809",
            "6807",
            "6805",
            "6799",
            "6797",
            "6835",
            "6833",
            "6830",
            "6794",
            "6826",
            "6823"
          ],
          TotalQuestionsCount: 14,
          name: "Oncology-Pharmacology(14)",
          qidsEncodedPatternString: "6819^^Oncology|Pharmacology,6816^^Oncology|Pharmacology,6812^^Oncology|Pharmacology,6809^^Oncology|Pharmacology,6807^^Oncology|Pharmacology,6805^^Oncology|Pharmacology,6799^^Oncology|Pharmacology,6797^^Oncology|Pharmacology,6835^^Oncology|Pharmacology,6833^^Oncology|Pharmacology,6830^^Oncology|Pharmacology,6794^^Oncology|Pharmacology,6826^^Oncology|Pharmacology,6823^^Oncology|Pharmacology,"
        }
      ],
      id: 80760,
      isParent: true,
      TotalQuestionsCount: 48,
      name: "Oncology"
    },
    {
      children: [
        {
          id: "5584^^Reproductive|Anatomy,5578^^Reproductive|Anatomy,5569^^Reproductive|Anatomy,5564^^Reproductive|Anatomy,5554^^Reproductive|Anatomy,5547^^Reproductive|Anatomy,5545^^Reproductive|Anatomy,5542^^Reproductive|Anatomy,5602^^Reproductive|Anatomy,5540^^Reproductive|Anatomy,5596^^Reproductive|Anatomy,",
          qidArray: [
            "5584",
            "5578",
            "5569",
            "5564",
            "5554",
            "5547",
            "5545",
            "5542",
            "5602",
            "5540",
            "5596"
          ],
          TotalQuestionsCount: 11,
          name: "Reproductive-Anatomy(11)",
          qidsEncodedPatternString: "5584^^Reproductive|Anatomy,5578^^Reproductive|Anatomy,5569^^Reproductive|Anatomy,5564^^Reproductive|Anatomy,5554^^Reproductive|Anatomy,5547^^Reproductive|Anatomy,5545^^Reproductive|Anatomy,5542^^Reproductive|Anatomy,5602^^Reproductive|Anatomy,5540^^Reproductive|Anatomy,5596^^Reproductive|Anatomy,"
        },
        {
          id: "5625^^Reproductive|Embryology,5623^^Reproductive|Embryology,5620^^Reproductive|Embryology,5616^^Reproductive|Embryology,5608^^Reproductive|Embryology,",
          qidArray: [
            "5625",
            "5623",
            "5620",
            "5616",
            "5608"
          ],
          TotalQuestionsCount: 5,
          name: "Reproductive-Embryology(5)",
          qidsEncodedPatternString: "5625^^Reproductive|Embryology,5623^^Reproductive|Embryology,5620^^Reproductive|Embryology,5616^^Reproductive|Embryology,5608^^Reproductive|Embryology,"
        },
        {
          id: "5639^^Reproductive|Histology,5636^^Reproductive|Histology,5631^^Reproductive|Histology,5628^^Reproductive|Histology,",
          qidArray: [
            "5639",
            "5636",
            "5631",
            "5628"
          ],
          TotalQuestionsCount: 4,
          name: "Reproductive-Histology(4)",
          qidsEncodedPatternString: "5639^^Reproductive|Histology,5636^^Reproductive|Histology,5631^^Reproductive|Histology,5628^^Reproductive|Histology,"
        },
        {
          id: "5740^^Reproductive|Pathology,5737^^Reproductive|Pathology,5733^^Reproductive|Pathology,5730^^Reproductive|Pathology,5728^^Reproductive|Pathology,5725^^Reproductive|Pathology,5722^^Reproductive|Pathology,5783^^Reproductive|Pathology,5781^^Reproductive|Pathology,5778^^Reproductive|Pathology,5774^^Reproductive|Pathology,5769^^Reproductive|Pathology,5762^^Reproductive|Pathology,5758^^Reproductive|Pathology,5754^^Reproductive|Pathology,5719^^Reproductive|Pathology,5748^^Reproductive|Pathology,5743^^Reproductive|Pathology,",
          qidArray: [
            "5740",
            "5737",
            "5733",
            "5730",
            "5728",
            "5725",
            "5722",
            "5783",
            "5781",
            "5778",
            "5774",
            "5769",
            "5762",
            "5758",
            "5754",
            "5719",
            "5748",
            "5743"
          ],
          TotalQuestionsCount: 18,
          name: "Reproductive-Pathology(18)",
          qidsEncodedPatternString: "5740^^Reproductive|Pathology,5737^^Reproductive|Pathology,5733^^Reproductive|Pathology,5730^^Reproductive|Pathology,5728^^Reproductive|Pathology,5725^^Reproductive|Pathology,5722^^Reproductive|Pathology,5783^^Reproductive|Pathology,5781^^Reproductive|Pathology,5778^^Reproductive|Pathology,5774^^Reproductive|Pathology,5769^^Reproductive|Pathology,5762^^Reproductive|Pathology,5758^^Reproductive|Pathology,5754^^Reproductive|Pathology,5719^^Reproductive|Pathology,5748^^Reproductive|Pathology,5743^^Reproductive|Pathology,"
        },
        {
          id: "5672^^Reproductive|Pharmacology,5669^^Reproductive|Pharmacology,5661^^Reproductive|Pharmacology,5655^^Reproductive|Pharmacology,5650^^Reproductive|Pharmacology,",
          qidArray: [
            "5672",
            "5669",
            "5661",
            "5655",
            "5650"
          ],
          TotalQuestionsCount: 5,
          name: "Reproductive-Pharmacology(5)",
          qidsEncodedPatternString: "5672^^Reproductive|Pharmacology,5669^^Reproductive|Pharmacology,5661^^Reproductive|Pharmacology,5655^^Reproductive|Pharmacology,5650^^Reproductive|Pharmacology,"
        },
        {
          id: "5715^^Reproductive|Physiology,5712^^Reproductive|Physiology,5708^^Reproductive|Physiology,5704^^Reproductive|Physiology,5694^^Reproductive|Physiology,5688^^Reproductive|Physiology,5683^^Reproductive|Physiology,",
          qidArray: [
            "5715",
            "5712",
            "5708",
            "5704",
            "5694",
            "5688",
            "5683"
          ],
          TotalQuestionsCount: 7,
          name: "Reproductive-Physiology(7)",
          qidsEncodedPatternString: "5715^^Reproductive|Physiology,5712^^Reproductive|Physiology,5708^^Reproductive|Physiology,5704^^Reproductive|Physiology,5694^^Reproductive|Physiology,5688^^Reproductive|Physiology,5683^^Reproductive|Physiology,"
        }
      ],
      id: 18947,
      isParent: true,
      TotalQuestionsCount: 50,
      name: "Reproductive"
    },
    {
      children: [
        {
          id: "5529^^Respiratory|Anatomy,5526^^Respiratory|Anatomy,5446^^Respiratory|Anatomy,5442^^Respiratory|Anatomy,5439^^Respiratory|Anatomy,5433^^Respiratory|Anatomy,5401^^Respiratory|Anatomy,5387^^Respiratory|Anatomy,5380^^Respiratory|Anatomy,5539^^Respiratory|Anatomy,",
          qidArray: [
            "5529",
            "5526",
            "5446",
            "5442",
            "5439",
            "5433",
            "5401",
            "5387",
            "5380",
            "5539"
          ],
          TotalQuestionsCount: 10,
          name: "Respiratory-Anatomy(10)",
          qidsEncodedPatternString: "5529^^Respiratory|Anatomy,5526^^Respiratory|Anatomy,5446^^Respiratory|Anatomy,5442^^Respiratory|Anatomy,5439^^Respiratory|Anatomy,5433^^Respiratory|Anatomy,5401^^Respiratory|Anatomy,5387^^Respiratory|Anatomy,5380^^Respiratory|Anatomy,5539^^Respiratory|Anatomy,"
        },
        {
          id: "6201^^Respiratory|Pathophysiology,6197^^Respiratory|Pathophysiology,6192^^Respiratory|Pathophysiology,5950^^Respiratory|Pathophysiology,5948^^Respiratory|Pathophysiology,5945^^Respiratory|Pathophysiology,5941^^Respiratory|Pathophysiology,5937^^Respiratory|Pathophysiology,5934^^Respiratory|Pathophysiology,5930^^Respiratory|Pathophysiology,5927^^Respiratory|Pathophysiology,5921^^Respiratory|Pathophysiology,5919^^Respiratory|Pathophysiology,5916^^Respiratory|Pathophysiology,5912^^Respiratory|Pathophysiology,5910^^Respiratory|Pathophysiology,5906^^Respiratory|Pathophysiology,5903^^Respiratory|Pathophysiology,",
          qidArray: [
            "6201",
            "6197",
            "6192",
            "5950",
            "5948",
            "5945",
            "5941",
            "5937",
            "5934",
            "5930",
            "5927",
            "5921",
            "5919",
            "5916",
            "5912",
            "5910",
            "5906",
            "5903"
          ],
          TotalQuestionsCount: 18,
          name: "Respiratory-Pathophysiology(18)",
          qidsEncodedPatternString: "6201^^Respiratory|Pathophysiology,6197^^Respiratory|Pathophysiology,6192^^Respiratory|Pathophysiology,5950^^Respiratory|Pathophysiology,5948^^Respiratory|Pathophysiology,5945^^Respiratory|Pathophysiology,5941^^Respiratory|Pathophysiology,5937^^Respiratory|Pathophysiology,5934^^Respiratory|Pathophysiology,5930^^Respiratory|Pathophysiology,5927^^Respiratory|Pathophysiology,5921^^Respiratory|Pathophysiology,5919^^Respiratory|Pathophysiology,5916^^Respiratory|Pathophysiology,5912^^Respiratory|Pathophysiology,5910^^Respiratory|Pathophysiology,5906^^Respiratory|Pathophysiology,5903^^Respiratory|Pathophysiology,"
        },
        {
          id: "5588^^Respiratory|Embryology,5574^^Respiratory|Embryology,5566^^Respiratory|Embryology,",
          qidArray: [
            "5588",
            "5574",
            "5566"
          ],
          TotalQuestionsCount: 3,
          name: "Respiratory-Embryology(3)",
          qidsEncodedPatternString: "5588^^Respiratory|Embryology,5574^^Respiratory|Embryology,5566^^Respiratory|Embryology,"
        },
        {
          id: "6431^^Respiratory|Pharmacology,6358^^Respiratory|Pharmacology,6342^^Respiratory|Pharmacology,6307^^Respiratory|Pharmacology,6296^^Respiratory|Pharmacology,6219^^Respiratory|Pharmacology,6216^^Respiratory|Pharmacology,6213^^Respiratory|Pharmacology,6538^^Respiratory|Pharmacology,6533^^Respiratory|Pharmacology,6527^^Respiratory|Pharmacology,6519^^Respiratory|Pharmacology,6515^^Respiratory|Pharmacology,6500^^Respiratory|Pharmacology,6490^^Respiratory|Pharmacology,6481^^Respiratory|Pharmacology,6473^^Respiratory|Pharmacology,6464^^Respiratory|Pharmacology,6210^^Respiratory|Pharmacology,6450^^Respiratory|Pharmacology,6442^^Respiratory|Pharmacology,",
          qidArray: [
            "6431",
            "6358",
            "6342",
            "6307",
            "6296",
            "6219",
            "6216",
            "6213",
            "6538",
            "6533",
            "6527",
            "6519",
            "6515",
            "6500",
            "6490",
            "6481",
            "6473",
            "6464",
            "6210",
            "6450",
            "6442"
          ],
          TotalQuestionsCount: 21,
          name: "Respiratory-Pharmacology(21)",
          qidsEncodedPatternString: "6431^^Respiratory|Pharmacology,6358^^Respiratory|Pharmacology,6342^^Respiratory|Pharmacology,6307^^Respiratory|Pharmacology,6296^^Respiratory|Pharmacology,6219^^Respiratory|Pharmacology,6216^^Respiratory|Pharmacology,6213^^Respiratory|Pharmacology,6538^^Respiratory|Pharmacology,6533^^Respiratory|Pharmacology,6527^^Respiratory|Pharmacology,6519^^Respiratory|Pharmacology,6515^^Respiratory|Pharmacology,6500^^Respiratory|Pharmacology,6490^^Respiratory|Pharmacology,6481^^Respiratory|Pharmacology,6473^^Respiratory|Pharmacology,6464^^Respiratory|Pharmacology,6210^^Respiratory|Pharmacology,6450^^Respiratory|Pharmacology,6442^^Respiratory|Pharmacology,"
        },
        {
          id: "5615^^Respiratory|Histology,5610^^Respiratory|Histology,5604^^Respiratory|Histology,5598^^Respiratory|Histology,5595^^Respiratory|Histology,",
          qidArray: [
            "5615",
            "5610",
            "5604",
            "5598",
            "5595"
          ],
          TotalQuestionsCount: 5,
          name: "Respiratory-Histology(5)",
          qidsEncodedPatternString: "5615^^Respiratory|Histology,5610^^Respiratory|Histology,5604^^Respiratory|Histology,5598^^Respiratory|Histology,5595^^Respiratory|Histology,"
        },
        {
          id: "6690^^Respiratory|Physiology,6685^^Respiratory|Physiology,6683^^Respiratory|Physiology,6677^^Respiratory|Physiology,6669^^Respiratory|Physiology,6613^^Respiratory|Physiology,6605^^Respiratory|Physiology,7161^^Respiratory|Physiology,7157^^Respiratory|Physiology,7154^^Respiratory|Physiology,7152^^Respiratory|Physiology,7150^^Respiratory|Physiology,7130^^Respiratory|Physiology,7123^^Respiratory|Physiology,7109^^Respiratory|Physiology,7100^^Respiratory|Physiology,6598^^Respiratory|Physiology,7093^^Respiratory|Physiology,7079^^Respiratory|Physiology,7044^^Respiratory|Physiology,6968^^Respiratory|Physiology,6924^^Respiratory|Physiology,6897^^Respiratory|Physiology,6884^^Respiratory|Physiology,6873^^Respiratory|Physiology,6865^^Respiratory|Physiology,6855^^Respiratory|Physiology,6556^^Respiratory|Physiology,6737^^Respiratory|Physiology,6727^^Respiratory|Physiology,6696^^Respiratory|Physiology,",
          qidArray: [
            "6690",
            "6685",
            "6683",
            "6677",
            "6669",
            "6613",
            "6605",
            "7161",
            "7157",
            "7154",
            "7152",
            "7150",
            "7130",
            "7123",
            "7109",
            "7100",
            "6598",
            "7093",
            "7079",
            "7044",
            "6968",
            "6924",
            "6897",
            "6884",
            "6873",
            "6865",
            "6855",
            "6556",
            "6737",
            "6727",
            "6696"
          ],
          TotalQuestionsCount: 31,
          name: "Respiratory-Physiology(31)",
          qidsEncodedPatternString: "6690^^Respiratory|Physiology,6685^^Respiratory|Physiology,6683^^Respiratory|Physiology,6677^^Respiratory|Physiology,6669^^Respiratory|Physiology,6613^^Respiratory|Physiology,6605^^Respiratory|Physiology,7161^^Respiratory|Physiology,7157^^Respiratory|Physiology,7154^^Respiratory|Physiology,7152^^Respiratory|Physiology,7150^^Respiratory|Physiology,7130^^Respiratory|Physiology,7123^^Respiratory|Physiology,7109^^Respiratory|Physiology,7100^^Respiratory|Physiology,6598^^Respiratory|Physiology,7093^^Respiratory|Physiology,7079^^Respiratory|Physiology,7044^^Respiratory|Physiology,6968^^Respiratory|Physiology,6924^^Respiratory|Physiology,6897^^Respiratory|Physiology,6884^^Respiratory|Physiology,6873^^Respiratory|Physiology,6865^^Respiratory|Physiology,6855^^Respiratory|Physiology,6556^^Respiratory|Physiology,6737^^Respiratory|Physiology,6727^^Respiratory|Physiology,6696^^Respiratory|Physiology,"
        },
        {
          id: "5901^^Respiratory|Pathology,5897^^Respiratory|Pathology,5893^^Respiratory|Pathology,5891^^Respiratory|Pathology,5888^^Respiratory|Pathology,5884^^Respiratory|Pathology,5882^^Respiratory|Pathology,5880^^Respiratory|Pathology,5878^^Respiratory|Pathology,5876^^Respiratory|Pathology,5874^^Respiratory|Pathology,5861^^Respiratory|Pathology,5858^^Respiratory|Pathology,5855^^Respiratory|Pathology,5851^^Respiratory|Pathology,5846^^Respiratory|Pathology,5844^^Respiratory|Pathology,5842^^Respiratory|Pathology,5837^^Respiratory|Pathology,5832^^Respiratory|Pathology,5825^^Respiratory|Pathology,5817^^Respiratory|Pathology,5807^^Respiratory|Pathology,5805^^Respiratory|Pathology,5793^^Respiratory|Pathology,5791^^Respiratory|Pathology,5785^^Respiratory|Pathology,5775^^Respiratory|Pathology,5770^^Respiratory|Pathology,5765^^Respiratory|Pathology,5763^^Respiratory|Pathology,5759^^Respiratory|Pathology,6208^^Respiratory|Pathology,5753^^Respiratory|Pathology,6205^^Respiratory|Pathology,6203^^Respiratory|Pathology,5746^^Respiratory|Pathology,5700^^Respiratory|Pathology,5697^^Respiratory|Pathology,5691^^Respiratory|Pathology,5686^^Respiratory|Pathology,5676^^Respiratory|Pathology,5668^^Respiratory|Pathology,5660^^Respiratory|Pathology,5653^^Respiratory|Pathology,5642^^Respiratory|Pathology,5633^^Respiratory|Pathology,",
          qidArray: [
            "5901",
            "5897",
            "5893",
            "5891",
            "5888",
            "5884",
            "5882",
            "5880",
            "5878",
            "5876",
            "5874",
            "5861",
            "5858",
            "5855",
            "5851",
            "5846",
            "5844",
            "5842",
            "5837",
            "5832",
            "5825",
            "5817",
            "5807",
            "5805",
            "5793",
            "5791",
            "5785",
            "5775",
            "5770",
            "5765",
            "5763",
            "5759",
            "6208",
            "5753",
            "6205",
            "6203",
            "5746",
            "5700",
            "5697",
            "5691",
            "5686",
            "5676",
            "5668",
            "5660",
            "5653",
            "5642",
            "5633"
          ],
          TotalQuestionsCount: 47,
          name: "Respiratory-Pathology(47)",
          qidsEncodedPatternString: "5901^^Respiratory|Pathology,5897^^Respiratory|Pathology,5893^^Respiratory|Pathology,5891^^Respiratory|Pathology,5888^^Respiratory|Pathology,5884^^Respiratory|Pathology,5882^^Respiratory|Pathology,5880^^Respiratory|Pathology,5878^^Respiratory|Pathology,5876^^Respiratory|Pathology,5874^^Respiratory|Pathology,5861^^Respiratory|Pathology,5858^^Respiratory|Pathology,5855^^Respiratory|Pathology,5851^^Respiratory|Pathology,5846^^Respiratory|Pathology,5844^^Respiratory|Pathology,5842^^Respiratory|Pathology,5837^^Respiratory|Pathology,5832^^Respiratory|Pathology,5825^^Respiratory|Pathology,5817^^Respiratory|Pathology,5807^^Respiratory|Pathology,5805^^Respiratory|Pathology,5793^^Respiratory|Pathology,5791^^Respiratory|Pathology,5785^^Respiratory|Pathology,5775^^Respiratory|Pathology,5770^^Respiratory|Pathology,5765^^Respiratory|Pathology,5763^^Respiratory|Pathology,5759^^Respiratory|Pathology,6208^^Respiratory|Pathology,5753^^Respiratory|Pathology,6205^^Respiratory|Pathology,6203^^Respiratory|Pathology,5746^^Respiratory|Pathology,5700^^Respiratory|Pathology,5697^^Respiratory|Pathology,5691^^Respiratory|Pathology,5686^^Respiratory|Pathology,5676^^Respiratory|Pathology,5668^^Respiratory|Pathology,5660^^Respiratory|Pathology,5653^^Respiratory|Pathology,5642^^Respiratory|Pathology,5633^^Respiratory|Pathology,"
        }
      ],
      id: 56410,
      isParent: true,
      TotalQuestionsCount: 135,
      name: "Respiratory"
    },
    {
      children: [
        {
          id: "4960^^Vascular|Anatomy,4958^^Vascular|Anatomy,4955^^Vascular|Anatomy,4952^^Vascular|Anatomy,4949^^Vascular|Anatomy,4946^^Vascular|Anatomy,4943^^Vascular|Anatomy,4940^^Vascular|Anatomy,4937^^Vascular|Anatomy,",
          qidArray: [
            "4960",
            "4958",
            "4955",
            "4952",
            "4949",
            "4946",
            "4943",
            "4940",
            "4937"
          ],
          TotalQuestionsCount: 9,
          name: "Vascular-Anatomy(9)",
          qidsEncodedPatternString: "4960^^Vascular|Anatomy,4958^^Vascular|Anatomy,4955^^Vascular|Anatomy,4952^^Vascular|Anatomy,4949^^Vascular|Anatomy,4946^^Vascular|Anatomy,4943^^Vascular|Anatomy,4940^^Vascular|Anatomy,4937^^Vascular|Anatomy,"
        },
        {
          id: "4966^^Vascular|Embryology,4963^^Vascular|Embryology,",
          qidArray: [
            "4966",
            "4963"
          ],
          TotalQuestionsCount: 2,
          name: "Vascular-Embryology(2)",
          qidsEncodedPatternString: "4966^^Vascular|Embryology,4963^^Vascular|Embryology,"
        },
        {
          id: "5118^^Vascular|Pharamacology,5115^^Vascular|Pharamacology,5111^^Vascular|Pharamacology,5109^^Vascular|Pharamacology,5108^^Vascular|Pharamacology,5102^^Vascular|Pharamacology,5100^^Vascular|Pharamacology,5207^^Vascular|Pharamacology,5096^^Vascular|Pharamacology,5204^^Vascular|Pharamacology,5202^^Vascular|Pharamacology,5198^^Vascular|Pharamacology,5195^^Vascular|Pharamacology,5191^^Vascular|Pharamacology,5185^^Vascular|Pharamacology,5182^^Vascular|Pharamacology,5180^^Vascular|Pharamacology,5178^^Vascular|Pharamacology,5176^^Vascular|Pharamacology,5093^^Vascular|Pharamacology,5173^^Vascular|Pharamacology,5171^^Vascular|Pharamacology,5168^^Vascular|Pharamacology,5166^^Vascular|Pharamacology,5145^^Vascular|Pharamacology,5143^^Vascular|Pharamacology,5141^^Vascular|Pharamacology,5138^^Vascular|Pharamacology,5133^^Vascular|Pharamacology,5130^^Vascular|Pharamacology,5090^^Vascular|Pharamacology,5126^^Vascular|Pharamacology,5123^^Vascular|Pharamacology,5120^^Vascular|Pharamacology,",
          qidArray: [
            "5118",
            "5115",
            "5111",
            "5109",
            "5108",
            "5102",
            "5100",
            "5207",
            "5096",
            "5204",
            "5202",
            "5198",
            "5195",
            "5191",
            "5185",
            "5182",
            "5180",
            "5178",
            "5176",
            "5093",
            "5173",
            "5171",
            "5168",
            "5166",
            "5145",
            "5143",
            "5141",
            "5138",
            "5133",
            "5130",
            "5090",
            "5126",
            "5123",
            "5120"
          ],
          TotalQuestionsCount: 34,
          name: "Vascular-Pharamacology(34)",
          qidsEncodedPatternString: "5118^^Vascular|Pharamacology,5115^^Vascular|Pharamacology,5111^^Vascular|Pharamacology,5109^^Vascular|Pharamacology,5108^^Vascular|Pharamacology,5102^^Vascular|Pharamacology,5100^^Vascular|Pharamacology,5207^^Vascular|Pharamacology,5096^^Vascular|Pharamacology,5204^^Vascular|Pharamacology,5202^^Vascular|Pharamacology,5198^^Vascular|Pharamacology,5195^^Vascular|Pharamacology,5191^^Vascular|Pharamacology,5185^^Vascular|Pharamacology,5182^^Vascular|Pharamacology,5180^^Vascular|Pharamacology,5178^^Vascular|Pharamacology,5176^^Vascular|Pharamacology,5093^^Vascular|Pharamacology,5173^^Vascular|Pharamacology,5171^^Vascular|Pharamacology,5168^^Vascular|Pharamacology,5166^^Vascular|Pharamacology,5145^^Vascular|Pharamacology,5143^^Vascular|Pharamacology,5141^^Vascular|Pharamacology,5138^^Vascular|Pharamacology,5133^^Vascular|Pharamacology,5130^^Vascular|Pharamacology,5090^^Vascular|Pharamacology,5126^^Vascular|Pharamacology,5123^^Vascular|Pharamacology,5120^^Vascular|Pharamacology,"
        },
        {
          id: "4991^^Vascular|Pathology,4989^^Vascular|Pathology,4986^^Vascular|Pathology,4984^^Vascular|Pathology,4982^^Vascular|Pathology,4980^^Vascular|Pathology,5060^^Vascular|Pathology,4978^^Vascular|Pathology,5057^^Vascular|Pathology,5052^^Vascular|Pathology,5049^^Vascular|Pathology,5047^^Vascular|Pathology,5043^^Vascular|Pathology,5041^^Vascular|Pathology,5037^^Vascular|Pathology,5035^^Vascular|Pathology,5032^^Vascular|Pathology,5029^^Vascular|Pathology,4974^^Vascular|Pathology,5027^^Vascular|Pathology,5023^^Vascular|Pathology,5020^^Vascular|Pathology,5015^^Vascular|Pathology,5013^^Vascular|Pathology,5011^^Vascular|Pathology,5009^^Vascular|Pathology,5005^^Vascular|Pathology,5003^^Vascular|Pathology,5001^^Vascular|Pathology,4972^^Vascular|Pathology,4999^^Vascular|Pathology,4996^^Vascular|Pathology,4993^^Vascular|Pathology,",
          qidArray: [
            "4991",
            "4989",
            "4986",
            "4984",
            "4982",
            "4980",
            "5060",
            "4978",
            "5057",
            "5052",
            "5049",
            "5047",
            "5043",
            "5041",
            "5037",
            "5035",
            "5032",
            "5029",
            "4974",
            "5027",
            "5023",
            "5020",
            "5015",
            "5013",
            "5011",
            "5009",
            "5005",
            "5003",
            "5001",
            "4972",
            "4999",
            "4996",
            "4993"
          ],
          TotalQuestionsCount: 33,
          name: "Vascular-Pathology(33)",
          qidsEncodedPatternString: "4991^^Vascular|Pathology,4989^^Vascular|Pathology,4986^^Vascular|Pathology,4984^^Vascular|Pathology,4982^^Vascular|Pathology,4980^^Vascular|Pathology,5060^^Vascular|Pathology,4978^^Vascular|Pathology,5057^^Vascular|Pathology,5052^^Vascular|Pathology,5049^^Vascular|Pathology,5047^^Vascular|Pathology,5043^^Vascular|Pathology,5041^^Vascular|Pathology,5037^^Vascular|Pathology,5035^^Vascular|Pathology,5032^^Vascular|Pathology,5029^^Vascular|Pathology,4974^^Vascular|Pathology,5027^^Vascular|Pathology,5023^^Vascular|Pathology,5020^^Vascular|Pathology,5015^^Vascular|Pathology,5013^^Vascular|Pathology,5011^^Vascular|Pathology,5009^^Vascular|Pathology,5005^^Vascular|Pathology,5003^^Vascular|Pathology,5001^^Vascular|Pathology,4972^^Vascular|Pathology,4999^^Vascular|Pathology,4996^^Vascular|Pathology,4993^^Vascular|Pathology,"
        },
        {
          id: "5085^^Vascular|Pathophysiology,5082^^Vascular|Pathophysiology,5078^^Vascular|Pathophysiology,5076^^Vascular|Pathophysiology,5074^^Vascular|Pathophysiology,5070^^Vascular|Pathophysiology,5067^^Vascular|Pathophysiology,5065^^Vascular|Pathophysiology,5063^^Vascular|Pathophysiology,5087^^Vascular|Pathophysiology,",
          qidArray: [
            "5085",
            "5082",
            "5078",
            "5076",
            "5074",
            "5070",
            "5067",
            "5065",
            "5063",
            "5087"
          ],
          TotalQuestionsCount: 10,
          name: "Vascular-Pathophysiology(10)",
          qidsEncodedPatternString: "5085^^Vascular|Pathophysiology,5082^^Vascular|Pathophysiology,5078^^Vascular|Pathophysiology,5076^^Vascular|Pathophysiology,5074^^Vascular|Pathophysiology,5070^^Vascular|Pathophysiology,5067^^Vascular|Pathophysiology,5065^^Vascular|Pathophysiology,5063^^Vascular|Pathophysiology,5087^^Vascular|Pathophysiology,"
        },
        {
          id: "5230^^Vascular|Physiology,5228^^Vascular|Physiology,5221^^Vascular|Physiology,5217^^Vascular|Physiology,5210^^Vascular|Physiology,",
          qidArray: [
            "5230",
            "5228",
            "5221",
            "5217",
            "5210"
          ],
          TotalQuestionsCount: 5,
          name: "Vascular-Physiology(5)",
          qidsEncodedPatternString: "5230^^Vascular|Physiology,5228^^Vascular|Physiology,5221^^Vascular|Physiology,5217^^Vascular|Physiology,5210^^Vascular|Physiology,"
        }
      ],
      id: 25350,
      isParent: true,
      TotalQuestionsCount: 93,
      name: "Vascular"
    }
  ]
}